import React, { useEffect, useState } from "react";
import HeadBar from "./headBar/HeadBar";
import PageHeader from "../pageheader/PageHeader";
import styles from "./UsagePolicy.module.css";

import patientWhite from "../../asset/image/menuPatientW.svg";
import patientGreen from "../../asset/image/menuPatientG.svg";
import doctorWhite from "../../asset/image/menuDoctorW.svg";
import doctorGreen from "../../asset/image/menuDoctorG.svg";
import labWhite from "../../asset/image/menuLabW.svg";
import labGreen from "../../asset/image/menuLabG.svg";
import { useLocation } from "react-router-dom";
import Footer from "./footer/Footer";
import Breadcrumb from "./breacrumb/breadcrumb";

const pathItems = [
  { name: "หน้าหลัก", url: "/" },
  { name: "ข้อกำหนดและนโยบายการใช้งาน", url: "/" },
];

export default function UsagePolicy() {
  const [value, setValue] = useState(0);
  const location = useLocation();
  const dataValue = location.state;

  return (
    <>
      <div className="global-page">
        <Breadcrumb pathItems={pathItems} />

        <PageHeader titlename={"ข้อกำหนดและนโยบายการใช้งาน"} />
        <div>
          <div className={styles.containerMenu}>
            <div
              onClick={() => {
                setValue(0);
              }}
            >
              <img
                src={value === 0 ? patientGreen : patientWhite}
                className="cursor-pointer"
                alt="รูปประชาชนเเละผู้ป่วย"
              />
            </div>
            <div
              onClick={() => {
                setValue(1);
              }}
            >
              <img
                src={value === 1 ? doctorGreen : doctorWhite}
                className="cursor-pointer"
                alt="รูปเเพทย์เเละเภสัชกร"
              />
            </div>
            <div
              onClick={() => {
                setValue(2);
              }}
            >
              <img
                src={value === 2 ? labGreen : labWhite}
                className="cursor-pointer"
                alt="รูปห้องปฏิบัติการ"
              />
            </div>
          </div>

          {value === 0 && <Patient data={dataValue} />}
          {value === 1 && <Doctor />}
          {value === 2 && <Laboratory />}
        </div>
      </div>
    </>
  );
}

export function Patient({ data, hideTabs }) {
  const [valueTab, setValueTab] = useState(0);
  useEffect(() => {
    if (data === "policy") {
      setValueTab(0);
    } else if (data === "requirements") {
      setValueTab(1);
    } else {
      setValueTab(0);
    }
  }, [data]);
  return (
    <>
      <div className={styles.containerTab} style={hideTabs ? { display: "none" } : {}}>
        <div
          onClick={() => {
            setValueTab(0);
          }}
          className={valueTab === 0 ? styles.tab : styles.tabN}
        >
          นโยบายความเป็นส่วนตัว
        </div>
        <div
          onClick={() => {
            setValueTab(1);
          }}
          className={valueTab === 1 ? styles.tab : styles.tabN}
        >
          ข้อกำหนดและเงื่อนไขการใช้บริการ
        </div>
      </div>
      <div className={styles.containerCard} style={hideTabs ? { height: "auto", border: "none", padding: 0 } : {}}>
        <div className={styles.scrollbar}>
          {valueTab === 0 ? (
            <div className={styles.card}>
              <div className={styles.title}>สำหรับประชาชน</div>
              <br />
              <div className={styles.detail}>
                <div>
                  ประกาศนโยบายความเป็นส่วนตัวฉบับนี้
                  มีเพื่อชี้แจงให้ประชาชนทราบถึงวัตถุประสงค์
                  และรายละเอียดของการเก็บรวบรวม เข้าถึง ใช้งาน จัดการ
                  และเปิดเผยข้อมูลส่วนบุคคลของประชาชน
                  จากการใช้บริการระบบแพลตฟอร์มดิจิทัล “ผูกพันธุ์”
                  และสิทธิตามกฎหมายของประชาชน ที่เกี่ยวข้องกับข้อมูลส่วนบุคคล
                </div>
                <br />
                <div>1. คำนิยาม</div>
                <div>
                  1.1 “ระบบแพลตฟอร์มดิจิทัล” หรือ “Digital Platform” ผูกพันธุ์
                  (ระบบฯ) หมายความว่า บริการดิจิทัลภาครัฐที่พัฒนา
                  หรือจัดหาและให้บริการ โดยกรมวิทยาศาสตร์การแพทย์
                  โดยมีวัตถุประสงค์ให้ประชาชน บุคลากรทางการแพทย์
                  สามารถเข้าถึงข้อมูลพันธุกรรม ได้แก่
                  ผลการตรวจทางเภสัชพันธุศาสตร์ เป็นต้น โดยระบบแพลตฟอร์มดิจิทัล
                  “ผูกพันธุ์” แบ่งการใช้งานออกเป็น 2 ระบบ ได้แก่
                </div>
                <div>
                  <span className={styles.dot}></span>“แอปพลิเคชัน” หรือ
                  “Application” ผูกพันธุ์ หมายความว่า แอปพลิเคชัน “ผูกพันธุ์”
                  ตลอดจนโปรแกรมคอมพิวเตอร์ ชุดคำสั่ง หรือแอปพลิเคชันอื่น ๆ
                  ที่ต้องใช้หรืออาจใช้ร่วมกัน
                  หรือเกี่ยวเนื่องกันกับแอปพลิเคชันดังกล่าว เพื่อการใช้บริการ
                  “ผูกพันธุ์” ไม่ว่าจะใช้งานผ่านโทรศัพท์มือถือ แท็บเล็ต เว็บ
                  หรือผ่านอุปกรณ์อื่นใดก็ตาม ทั้งนี้ ในกรณีที่ แอปพลิเคชัน
                  “ผูกพันธุ์”
                  เปลี่ยนชื่อเป็นอย่างอื่นหรือมีแอปพลิเคชันอื่นรวมอยู่ด้วย
                  ให้หมายความรวมถึงแอปพลิเคชันนั้นด้วย
                </div>
                <div>
                  <span className={styles.dot}></span>“เว็บไซต์” หรือ “website”
                  ผูกพันธุ์ หมายความว่า เว็บไซต์ “ผูกพันธุ์”
                  ตลอดจนหน้าเว็บเพจที่ทำขึ้นเพื่อนำเสนอข้อมูลต่าง ๆ
                  ผ่านทางคอมพิวเตอร์ และอินเทอร์เน็ต
                  โดยมีหลายหน้าที่เชื่อมโยงเข้ากับไฮเปอร์ลิงก์
                  เพื่อให้สามารถเปิดไปยังหน้าเพจต่าง ๆ และถูกจัดเก็บไว้ใน www.
                  (เวิลด์ไวด์เว็บ) โดยเว็บไซต์ผูกพันธุ์ หรือ
                  https://phukphan.dmsc.moph.go.th/ มีไว้เพื่อให้ประชาชน
                  บุคลากรทางการแพทย์ สามารถเข้าถึงข้อมูลพันธุกรรมได้
                  นอกจากนี้ยังให้เจ้าหน้าที่ห้องปฏิบัติการสามารถเปิดห้องปฏิบัติการของตนเองและสามารถรายงานผลการตรวจทางพันธุกรรมได้
                </div>
                <div>
                  1.2 “ข้อมูลส่วนบุคคล” หมายความว่า ข้อมูลส่วนตัว หรือ
                  ข้อมูลเกี่ยวกับผู้ใช้บริการ
                  ซึ่งทำให้สามารถระบุตัวตนของผู้ใช้บริการได้ไม่ว่าทางตรงหรือทางอ้อม
                  ซึ่งรวมถึงข้อมูลทั่วไปของผู้ใช้บริการ ข้อมูลที่ใช้ยืนยันตัวตน
                  ข้อมูลชีวมาตรหรือ biometrics (เช่น ลายนิ้วมือ ใบหน้า เป็นต้น)
                  ข้อมูลสุขภาพ และข้อมูลส่วนบุคคลอื่นใดเกี่ยวกับผู้ใช้บริการ
                  ตามกฎหมายว่าด้วยการคุ้มครองข้อมูลส่วนบุคคล ทั้งนี้
                  ไม่รวมถึงข้อมูลเกี่ยวกับผู้ใช้บริการ
                  ในกรณีที่ผู้ใช้บริการถึงแก่กรรม และไม่รวมถึงข้อมูลทางสถิติ
                  หรือข้อมูลที่ไม่สามารถระบุตัวบุคคลที่เป็นเจ้าของข้อมูลส่วนบุคคลได้
                  ซึ่งไม่ถือเป็นข้อมูลส่วนบุคคล
                  ตามกฎหมายว่าด้วยการคุ้มครองข้อมูลส่วนบุคคล
                </div>
                <div>
                  1.3 “ข้อมูลสุขภาพ” หมายความว่า
                  ข้อมูลส่วนบุคคลของผู้ใช้บริการที่มีเนื้อหาเกี่ยวกับสุขภาพ
                  ได้แก่ ข้อมูลการแพ้ยา ข้อมูลโรควินิจฉัย ข้อมูลการจ่ายยา
                  ข้อมูลวัคซีน ข้อมูลหัตถการ ข้อมูลค่าผลตรวจ ทางการแพทย์
                  ข้อมูลผลตรวจห้องปฏิบัติและผลสรุปภาพถ่ายทางการแพทย์
                  ข้อมูลสุขภาพละเอียดอ่อน เช่น ข้อมูลพันธุกรรม เป็นต้น
                  และข้อมูลการเข้ารับบริการการรักษาพยาบาล
                  รวมไปถึงข้อมูลสุขภาพอื่น ๆ ที่อาจมีเพิ่มเติมในอนาคต
                </div>
                <div>
                  1.4 “ผู้ใช้บริการ” หมายความว่า ผู้ใช้งาน ระบบแพลตฟอร์มดิจิทัล
                  “ผูกพันธุ์” แบ่งการใช้งานตามระบบฯ และบทบาทดังต่อไปนี้
                </div>
                <div>
                  <span className={styles.dot}></span>“ประชาชน” หมายความว่า
                  ผู้ป่วย หรือ บุคคลทั่วไป ที่เข้าใช้งานระบบแพลตฟอร์มดิจิทัล
                  “ผูกพันธุ์”
                </div>
                <div>
                  <span className={styles.dot}></span>“บุคลากรทางการแพทย์”
                  หมายความว่า ผู้ประกอบวิชาชีพทางการแพทย์ ได้แก่ แพทย์
                  เภสัชกรพยาบาล เทคนิคการแพทย์ กายภาพบำบัด แพทย์แผนไทย
                  นักสาธารณสุขชุมชน รวมทั้ง
                  ผู้ที่มีหน้าที่ในการดูแลรักษาผู้ป่วยในด้านอื่น ๆ
                </div>
                <div>
                  <span className={styles.dot}></span>
                  “ผู้ปฏิบัติงานในห้องปฏิบัติการ” หมายความว่า
                  ผู้มีหน้าที่รับผิดชอบในการดำเนินการวิเคราะห์
                  ผลการตรวจทางพันธุกรรมที่โรงพยาบาลได้ทำการส่งตัวอย่างมาที่กรมวิทยาศาสตร์การแพทย์
                  ได้แก่ นักเทคนิคการแพทย์ และ นักวิทยาศาสตร์การแพทย์
                </div>
                <div>
                  1.5 “โรงพยาบาล” หมายความว่า
                  สถานที่รวมตลอดถึงยานพาหนะซึ่งจัดไว้เพื่อการประกอบโรคศิลปะ
                  ตามกฎหมายว่าด้วยการประกอบโรคศิลปะ
                  การประกอบวิชาชีพเวชกรรมตามกฎหมายว่าด้วยวิชาชีพเวชกรรม
                  การประกอบวิชาชีพการพยาบาลและการผดุงครรภ์ตามกฎหมายว่าด้วยวิชาชีพ
                  การพยาบาลและการผดุงครรภ์
                  การประกอบวิชาชีพทันตกรรมตามกฎหมายว่าด้วยวิชาชีพทันตกรรม
                  เทคนิคการแพทย์ตามกฎหมายว่าด้วยวิชาชีพเทคนิค การแพทย์
                  การประกอบวิชาชีพการแพทย์แผนไทยและการประกอบวิชาชีพการแพทย์แผนไทยประยุกต์ตามกฎหมายว่าด้วยวิชาชีพการแพทย์แผนไทย
                  หรือการประกอบวิชาชีพทางการแพทย์และสาธารณสุขอื่นตามกฎหมายว่าด้วยการนั้น
                </div>
                <div>
                  1.6 “ระบบสารสนเทศโรงพยาบาล” หรือ “Hospital Information System:
                  HIS” หมายความว่า ระบบการจัดการโรงพยาบาลที่ช่วยในการจัดเก็บ
                  จัดการ และส่งต่อข้อมูลจำนวนมากทั้งจากภายใน และภายนอกโรงพยาบาล
                  ให้ผู้บริหารสามารถจัดสรรทรัพยากรต่างๆ
                  ของโรงพยาบาลได้อย่างคุ้มค่า
                  เพิ่มประสิทธิภาพของการทำงานและการรักษาผู้ป่วยได้อย่างรวดเร็ว
                </div>
                <div>
                  1.7 “ระบบรับ-ส่งตัวอย่างเพื่อตรวจวิเคราะห์” หรือ “iLAB PLUS”
                  หมายความว่า ระบบรับ-ส่งตัวอย่าง
                  เพื่อตรวจวิเคราะห์กรมวิทยาศาสตร์การแพทย์ กระทรวงสาธารณสุข
                  โดยผู้ใช้จะแบ่งเป็นสำหรับหน่วยงานผู้ขอรับบริการ
                  และสำหรับเจ้าหน้าที่กรมวิทยาศาสตร์การแพทย์
                  ซึ่งผู้ขอรับบริการเป็นผู้ส่งตัวอย่างให้กับห้องปฏิบัติการของกรมวิทยาศาสตร์การแพทย์
                  จากนั้นจะทำการวิเคราะห์ผลทางห้องปฏิบัติการ
                  เมื่อวิเคราะห์ผลเรียบร้อยแล้วจะทำการออกรายงานผล
                  รับรองผลการตรวจวิเคราะห์
                  และส่งผลการตรวจวิเคราะห์กลับให้ทางผู้ขอรับบริการนั้น ๆ
                </div>
                <div>
                  1.8 “ผู้ให้บริการ”
                  หมายความหน่วยงานที่มีหน้าที่และ/หรือได้รับมอบหมายในการจัดทำ
                  พัฒนา และให้บริการระบบแพลตฟอร์มดิจิทัล“ผูกพันธุ์”
                </div>
                <br />
                <div>
                  2. วัตถุประสงค์ของการเก็บรวบรวม เข้าถึง ใช้งาน จัดการ
                  และเปิดเผยข้อมูลส่วนบุคคลของประชาชน
                </div>
                <div>
                  ข้อมูลส่วนบุคคลจะถูกเก็บรวบรวม เข้าถึง ใช้งาน จัดการ
                  และเปิดเผย
                  โดยมีวัตถุประสงค์เพื่อให้ผู้ขอใช้บริการเข้าถึงข้อมูลพันธุกรรมที่กรมวิทยาศาสตร์การแพทย์และห้องปฏิบัติการอื่น
                  ๆ ให้บริการ โดยมีผู้ใช้บริการ และบทบาทที่เกี่ยวข้อง ดังนี้
                </div>
                <div>
                  <span className={styles.dot}></span>ประชาชน
                  เข้าถึงและแสดงผลการตรวจของตนเองให้บุคลาการทางการแพทย์ที่รักษา
                </div>
                <div>
                  <span className={styles.dot}></span>บุคลากรทางการแพทย์
                  เข้าถึงและใช้ผลการตรวจของประชาชน ประกอบการพิจารณาวินิจฉัย
                  ป้องกันและรักษาโรคที่เฉพาะบุคคล
                  ส่งเสริมการรักษาแบบการแพทย์แม่นยำ (Precision Medicine)
                </div>
                <div>
                  <span className={styles.dot}></span>
                  ผู้ปฏิบัติงานในห้องปฏิบัติการ
                  บันทึกผลการตรวจทางพันธุกรรมในระบบแพลตฟอร์มดิจิทัล “ผูกพันธุ์”
                </div>
                <div>
                  นอกจากนี้ ระบบแพลตฟอร์มดิจิทัล “ผูกพันธุ์”
                  ยังสามารถเชื่อมต่อกับระบบสารสนเทศโรงพยาบาล
                  เพื่อแลกเปลี่ยนข้อมูลพันธุกรรม
                  เนื่องจากการตรวจทางพันธุกรรมบางรายการ สามารถตรวจครั้งเดียว
                  และใช้ผลการตรวจได้ตลอดชีวิต
                  ดังนั้นจึงทำให้ประชาชนและภาครัฐประหยัดเงิน และเวลาในการตรวจซ้ำ
                  เมื่อประชาชนเข้ารับการรักษาต่างโรงพยาบาล
                  และบุคลากรทางการแพทย์สามารถพิจารณาใช้ผลการตรวจดังกล่าว
                  ในการวางแผนป้องกันและรักษาโรคได้ทันที
                </div>
                <div>
                  ในขณะเดียวกัน
                  ข้อมูลส่วนบุคคลบางรายการมีความจำเป็นที่จะต้องทำการเก็บรวบรวม
                  เข้าถึง ใช้งาน จัดการ และเปิดเผย
                  เนื่องจากเป็นข้อมูลที่มีความสำคัญต่อการให้บริการระบบฯ
                  ซึ่งการเก็บรวบรวม เข้าถึง ใช้งาน จัดการ
                  และเปิดเผยข้อมูลส่วนบุคคลของประชาชน จะไม่ถูกกระทำการใด ๆ
                  ที่นอกเหนือไปจากวัตถุประสงค์ที่ได้ระบุไว้ข้างต้น
                  เว้นแต่เป็นการใช้เพื่อ
                </div>
                <div>
                  <span className={styles.dot}></span>
                  การควบคุมคุณภาพและเพิ่มประสิทธิภาพและส่งเสริมการให้บริการของระบบฯ
                </div>
                <div>
                  <span className={styles.dot}></span>
                  ความปลอดภัยของเครือข่ายและข้อมูล
                </div>
                <div>
                  <span className={styles.dot}></span>
                  การปฏิบัติตามเงื่อนไขการให้บริการของระบบฯ
                </div>
                <div>
                  <span className={styles.dot}></span>
                  การให้บริการเพื่อประโยชน์ของประชาชน
                </div>
                <div>
                  <span className={styles.dot}></span>วัตถุประสงค์อื่น ๆ
                  ซึ่งจะต้องได้รับความยินยอมจากประชาชนก่อน
                </div>
                <div>
                  <span className={styles.dot}></span>
                  ประโยชน์สาธารณะด้านการสาธารณสุข
                  ตามพระราชบัญญัติคุ้มครองข้อมูลส่วนบุคคล พ.ศ. 2562
                </div>
                <div>
                  <span className={styles.dot}></span>
                  การศึกษาวิจัยทางวิทยาศาสตร์ ประวัติศาสตร์ หรือสถิติ
                  หรือประโยชน์สาธารณะอื่น
                  ตามพระราชบัญญัติคุ้มครองข้อมูลส่วนบุคคล พ.ศ. 2562
                </div>
                <div>
                  <span className={styles.dot}></span>
                  การปฏิบัติตามกฎหมายว่าด้วยการคุ้มครองข้อมูลส่วนบุคคล พ.ศ. 2562
                  หรือกรณีที่กฎหมายฉบับอื่นบัญญัติให้กระทำ
                </div>
                <br />
                <div>
                  3. การเก็บรวบรวม เข้าถึง ใช้งาน จัดการ
                  และเปิดเผยข้อมูลส่วนบุคคลบนระบบแพลตฟอร์มดิจิทัล “ผูกพันธุ์”
                </div>
                <div>
                  ข้อมูลส่วนบุคคล
                  คือข้อมูลที่ทำให้สามารถระบุตัวตนหรือบ่งชี้ลักษณะเฉพาะตัวของประชาชนได้
                  ไม่ว่าจะทั้งทางตรงหรือทางอ้อม
                  แต่ไม่รวมถึงข้อมูลของผู้ถึงแก่กรรม
                  ซึ่งข้อมูลส่วนบุคคลที่จะถูกเก็บรวบรวม เข้าถึง ใช้งาน จัดการ
                  และเปิดเผยภายในระบบฯ
                  จะครอบคลุมทั้งข้อมูลก่อนและหลังจากวันที่ประชาชน
                  แสดงความยินยอมในการใช้บริการระบบฯ
                  โดยจะประกอบไปด้วยข้อมูลและวัตถุประสงค์ในการเก็บรวบรวม เข้าถึง
                  ใช้งาน จัดการ และเปิดเผย ดังนี้
                </div>
                <div>3.1 ข้อมูลส่วนตัว เช่น</div>
                <div>
                  <span className={styles.dot}></span>หมายเลขบัตรประชาชน
                  เพื่อใช้ในการดึงข้อมูลพันธุกรรมจากฐานข้อมูล “ผูกพันธุ์”
                  และยืนยันตัวตนของประชาชนกับฐานข้อมูลกรมการปกครอง
                </div>
                <div>
                  <span className={styles.dot}></span>คำนำหน้า ชื่อ นามสกุล เพศ
                  อายุ และหมายเลขโทรศัพท์ เพื่อระบุตัวตนและในการดึงข้อมูล
                </div>
                <div>
                  <span className={styles.dot}></span>รหัสไปรษณีย์
                  เพื่อนำไปใช้ในการศึกษาวิจัยทางวิทยาศาสตร์ ประวัติศาสตร์
                  หรือสถิติ หรือประโยชน์สาธารณะอื่น ๆ
                  ตามพระราชบัญญัติคุ้มครองข้อมูลส่วนบุคคล พ.ศ. 2562
                </div>
                <div>
                  <span className={styles.dot}></span>หมายเลขหลังบัตรประชาชน
                  ถูกนำมาใช้เพื่อยืนยันตัวตนของประชาชนกับฐานข้อมูล กรมการปกครอง
                  เป็นการป้องกันการฉ้อโกงโดยแสดงตนเป็นบุคคลอื่น
                  ซึ่งข้อมูลนี้จะไม่ถูกเก็บไว้เมื่อทำการยืนยันตัวตนหรือสมัครใช้งานสำเร็จ
                </div>
                <div>3.2 ข้อมูลสุขภาพละเอียดอ่อน ได้แก่</div>
                <div>
                  <span className={styles.dot}></span>ข้อมูลพันธุกรรม
                  เป็นข้อมูลพันธุกรรมที่ถูกนำในระบบแพลตฟอร์มดิจิทัล “ผูกพันธุ์”
                  โดย 4 การทดสอบแรกที่แสดงในระบบฯ ได้แก่
                </div>
                <div>
                  การตรวจ HLA-B*58:01 สำหรับกลุ่มผู้ป่วยที่ได้รับยา Allopurinol
                </div>
                <div>
                  การตรวจ HLA-B*15:02 สำหรับกลุ่มผู้ป่วยที่ได้รับยา
                  Carbamazepine
                </div>
                <div>
                  การตรวจ HLA-B*57:01 สำหรับกลุ่มผู้ป่วยที่ได้รับยา Abacavir
                </div>
                <div>
                  การตรวจ NAT2-Diplotype ในผู้ป่วยโรควัณโรคที่ได้รับยา Isoniazid
                </div>
                <div>
                  และการทดสอบทางพันธุกรรมอื่น ๆ เช่น การตรวจการกลายพันธุ์ของยีน
                  BRCA1/BRCA2 การตรวจธาลัสซีเมีย และการแปลผลทางพันธุกรรม
                  จากโครงการจีโนมิกส์ประเทศไทย เป็นต้น ทั้งนี้
                  ข้อมูลที่นำเข้าในระบบแพลตฟอร์มดิจิทัล “ผูกพันธุ์”
                  อาจแสดงข้อมูลพันธุกรรมย้อนหลังเพียงบางส่วน
                  เนื่องจากข้อจำกัดในการจัดเก็บข้อมูลในช่วงเวลาที่ผ่านมา
                </div>
                <div>
                  3.3 ข้อมูลประวัติความยินยอม
                  ซึ่งเป็นการบันทึกข้อมูลที่เกี่ยวข้องกับการให้ความยินยอมของประชาชน
                  และข้อมูลการร้องขอความยินยอมเพื่อเรียกดูข้อมูลสุขภาพของประชาชนโดยบุคลากรทางการแพทย์
                  รวมถึงการตอบรับของประชาชน เพื่อใช้กำกับการเก็บรวบรวม เข้าถึง
                  ใช้งาน จัดการ และเปิดเผยข้อมูลของประชาชน โดยมีรายละเอียดดังนี้
                </div>
                <div>
                  <span className={styles.dot}></span>
                  วันที่และเวลาของการร้องขอและตอบรับ
                </div>
                <div>
                  <span className={styles.dot}></span>ช่องทางการร้องขอและตอบรับ
                </div>
                <div>
                  <span className={styles.dot}></span>
                  ข้อมูลของบุคลากรทางการแพทย์ผู้ทำการร้องขอ
                </div>
                <div>
                  <span className={styles.dot}></span>ข้อมูลส่วนตัวของประชาชน
                </div>
                <div>
                  <span className={styles.dot}></span>โรงพยาบาลที่เกิดการร้องขอ
                </div>
                <div>
                  <span className={styles.dot}></span>
                  การแสดงหรือปฏิเสธความยินยอมของประชาชน
                </div>
                <div>
                  3.4 ข้อมูลประวัติการเข้าถึงและเรียกดูข้อมูลสุขภาพ
                  ซึ่งเป็นการบันทึกการเรียกดูข้อมูลสุขภาพของประชาชนโดยบุคลากรทางการแพทย์
                  ในโรงพยาบาลที่เข้าร่วมระบบฯ
                  เพื่อใช้ตรวจสอบและดูแลจัดการเข้าถึง
                  และใช้งานข้อมูลสุขภาพของประชาชน เช่น
                </div>
                <div>
                  <span className={styles.dot}></span>
                  ประเภทข้อมูลสุขภาพที่ถูกเรียกดู
                </div>
                <div>
                  <span className={styles.dot}></span>
                  วันที่และเวลาของการเรียกดูข้อมูล
                </div>
                <div>
                  <span className={styles.dot}></span>
                  ข้อมูลของบุคลากรทางการแพทย์ผู้ทำการเรียกดูข้อมูล
                </div>
                <div>
                  <span className={styles.dot}></span>สถานะของการเรียกดูข้อมูล
                  (อนุญาต/ไม่อนุญาต)
                </div>
                <div>
                  <span className={styles.dot}></span>ข้อมูลส่วนตัว
                </div>
                <div>
                  <span className={styles.dot}></span>
                  รายชื่อโรงพยาบาลที่ถูกบุคลากรทางการแพทย์เรียกดูข้อมูล
                </div>
                <div>
                  <span className={styles.dot}></span>
                  โรงพยาบาลของบุคลากรทางการแพทย์ ณ ตอนที่เรียกดูข้อมูล
                </div>
                <div>
                  <span className={styles.dot}></span>ประเภทของการเข้ารับบริการ
                  (ประชาชน/กรณีฉุกเฉิน)
                </div>
                <div>
                  3.5 ข้อมูลประวัติการนำเข้าข้อมูลสุขภาพ
                  ซึ่งเป็นการบันทึกรายการการนำเข้าข้อมูลสุขภาพทางอิเล็กทรอนิกส์ของประชาชน
                  จากโรงพยาบาลหรือห้องปฏิบัติการอื่น ๆ ที่เข้าร่วมระบบฯ
                  มายังระบบแพลตฟอร์มดิจิทัล “ผูกพันธุ์”
                  เพื่อใช้จัดการดูแลและเป็นหลักฐานการทำงานของระบบฯ เช่น
                </div>
                <div>
                  <span className={styles.dot}></span>
                  วันที่และเวลาของการนำเข้าข้อมูล
                </div>
                <div>
                  <span className={styles.dot}></span>สถานะของการนำเข้าข้อมูล
                  (สำเร็จ)
                </div>
                <div>
                  <span className={styles.dot}></span>ข้อมูลส่วนตัวของประชาชน
                </div>
                <div>
                  <span className={styles.dot}></span>
                  โรงพยาบาลที่นำส่งข้อมูลเข้าระบบฯ
                </div>
                <div>
                  <span className={styles.dot}></span>ประเภทข้อมูลที่ถูกนำเข้า
                </div>
                <div>
                  บุคลากรทางการแพทย์ที่สามารถเข้าถึง เรียกดู
                  และใช้ข้อมูลส่วนบุคคลของประชาชน แบ่งเป็น 3 กรณี ได้แก่
                </div>
                <div>
                  <span className={styles.dot}></span>
                  เข้าถึงข้อมูลผ่านระบบแพลตฟอร์มดิจิทัล “ผูกพันธุ์”
                  บุคลากรทางการแพทย์ที่เป็นผู้ขอเข้าถึงข้อมูล
                  ของประชาชนเท่านั้นที่จะสามารถเข้าถึง เรียกดู
                  และใช้ข้อมูลพันธุกรรมของประชาชน
                </div>
                <div>
                  <span className={styles.dot}></span>
                  เข้าถึงข้อมูลผ่านระบบสารสนเทศโรงพยาบาล
                  เมื่อประชาชนให้ความยินยอมให้รับ-ส่งข้อมูลพันธุกรรมระหว่างระบบแพลตฟอร์มดิจิทัล
                  “ผูกพันธุ์” กับระบบสารสนเทศโรงพยาบาล
                  โดยบุคลากรทางการแพทย์ในโรงพยาบาลนั้น ๆ สามารถเข้าถึง เรียกดู
                  และใช้ข้อมูลพันธุกรรมของประชาชน
                </div>
                <div>
                  <span className={styles.dot}></span>
                  ผู้ให้บริการระบบแพลตฟอร์มดิจิทัล “ผูกพันธุ์”
                  ซึ่งเป็นผู้ดูแลการใช้งาน จัดการ การให้บริการ การพัฒนา
                  และความปลอดภัยของระบบฯ
                  จึงสามารถเข้าถึงข้อมูลใดของประชาชนได้เท่าทีมีความจำเป็น
                </div>
                <div>
                  การเปิดเผยข้อมูลส่วนบุคคลของประชาชนในระบบแพลตฟอร์มดิจิทัล
                  “ผูกพันธุ์” อาจมีการเปิดเผยให้แก่บุคคลที่ทำงานให้
                  และทำงานร่วมกับผู้ให้บริการระบบฯ อาทิเช่น ผู้ตรวจสอบระบบฯ
                  ผู้พัฒนาดูแลระบบฯ และผู้ประชาสัมพันธ์ระบบฯ โดยบุคคลดังกล่าว
                  สามารถเข้าถึงเฉพาะข้อมูลที่จำเป็นตามหน้าที่ที่ได้รับมอบหมายจากผู้ให้บริการระบบฯ
                  เพื่อวัตถุประสงค์ในการปรับปรุง พัฒนา และส่งเสริมบริการของระบบฯ
                  ให้ปลอดภัย ถูกต้อง และมีประสิทธิภาพมากขึ้น
                  และโรงพยาบาลที่เข้าร่วมใช้งานระบบแพลตฟอร์มดิจิทัล “ผูกพันธุ์”
                  เพื่อให้บุคลากรทางการแพทย์ของโรงพยาบาลนั้น
                  สามารถเข้าถึงและใช้ผลการตรวจทางพันธุกรรมของประชาชน
                  ประกอบการพิจารณาวินิจฉัย ป้องกันและรักษาโรคที่เฉพาะบุคคลได้
                </div>
                <div>
                  การใช้งานหรือเปิดเผยข้อมูลส่วนบุคคลของประชาชนภายในระบบแพลตฟอร์มดิจิทัล
                  “ผูกพันธุ์” จะเป็นไปตามวัตถุประสงค์ที่กล่าวไว้ข้างต้น
                  ความยินยอมเข้าร่วมระบบฯของประชาชน
                  ข้อกำหนดและเงื่อนไขการใช้บริการสำหรับประชาชน
                  และประกาศนโยบายความเป็นส่วนตัวฉบับนี้อย่างเคร่งครัด
                  โดยผู้ให้บริการระบบฯ
                  จะไม่นำข้อมูลส่วนบุคคลของประชาชนไปใช้เพื่อการกระทำอื่นใด
                  ซึ่งไม่เป็นประโยชน์ต่อการรักษาพยาบาลของประชาชน
                  เว้นแต่จะได้รับความยินยอมจากประชาชนมาก่อนแล้ว
                  หรือเป็นไปตามตามกฎหมายว่าด้วยการคุ้มครองข้อมูลส่วนบุคคล
                  ในขณะเดียวกัน
                  ก่อนที่บุคลากรทางการแพทย์จะสามารถเข้าถึงข้อมูลส่วนบุคคลของประชาชนได้
                  บุคลากรทางการแพทย์ต้องตกลงที่จะปฏิบัติตามข้อกำหนดและเงื่อนไขการใช้บริการสำหรับบุคลกรทางการแพทย์
                  และได้รับอนุญาตจากโรงพยาบาล ที่เข้าร่วมระบบฯในการใช้งานระบบฯ
                  เพื่อประกอบการให้บริการทางการบุคลากรทางการแพทย์ อย่างไรก็ตาม
                  ผู้ให้บริการระบบฯ
                  ไม่สามารถรับรองได้อย่างเด็ดขาดว่าการเข้าถึงข้อมูลส่วนบุคคลของประชาชน
                  โดยบุคลากรทางการแพทย์จะเป็นไปตามวัตถุประสงค์ของการรักษาพยาบาลของประชาชนและ/หรือข้อตกลงดังกล่าว
                  แต่ระบบฯจะดูแลการเข้าถึงข้อมูลส่วนบุคคลของประชาชนอย่างใกล้ชิด
                  โดยกำกับ บันทึก และตรวจสอบการใช้งานของบุคลากรทางการแพทย์
                  ตามข้อกำหนดและเงื่อนไขที่ระบุไว้ข้างต้น หากระบบฯ
                  ค้นพบบุคลากรทางการแพทย์ที่ใช้งานระบบฯ
                  นอกขอบเขตข้อกำหนดและเงื่อนไขการใช้บริการสำหรับบุคลากรทางการแพทย์
                  ระบบฯ จะระงับการใช้งานของบุคลากรทางการแพทย์ทันที
                </div>
                <div>
                  ในบางกรณีอาจมีการอนุญาตให้บุคลากรทางการแพทย์เข้าถึงข้อมูลส่วนบุคคลของประชาชนได้หากประชาชนอยู่ในกรณีฉุกเฉินซึ่งมีความจำเป็นจะต้องป้องกันหรือระงับอันตรายต่อชีวิต
                  ร่างกาย หรือสุขภาพของประชาชน
                  ซึ่งประชาชนไม่สามารถให้ความยินยอมได้ไม่ว่าด้วยเหตุใดก็ตาม
                  หรือกรณีที่มีการบังคับใช้ภายใต้หลักเกณฑ์ที่กฎหมายกำหนด
                  โดยบุคคลที่เข้าถึงข้อมูลของประชาชนจะต้องเก็บรวบรวม เข้าถึง
                  ใช้งาน จัดการ และเปิดเผยข้อมูลส่วนบุคคลของประชาชนตามเงื่อนไข
                  หรือขอบเขตเท่าที่จำเป็นเท่านั้น ทั้งนี้ระบบฯ
                  จะบันทึกการใช้และการเปิดเผยข้อมูลส่วนบุคคลดังกล่าวไว้
                  เพื่อให้ประชาชนสามารถตรวจสอบได้
                </div>
                <br />
                <div>4. แหล่งที่มาของข้อมูลส่วนบุคคล</div>
                <div>ข้อมูลส่วนบุคคลของประชาชนจะถูกเก็บรวบรวมโดยแบ่งเป็น</div>
                <div>
                  4.1 ข้อมูลส่วนตัว
                  จะถูกเก็บรวบรวมและจัดการผ่านระบบอิเล็กทรอนิกส์ของระบบแพลตฟอร์มดิจิทัล
                  “ผูกพันธุ์” โดยมีการนำเข้าข้อมูล และพิสูจน์ตัวตนจากแพลตฟอร์ม
                  ดังต่อไปนี้
                </div>
                <div>
                  <span className={styles.dot}></span>“หมอพร้อม”
                  ภายใต้การดูแลของสำนักสุขภาพดิจิทัล สำนักปลัดกระทรวงสาธารณสุข
                </div>
                <div>
                  <span className={styles.dot}></span>“OnesID” ภายใต้การดูแลของ
                  SOFTMAX CO., LTD.
                </div>
                <div>
                  <span className={styles.dot}></span>“ThaiD”
                  ภายใต้การดูแลของกรมการปกครอง
                </div>
                <div>
                  หรือ
                  ผ่านการกรอกแบบฟอร์มลงทะเบียนเข้าใช้งานผ่านระบบแพลตฟอร์มดิจิทัล
                  “ผูกพันธุ์”
                </div>
                <div>
                  4.2 ข้อมูลสุขภาพละเอียดอ่อน เป็นข้อมูลพันธุกรรม
                  ที่ถูกนำเข้าจาก
                </div>
                <div>
                  <span className={styles.dot}></span>
                  ระบบรับ-ส่งตัวอย่างเพื่อตรวจวิเคราะห์ของกรมวิทยาศาสตร์การแพทย์
                  (iLAB PLUS)
                </div>
                <div>
                  <span className={styles.dot}></span>ระบบสารสนเทศโรงพยาบาล
                  (Hospital Information System)
                </div>
                <div>
                  <span className={styles.dot}></span>
                  การนำเข้าข้อมูลผลการตรวจทางห้องปฏิบัติการโดยเจ้าหน้าที่ห้องปฏิบัติการของโรงพยาบาลผ่านเว็บไซต์
                  “ผูกพันธุ์”
                </div>
                <div>
                  4.3 ข้อมูลประวัติความยินยอม
                  ข้อมูลประวัติการเข้าถึงและเรียกดูข้อมูลสุขภาพ
                  ข้อมูลการเข้ารับบริการทางการแพทย์
                  และข้อมูลประวัติการนำเข้าข้อมูลสุขภาพ
                  จะถูกเก็บรวบรวมโดยแพลตฟอร์มดิจิทัล “ผูกพันธุ์”
                </div>
                <br />
                <div>
                  5. การแสดงความยินยอมให้เก็บรวบรวม เข้าถึง ใช้งาน จัดการ
                  และเปิดเผยข้อมูลส่วนบุคคล
                </div>
                <div>
                  ระบบแพลตฟอร์มดิจิทัล “ผูกพันธุ์”
                  ออกแบบให้บุคลากรทางการแพทย์สามารถเข้าถึงข้อมูลผ่านแอปพลิเคชัน
                  เว็บไซต์ และระบบสารสนเทศโรงพยาบาล ที่เข้าร่วมใช้บริการระบบฯ
                  ดังนั้นเพื่อให้สามารถแลกเปลี่ยน
                  ข้อมูลพันธุกรรมของประชาชนได้นั้น
                  ประชาชนสามารถเลือกแสดงความยินยอม โดยมีรูปแบบดังต่อไปนี้
                </div>
                <div>
                  <span className={styles.dot}></span>การแสดงความยินยอมรายครั้ง
                  ผ่านระบบแพลตฟอร์มดิจิทัล “ผูกพันธุ์” เมื่อบุคลากรทางการแพทย์
                  กดขออนุญาตเข้าถึงข้อมูลพันธุกรรรมขอประชาชน
                  หากประชาชนเลือกให้เข้าถึงข้อมูลดังกล่าว แบบรายครั้ง
                  ประชาชนจำเป็นจะต้องกดยินยอมให้เข้าถึงข้อมูลดังกล่าวทุกครั้งที่มีการขอเข้าถึง
                  แม้ว่าบุคลากรทางการแพทย์ผู้นั้นจะเป็นคนเดียวกันกับผู้ที่ขอเข้าถึงข้อมูลครั้งแรกก็ตาม
                </div>
                <div>
                  <span className={styles.dot}></span>
                  การแสดงความยินยอมครั้งเดียว ผ่านระบบแพลตฟอร์มดิจิทัล
                  “ผูกพันธุ์”
                  เมื่อบุคลากรทางการแพทย์ขออนุญาตเข้าถึงข้อมูลพันธุกรรรมของประชาชน
                  หากประชาชนเลือกให้เข้าถึงข้อมูลดังกล่าว
                  แบบครั้งเดียวจะเป็นการอนุญาตให้บุลคาการทางการแพทย์คนดังกล่าวสามารถเข้าถึง
                  ข้อมูลพันธุกรรรมของประชาชนได้ตลอดจนกว่าประชาชนจะยกเลิกความยินยอม
                </div>
                <div>
                  <span className={styles.dot}></span>
                  การแสดงความยินยอมรายโรงพยาบาล
                  เมื่อประชาชนเข้ารับการรักษาในโรงพยาบาลนั้น ๆ
                  ประชาชนมีสิทธิ์ที่จะอนุญาตให้โรงพยาบาลเข้าถึงและนำเข้าข้อมูลพันธุกรรรมใน
                  ระบบสารสนเทศโรงพยาบาลกับระบบแพลตฟอร์มดิจิทัล “ผูกพันธุ์”
                  หรือไม่อนุญาตก็ได้
                </div>
                <div>
                  ข้อมูลพันธุกรรรมของประชาชนจะสามารถเข้าถึงได้โดยบุคลากรทางการแพทย์ก็ต่อเมื่อ
                  ประชาชนอนุญาตให้เข้าถึงข้อมูลเท่านั้น
                </div>
                <br />
                <div>6. การแบ่งปันข้อมูลให้แก่บุคคลที่สาม</div>
                <div>
                  ข้อมูลที่เก็บรวบรวมในระบบแพลตฟอร์มดิจิทัล “ผูกพันธุ์”
                  จะถูกแบ่งปันให้กับบุคลากรทางการแพทย์เพื่อวัตถุประสงค์ด้านสาธารณสุข
                  ก็ต่อเมื่อเจ้าของข้อมูลอนุญาตให้เข้าถึงข้อมูลดังกล่าวผ่านระบบฯ
                  และการเสียบประชาชนเท่านั้น
                  โดยข้อมูลจะไม่ถูกแบ่งปันเพื่อวัตถุประสงค์เชิงพาณิชย์โดยไม่ได้รับอนุญาต
                </div>
                <div>
                  นอกจากนี้ระบบแพลตฟอร์มดิจิทัล “ผูกพันธุ์”
                  จะมีการขออนุญาตเปิดเผยข้อมูลส่วนตัวของประชาชน
                  ให้แก่หน่วยงานของบุคคลที่มีวัตถุประสงค์เพื่อนำข้อมูลพันธุกรรมจากระบบฯ
                  ไปแสดงในระบบต่าง ๆ เช่น
                  การเปิดเผยข้อมูลส่วนบุคคลของประชาชนไปยังแอปพลิเคชัน “H4U”
                  แอปพลิเคชัน “หมอพร้อม” และระบบ “Health Link”
                  โดยที่หน่วยงานของแอปพลิเคชันดังกล่าวจะต้องตกลงเรื่องการเก็บรวบรวม
                  เข้าถึง ใช้งาน จัดการ
                  และเปิดเผยข้อมูลส่วนบุคคลของประชาชนกับโรงพยาบาลที่เข้าร่วมระบบฯ
                  จัดทำเอกสารชี้แจงขอบเขตและวัตถุประสงค์ของการใช้งานข้อมูลจากระบบฯ
                  รวมถึงจัดให้มีมาตรฐานความปลอดภัยที่มีความมั่นคงอย่างเพียงพอ
                  ทั้งนี้ หน่วยงานของบุคคลที่สามจะต้องเก็บรวบรวม ใช้
                  เปิดเผยข้อมูลของประชาชนตามที่กฎหมายว่าด้วยการคุ้มครองข้อมูลส่วนบุคคลกำหนด
                </div>
                <br />
                <div>7. การจัดเก็บข้อมูลส่วนบุคคลของประชาชน</div>
                <div>
                  ข้อมูลของประชาชนจะถูกจัดเก็บในฐานข้อมูลบนศูนย์ข้อมูล (server)
                  ของกรมวิทยาศาสตร์การแพทย์
                  โดยข้อมูลของประชาชนจะถูกรักษาไว้อย่างดี โดยมีการสำรองข้อมูล
                  มาตรการในการรักษาความปลอดภัย
                  และกลไกในการปกป้องข้อมูลจากการสูญเสียต่าง ๆ
                  การเปิดเผยข้อมูลส่วนบุคคลของประชาชน
                  จะมีผลบังคับใช้ตลอดระยะเวลาที่ประชาชนให้ความยินยอมใช้งานระบบแพลตฟอร์มดิจิทัล
                  “ผูกพันธุ์” หรือจนกว่าระบบฯ จะยุติการให้บริการ
                  หรือเป็นไปตามข้อกำหนดของระเบียบกฎหมายที่เกี่ยวข้อง
                </div>
                <br />
                <div>8. สิทธิของประชาชนเกี่ยวกับข้อมูลส่วนบุคคล</div>
                <div>
                  ประชาชนมีสิทธิในการให้ความยินยอมให้รับ-ส่งข้อมูลพันธุกรรมระหว่างระบบแพลตฟอร์มดิจิทัล
                  “ผูกพันธุ์” กับระบบสารสนเทศโรงพยาบาล
                  บุคลากรทางการแพทย์ในโรงพยาบาลนั้น ๆ สามารถเข้าถึง เรียกดู
                  และใช้ข้อมูลพันธุกรรมของประชาชน
                  ทำให้ประชาชนสามารถรับบริการพยาบาลปราศจากรอยต่อ ทั้งนี้
                  สิทธิของประชาชนเกี่ยวกับข้อมูลในระบบฯ มีดังต่อไปนี้
                </div>
                <div>
                  <span className={styles.dot}></span>
                  สิทธิที่จะได้รับการแจ้งให้ทราบ
                  เอกสารนโยบายการคุ้มครองข้อมูลฉบับนี้มีไว้เพื่อแจ้งให้ประชาชนทราบเกี่ยวกับการเก็บรวบรวม
                  เข้าถึง ใช้งาน จัดการ และเปิดเผยข้อมูลส่วนบุคคลของประชาชน
                  โดยประชาชนสามารถติดต่อมาที่ระบบฯ
                  เพื่อสอบถามรายละเอียดเพิ่มเติม
                </div>
                <div>
                  <span className={styles.dot}></span>สิทธิในการขอเข้าถึง รับ
                  โอนถ่าย และแก้ไขข้อมูลส่วนบุคคล ประชาชนสามารถเข้าถึง รับ
                  โอนถ่าย
                  และแก้ไขข้อมูลส่วนบุคคลของประชาชนตามแหล่งที่มาของข้อมูลที่ระบุไว้ข้างต้น
                  อย่างไรก็ตาม
                  สิทธิของประชาชนอาจจำกัดโดยความสัมพันธ์ที่มีอยู่ระหว่างประชาชนและผู้ควบคุมข้อมูลของประชาชน
                </div>
                <div>
                  ทั้งนี้
                  ประชาชนสามารถใช้สิทธิในการโอนถ่ายข้อมูลจากระบบแพลตฟอร์มดิจิทัล
                  “ผูกพันธุ์” ไปยังระบบหรือหน่วยงานอื่นที่ทำการเชื่อมโยงกับระบบฯ
                  ได้
                  ปัจจุบันยังไม่มีแอปพลิเคชันที่ประชาชนสามารถยินยอมให้ดึงข้อมูลจากระบบฯ
                  ได้ โดยระบบฯ มีแผนดำเนินการพัฒนาในส่วนการเชื่อมต่อ
                  กับแอปพลิเคชันอื่น ๆ ในระยะถัดไป
                </div>
                <div>
                  <span className={styles.dot}></span>
                  สิทธิในการคัดค้านการเก็บรวบรวม ใช้ หรือเปิดเผยข้อมูลส่วนบุคคล
                  ประชาชนสามารถคัดค้านการเก็บรวบรวม ใช้
                  หรือเปิดเผยข้อมูลส่วนบุคคของประชาชนได้
                  โดยไม่ยินยอมเข้าร่วมโครงการฯ เพิกถอนความยินยอม
                  หรือส่งคำร้องขอดังกล่าวมาที่ระบบฯ
                </div>
                <div>
                  <span className={styles.dot}></span>สิทธิในการขอให้ลบ
                  หรือทำลายข้อมูลส่วนบุคคล
                  ประชาชนสามารถขอใช้สิทธิโดยส่งคำร้องขอมาที่ระบบฯ
                </div>
                <div>
                  <span className={styles.dot}></span>
                  สิทธิในการขอระงับการใช้ข้อมูล
                  ประชาชนสามารถระงับการใช้ข้อมูลของประชาชนได้
                  โดยการเพิกถอนความยินยอมเข้าร่วมระบบฯ
                </div>
                <div>
                  <span className={styles.dot}></span>
                  สิทธิในการเพิกถอนความยินยอม
                  ประชาชนสามารถเพิกถอนความยินยอมในการเก็บรวบรวม เข้าถึง ใช้งาน
                  จัดการ และเปิดเผยข้อมูลส่วนบุคคลของประชาชนจากระบบฯ
                  ได้ตลอดระยะเวลาที่เข้าร่วมระบบฯ ทั้งนี้
                  การเพิกถอนจะไม่มีผลลบล้างความยินยอมหรือผลของความยินยอนที่ได้กระทำไปก่อนหน้าแต่อย่างใด
                  โดยขั้นตอนในการเพิกถอนความยินยอมนั้นจำเป็นจะต้องทำผ่านระบบฯ
                </div>
                <div>
                  <span className={styles.dot}></span>
                  สิทธิในการเลือกโรงพยาบาลที่สามารถนำข้อมูลการรักษาพยาบาลของประชาชนเข้าสู่ระบบฯ
                </div>
                <div>
                  <span className={styles.dot}></span>
                  สิทธิในการอนุญาตหรือปฏิเสธการเข้าถึงประวัติการรักษาพยาบาลจากโรงพยาบาลที่บังคับ
                  การให้ความยินยอมเป็นรายครั้ง
                </div>
                <br />
                <div>
                  9. การปฏิเสธคำขอหรือการคัดค้านเกี่ยวกับข้อมูลส่วนบุคคล
                </div>
                <div>
                  การดำเนินการต่าง ๆ
                  ที่เกิดขึ้นกับข้อมูลส่วนบุคคลของประชาชนจะเป็นตามพระราชบัญญัติคุ้มครอง
                  ข้อมูลส่วนบุคคล พ.ศ. 2562
                </div>
                <br />
                <div>
                  10.
                  ข้อมูลเกี่ยวกับผู้ประมวลผลและผู้ควบคุมข้อมูลส่วนบุคคลของประชาชน
                </div>
                <div>
                  เมื่อประชาชนเข้าร่วมใช้งานระบบแพลตฟอร์มดิจิทัล “ผูกพันธุ์”
                  ข้อมูลส่วนบุคคลของประชาชน จะถูกเก็บรวบรวม เข้าถึง ใช้งาน
                  จัดการ และเปิดเผยโดยบุคคล หรือนิติบุคคลที่เกี่ยวข้องตามหน้าที่
                  ความรับผิดชอบที่ได้รับมอบหมาย ซึ่งจำแนกออกเป็น
                </div>
                <div>
                  10.1 ผู้ควบคุมข้อมูลส่วนบุคคล หมายถึง
                  บุคคลหรือนิติบุคคลซึ่งมีหน้าที่ตัดสินใจเกี่ยวกับการเก็บรวบรวม
                  เข้าถึง ใช้งาน จัดการ และเปิดเผยข้อมูลส่วนบุคคล ในที่นี้
                  ผู้ควบคุมข้อมูลส่วนบุคคลในระบบฯ ได้แก่
                </div>
                <div>
                  10.2 กรมวิทยาศาสตร์การแพทย์
                  โดยสถาบันชีววิทยาศาสตร์ทางการแพทย์ซึ่งเป็นผู้ควบคุมดูแลข้อมูล
                  ที่อยู่ใน ระบบฯ โดยมีหน้าที่
                </div>
                <div>
                  <span className={styles.dot}></span>เก็บรวบรวม เข้าถึง ใช้งาน
                  จัดการ และเปิดเผยข้อมูลของประชาชนตามที่ประชาชน
                  ได้ให้ความยินยอมไว้
                </div>
                <div>
                  <span className={styles.dot}></span>
                  จัดให้มีมาตรการรักษาความมั่นคงปลอดภัยข้อมูลส่วนบุคคลอย่างเหมาะสม
                  รวมทั้งแจ้งให้ผู้ควบคุมข้อมูลส่วนบุคคลทราบถึงการละเมิดข้อมูลส่วนบุคคลที่เกิดขึ้น
                </div>
                <div>
                  <span className={styles.dot}></span>
                  จัดทำและเก็บรักษาบันทึกรายการกิจกรรมการประมวลผลข้อมูลส่วนบุคคลที่เกิดขึ้นอย่างถูกต้องครบถ้วน
                </div>
                <div>
                  10.3 โรงพยาบาลที่เข้าร่วมใช้งานระบบฯ
                  ซึ่งจะเป็นผู้ควบคุมข้อมูลส่วนบุคคลของประชาชน
                </div>
                <div>
                  10.4 กรมการปกครอง
                  ซึ่งจะเป็นผู้ควบคุมข้อมูลส่วนบุคคลสำหรับข้อมูลส่วนตัวจากการดำเนินการตรวจสอบเลขหลังบัตรประชาชนเพื่อยืนยันตัวบุคคล
                  ที่กระทำโดยประชาชนผ่านขั้นตอน
                  การกรอกข้อมูลเพื่อสมัครเข้าใช้งานระบบฯ
                </div>
                <div>
                  10.5 สำนักสุขภาพดิจิทัล สำนักปลัดกระทรวงสาธารณสุข
                  ซึ่งจะเป็นผู้ควบคุมข้อมูลส่วนบุคคล
                  สำหรับข้อมูลส่วนตัวจากการดำเนินการสมัครใช้งานและยืนยันตัวตน
                  (e-KYC) ที่กระทำโดยประชาชนผ่านทางแอปพลิเคชัน “หมอพร้อม”
                </div>
                <div>
                  10.6 บริษัท ซอฟต์แม็กซ์ จำกัด
                  ซึ่งจะเป็นผู้ควบคุมข้อมูลส่วนบุคคลสำหรับข้อมูลส่วนตัว
                  จากการดำเนินการสมัครใช้งานและยืนยันตัวตน (e-KYC)
                  ที่กระทำโดยประชาชน ผ่านทางแอปพลิเคชัน “OnesID”
                </div>
                <div>
                  10.7 ผู้ประมวลผลข้อมูลส่วนบุคคล หมายถึง
                  บุคคลหรือนิติบุคคลซึ่งดำเนินการเกี่ยวกับ การเก็บรวบรวม เข้าถึง
                  ใช้งาน จัดการ
                  และเปิดเผยข้อมูลส่วนบุคคลตามคำสั่งหรือในนามของผู้ควบคุมข้อมูลส่วนบุคคล
                  ในที่นี้ ผู้ประมวลผลข้อมูลส่วนบุคคลในระบบฯ ได้แก่
                </div>
                <div>
                  10.8 บุคลากรทางการแพทย์ในโรงพยาบาลที่เข้าร่วมโครงการฯ
                  โดยมีหน้าที่ใช้ Health Link
                  เพื่อประกอบการรักษาพยาบาลของประชาชน
                </div>
                <div>
                  10.9 เจ้าหน้าที่ในโรงพยาบาลที่เข้าร่วมระบบฯ
                  โดยมีหน้าที่ดูแลจัดการการใช้งานข้อมูลของประชาชนในโรงพยาบาลนั้น
                  ๆ
                </div>
                <div>
                  10.10 กรมวิทยาศาสตร์การแพทย์ โดย ศูนย์เทคโนโลยีสารสนเทศ
                  ซึ่งมีหน้าที่ดำเนินการเก็บรวบรวม ใช้งาน จัดการ
                  และเปิดเผยข้อมูลสุขภาพและข้อมูลการเข้ารับบริการทางการแพทย์
                  ตามที่ได้รับมอบหมายจากกรมวิทยาศาสตร์การแพทย์
                  ซึ่งเป็นผู้ควบคุมข้อมูลส่วนบุคคล เว้นแต่จะขัดต่อ
                  ข้อกฎหมายหรือพระราชบัญญัติคุ้มครองข้อมูลส่วนบุคคล พ.ศ. 2562
                </div>
                <div>
                  10.11 บุคคลอื่น
                  ที่ผู้ควบคุมข้อมูลกำหนดเพื่อดำเนินการตามวัตถุประสงค์ของระบบฯ
                </div>
                <br />
                <div>11. การเปลี่ยนแปลงนโยบายการคุ้มครองข้อมูลส่วนบุคคล</div>
                <div>
                  ผู้ให้บริการระบบแพลตฟอร์มดิจิทัล “ผูกพันธุ์”
                  ขอสงวนสิทธิในการปรับปรุงหรือแก้ไขรายละเอียดนโยบายคุ้มครองข้อมูลส่วนบุคคล
                </div>
                <div>
                  <span className={styles.dot}></span>เพื่อวัตถุประสงค์ของระบบฯ
                </div>
                <div>
                  <span className={styles.dot}></span>เพื่อพัฒนา ทดสอบ
                  และให้บริการระบบฯ
                </div>
                <div>
                  <span className={styles.dot}></span>
                  เพื่อให้เกิดผลประโยชน์ต่อผู้ใช้บริการ
                  และสาธารณสุขให้มากยิ่งขึ้น
                </div>
                <div>
                  <span className={styles.dot}></span>
                  เพื่อให้สอดคล้องกับพระราชบัญญัติคุ้มครองข้อมูลส่วนบุคคล พ.ศ.
                  2562 หรือหลักกฎหมายอื่น ๆ ที่เกี่ยวข้อง
                </div>
                <div>
                  ซึ่งระบบฯ
                  จะประกาศอย่างชัดเจนให้ประชาชนทราบก่อนการดำเนินการพร้อมทั้งขอความยินยอม
                  จากประชาชนอีกครั้งหากจำเป็น
                  ปัจจุบันนโยบายการคุ้มครองข้อมูลส่วนบุคคลของประชาชนถูกทบทวน
                  ครั้งล่าสุดเมื่อวันที่ 10 พฤศจิกายน 2566
                </div>
                <br />
                <div>12. การรักษาความปลอดภัยของข้อมูลส่วนบุคคลของประชาชน</div>
                <div>
                  ระบบแพลตฟอร์มดิจิทัล “ผูกพันธุ์”
                  ได้มีการออกแบบและพัฒนาโดยตระหนักและให้ความสำคัญ
                  กับการรักษาความปลอดภัยของข้อมูลในทุกกระบวนการ
                  เพื่อปกป้องข้อมูลของประชาชนจากการทำลาย
                  หรือบุกรุกจากผู้ไม่หวังดีหรือผู้ไม่มีสิทธิในการเข้าถึงข้อมูล
                  มีระบบการลงทะเบียนด้วย e-KYC และทำการเข้ารหัสข้อมูล (Data
                  Encryption)
                  ซึ่งทำให้ผู้ที่ดักจับข้อมูลไม่สามารถนำข้อมูลไปใช้ต่อได้
                </div>
                <div>
                  ข้อมูลส่วนบุคคลในระบบแพลตฟอร์มดิจิทัล “ผูกพันธุ์”
                  จะถูกปกป้องอย่างเคร่งครัด
                  จึงทำให้การใช้งานของข้อมูลในระบบดังกล่าว
                  เป็นไปตามข้อกำหนดทางกฎหมายที่เกี่ยวข้อง ทั้งนี้ แม้ว่าระบบฯ
                  ได้มีการออกแบบและพัฒนาเพื่อรักษาความปลอดภัยเป็นอย่างดีที่สุดก็ตาม
                  ระบบฯ ไม่สามารถปกป้องข้อมูล ของประชาชนได้อย่างเด็ดขาด ดังนั้น
                  ประชาชนควรตระหนักเรื่องการรักษาความปลอดภัย
                  และดูแลอุปกรณ์ของประชาชนเป็นอย่างดีเช่นเดียวกัน
                </div>
                <br />
                <div>13. การจำกัดความรับผิดชอบ</div>
                <div>
                  ทางระบบแพลตฟอร์มดิจิทัล “ผูกพันธุ์”
                  ขอสงวนสิทธิที่จะไม่รับผิดชอบต่อความเสียหาย ค่าใช้จ่าย
                  ความสูญเสียที่อาจเกิดขึ้นจากการดำเนินการของโครงการฯ
                  ทั้งทางตรงและทางอ้อม รวมถึงความถูกต้องแม่นยำของข้อมูล
                  ความล่าช้าในการโอนถ่ายข้อมูล ระยะเวลาในการเปิดเผยข้อมูล
                  เหตุขัดข้องหรืออุปสรรคของการเชื่อมต่อ ความผิดพลาดในการแสดงผล
                  ความเสถียรของระบบฯ และไวรัสคอมพิวเตอร์จากการใช้งานระบบฯ
                </div>
                <br />
                <div>14. ช่องทางการติดต่อ</div>
                <div>
                  หากประชาชนประสงค์จะติดต่อ หรือมีข้อสงสัย
                  หรือต้องการสอบถามข้อมูลเกี่ยวกับรายละเอียด การเก็บรวบรวม ใช้
                  และ/หรือเปิดเผยข้อมูลส่วนบุคคล
                  รวมถึงสิทธิของประชาชนนโยบายฉบับนี้
                  หรือต้องการยกเลิกการให้ความยินยอมในการเก็บรวบรวม ใช้
                  และ/หรือเปิดเผยข้อมูลส่วนบุคคล
                  หรือกรณีที่พบว่ามีการใช้ข้อมูลส่วนบุคคลของประชาชนไปในทางที่ไม่ชอบ
                  ประชาชนสามารถติดต่อสำนักงาน ทางช่องทางดังต่อไปนี้
                </div>
                <br />
                <div>
                  สถาบันชีววิทยาศาสตร์ทางการแพทย์ กรมวิทยาศาสตร์การแพทย์
                </div>
                <div>
                  สถานที่ติดต่อ: 88/7 ซอยบำราศนราดูร ถ.ติวานนท์ ต.ตลาดขวัญ
                  อ.เมือง จ.นนทบุรี 11000
                </div>
                <div>เวลาทำการปกติ: วันจันทร์ถึงศุกร์ เวลา 8:30 – 16:30 น.</div>
                <div>เว็บไซต์: https://phukphan.dmsc.moph.go.th/</div>
                <br />

                <div>ติดต่อสอบถาม :</div>

                <div style={{ fontWeight: 700 }}>นางสาวพรนภัส อยู่นุช</div>
                <div>อีเมลล์: pornnapat.y@dmsc.mail.go.th</div>
                <div>หมายเลขโทรศัพท์: 0-2589-9850 ถึง 8 ต่อ 98096</div>

                <div style={{ fontWeight: 700 }}>นายพนาพัฒน์ ไพเราะ</div>
                <div>อีเมลล์: panapat.p@dmsc.mail.go.th</div>
                <div>หมายเลขโทรศัพท์: 0-2951-0000 ต่อ 99394</div>

                <div style={{ fontWeight: 700 }}>นางสาวนภัชชา ถาวงศ์</div>
                <div>อีเมลล์: penpitcha.t@dmsc.mail.go.th</div>
                <div>หมายเลขโทรศัพท์: 0-2589-9850 ถึง 8 ต่อ 98096</div>

                <div style={{ fontWeight: 700 }}>นายอาคม สาลี</div>
                <div>อีเมลล์: arkom.s@dmsc.mail.go.th</div>
                <div>หมายเลขโทรศัพท์: 0-2951-0000 ต่อ 99460</div>
              </div>
            </div>
          ) : (
            <div className={styles.card}>
              <div className={styles.title}>สำหรับประชาชน</div>
              <br />
              <div className={styles.detail}>
                <div>
                  ประชาชนตกลงใช้บริการของระบบแพลตฟอร์มดิจิทัล “ผูกพันธุ์”
                  ของกระทรวงสาธารณะสุข ตามรายละเอียดการให้บริการที่ระบบฯ กำหนด
                  โดยยอมรับและตกลงที่จะผูกพัน
                  และปฏิบัติตามข้อกำหนดและเงื่อนไขการใช้บริการ ดังต่อไปนี้
                </div>
                <div>
                  <br />
                </div>
                <div>1. คำนิยาม</div>
                <div>
                  1.1 “ระบบแพลตฟอร์มดิจิทัล” หรือ “Digital Platform” ผูกพันธุ์
                  (ระบบฯ) หมายความว่า บริการดิจิทัลภาครัฐที่พัฒนา
                  หรือจัดหาและให้บริการ โดยกรมวิทยาศาสตร์การแพทย์
                  โดยมีวัตถุประสงค์ให้ประชาชน บุคลาการทางการแพทย์
                  สามารถเข้าถึงข้อมูลพันธุกรรม ได้แก่
                  ผลการตรวจทางเภสัชพันธุศาสตร์ เป็นต้น โดยระบบแพลตฟอร์มดิจิทัล
                  “ผูกพันธุ์” แบ่งการใช้งานออกเป็น 2 ระบบ ได้แก่
                </div>
                <div>
                  <span className={styles.dot}></span>
                  “แอปพลิเคชัน” หรือ “Application” ผูกพันธุ์ หมายความว่า
                  แอปพลิเคชัน “ผูกพันธุ์” ตลอดจนโปรแกรมคอมพิวเตอร์ ชุดคำสั่ง
                  หรือแอปพลิเคชันอื่น ๆ ที่ต้องใช้หรืออาจใช้ร่วมกัน
                  หรือเกี่ยวเนื่องกันกับแอปพลิเคชันดังกล่าว เพื่อการใช้บริการ
                  “ผูกพันธุ์” ไม่ว่าจะใช้งานผ่านโทรศัพท์มือถือ แท็บเล็ต เว็บ
                  หรือผ่านอุปกรณ์อื่นใดก็ตาม ทั้งนี้ ในกรณีที่ แอปพลิเคชัน
                  “ผูกพันธุ์”
                  เปลี่ยนชื่อเป็นอย่างอื่นหรือมีแอปพลิเคชันอื่นรวมอยู่ด้วย
                  ให้หมายความรวมถึงแอปพลิเคชันนั้นด้วย
                </div>
                <div>
                  <span className={styles.dot}></span>
                  “เว็บไซต์” หรือ “website” ผูกพันธุ์ หมายความว่า เว็บไซต์
                  “ผูกพันธุ์” ตลอดจนหน้าเว็บเพจที่ทำขึ้นเพื่อนำเสนอข้อมูลต่าง ๆ
                  ผ่านทางคอมพิวเตอร์ และอินเทอร์เน็ต
                  โดยมีหลายหน้าที่เชื่อมโยงเข้ากับไฮเปอร์ลิงก์
                  เพื่อให้สามารถเปิดไปยังหน้าเพจต่าง ๆ และถูกจัดเก็บไว้ใน www.
                  (เวิลด์ไวด์เว็บ) โดยเว็บไซต์ผูกพันธุ์ หรือ
                  https://phukphan.dmsc.moph.go.th/ มีไว้เพื่อให้ประชาชน
                  บุคลากรทางการแพทย์ สามารถเข้าถึงข้อมูลพันธุกรรมได้
                  นอกจากนี้ยังให้เจ้าหน้าที่ห้องปฏิบัติการสามารถเปิดห้องปฏิบัติการของตนเองและสามารถรายงานผลการตรวจทางพันธุกรรมได้
                </div>
                <div>
                  1.2 “ข้อมูลส่วนบุคคล” หมายความว่า ข้อมูลส่วนตัว หรือ
                  ข้อมูลเกี่ยวกับผู้ใช้บริการ
                  ซึ่งทำให้สามารถระบุตัวตนของผู้ใช้บริการได้ไม่ว่าทางตรงหรือทางอ้อม
                  ซึ่งรวมถึงข้อมูลทั่วไปของผู้ใช้บริการ ข้อมูลที่ใช้ยืนยันตัวตน
                  ข้อมูลชีวมาตรหรือ biometrics (เช่น ลายนิ้วมือ ใบหน้า เป็นต้น)
                  ข้อมูลสุขภาพ และข้อมูลส่วนบุคคลอื่นใดเกี่ยวกับผู้ใช้บริการ
                  ตามกฎหมายว่าด้วยการคุ้มครองข้อมูลส่วนบุคคล ทั้งนี้
                  ไม่รวมถึงข้อมูลเกี่ยวกับผู้ใช้บริการ
                  ในกรณีที่ผู้ใช้บริการถึงแก่กรรม และไม่รวมถึงข้อมูลทางสถิติ
                  หรือข้อมูลที่ไม่สามารถระบุตัวบุคคลที่เป็นเจ้าของข้อมูลส่วนบุคคลได้
                  ซึ่งไม่ถือเป็นข้อมูลส่วนบุคคล
                  ตามกฎหมายว่าด้วยการคุ้มครองข้อมูลส่วนบุคคล
                </div>
                <div>
                  1.3 “ข้อมูลสุขภาพ” หมายความว่า
                  ข้อมูลส่วนบุคคลของผู้ใช้บริการที่มีเนื้อหาเกี่ยวกับสุขภาพ
                  ได้แก่ ข้อมูลการแพ้ยา ข้อมูลโรควินิจฉัย ข้อมูลการจ่ายยา
                  ข้อมูลวัคซีน ข้อมูลหัตถการ ข้อมูลค่าผลตรวจ ทางการแพทย์
                  ข้อมูลผลตรวจห้องปฏิบัติและผลสรุปภาพถ่ายทางการแพทย์
                  ข้อมูลสุขภาพละเอียดอ่อน เช่น ข้อมูลพันธุกรรม เป็นต้น
                  และข้อมูลการเข้ารับบริการการรักษาพยาบาล
                  รวมไปถึงข้อมูลสุขภาพอื่น ๆ ที่อาจมีเพิ่มเติมในอนาคต
                </div>
                <div>
                  1.4 “ผู้ใช้บริการ” หมายความว่า ผู้ใช้งาน ระบบแพลตฟอร์มดิจิทัล
                  “ผูกพันธุ์” แบ่งการใช้งานตามระบบฯ และบทบาทดังต่อไปนี้
                </div>
                <div>
                  <span className={styles.dot}></span>
                  “ประชาชน” หมายความว่า ผู้ป่วย หรือ บุคคลทั่วไป
                  ที่เข้าใช้งานระบบแพลตฟอร์มดิจิทัล “ผูกพันธุ์”
                </div>
                <div>
                  <span className={styles.dot}></span>
                  “บุคลากรทางการแพทย์” หมายความว่า ผู้ประกอบวิชาชีพทางการแพทย์
                  ได้แก่ แพทย์ เภสัชกรพยาบาล เทคนิคการแพทย์ กายภาพบำบัด
                  แพทย์แผนไทย นักสาธารณสุขชุมชน รวมทั้ง
                  ผู้ที่มีหน้าที่ในการดูแลรักษาผู้ป่วยในด้านอื่น ๆ
                </div>
                <div>
                  <span className={styles.dot}></span>
                  “ผู้ปฏิบัติงานในห้องปฏิบัติการ” หมายความว่า
                  ผู้มีหน้าที่รับผิดชอบในการดำเนินการวิเคราะห์
                  ผลการตรวจทางพันธุกรรมที่โรงพยาบาลได้ทำการส่งตัวอย่างมาที่กรมวิทยาศาสตร์การแพทย์
                  ได้แก่ นักเทคนิคการแพทย์ และ นักวิทยาศาสตร์การแพทย์
                </div>
                <div>
                  1.5 “โรงพยาบาล” หมายความว่า
                  สถานที่รวมตลอดถึงยานพาหนะซึ่งจัดไว้เพื่อการประกอบโรคศิลปะ
                  ตามกฎหมายว่าด้วยการประกอบโรคศิลปะ
                  การประกอบวิชาชีพเวชกรรมตามกฎหมายว่าด้วยวิชาชีพเวชกรรม
                  การประกอบวิชาชีพการพยาบาลและการผดุงครรภ์ตามกฎหมายว่าด้วยวิชาชีพ
                  การพยาบาลและการผดุงครรภ์
                  การประกอบวิชาชีพทันตกรรมตามกฎหมายว่าด้วยวิชาชีพทันตกรรม
                  เทคนิคการแพทย์ตามกฎหมายว่าด้วยวิชาชีพเทคนิค การแพทย์
                  การประกอบวิชาชีพการแพทย์แผนไทยและการประกอบวิชาชีพการแพทย์แผนไทยประยุกต์ตามกฎหมายว่าด้วยวิชาชีพการแพทย์แผนไทย
                  หรือการประกอบวิชาชีพทางการแพทย์และสาธารณสุขอื่นตามกฎหมายว่าด้วยการนั้น
                </div>
                <div>
                  1.6 “ระบบสารสนเทศโรงพยาบาล” หรือ “Hospital Information System:
                  HIS” หมายความว่า ระบบการจัดการโรงพยาบาลที่ช่วยในการจัดเก็บ
                  จัดการ และส่งต่อข้อมูลจำนวนมากทั้งจากภายใน และภายนอกโรงพยาบาล
                  ให้ผู้บริหารสามารถจัดสรรทรัพยากรต่างๆ
                  ของโรงพยาบาลได้อย่างคุ้มค่า
                  เพิ่มประสิทธิภาพของการทำงานและการรักษาผู้ป่วยได้อย่างรวดเร็ว
                </div>
                <div>
                  1.7 “ระบบรับ-ส่งตัวอย่างเพื่อตรวจวิเคราะห์” หรือ “iLAB PLUS”
                  หมายความว่า ระบบรับ-ส่งตัวอย่าง
                  เพื่อตรวจวิเคราะห์กรมวิทยาศาสตร์การแพทย์ กระทรวงสาธารณสุข
                  โดยผู้ใช้จะแบ่งเป็นสำหรับหน่วยงานผู้ขอรับบริการ
                  และสำหรับเจ้าหน้าที่กรมวิทยาศาสตร์การแพทย์
                  ซึ่งผู้ขอรับบริการเป็นผู้ส่งตัวอย่างให้กับห้องปฏิบัติการของกรมวิทยาศาสตร์การแพทย์
                  จากนั้นจะทำการวิเคราะห์ผลทางห้องปฏิบัติการ
                  เมื่อวิเคราะห์ผลเรียบร้อยแล้วจะทำการออกรายงานผล
                  รับรองผลการตรวจวิเคราะห์
                  และส่งผลการตรวจวิเคราะห์กลับให้ทางผู้ขอรับบริการนั้น ๆ
                </div>
                <div>
                  1.8 “ผู้ให้บริการ”
                  หมายความหน่วยงานที่มีหน้าที่และ/หรือได้รับมอบหมายในการจัดทำ
                  พัฒนา และให้บริการระบบแพลตฟอร์มดิจิทัล“ผูกพันธุ์”
                </div>
                <div>
                  <br />
                </div>
                <div>บทนำ</div>
                <div>
                  ระบบแพลตฟอร์มดิจิทัล “ผูกพันธุ์” (ระบบฯ) คือ
                  แพลตฟอร์มดิจิทัลที่มีจุดประสงค์เพื่อรวบรวมข้อมูลพันธุกรรม
                  ที่กรมวิทยาศาสตร์การแพทย์และห้องปฏิบัติการอื่น ๆ ให้บริการ
                  และให้ผู้ใช้บริการงานสามารถเข้าถึงผลการตรวจผ่านช่องทางต่าง ๆ
                  เช่น เว็บไซต์และแอปพลิเคชัน “ผูกพันธุ์”
                  ระเบียนสุขภาพอิเล็กทรอนิกส์ส่วนบุคคล (Personal Health Record:
                  PHR) และระบบสารสนเทศของโรงพยาบาล (Hospital Information System:
                  HIS) เป็นต้น โดยมีผู้ใช้บริการงานระบบ และบทบาทที่เกี่ยวข้อง
                  ดังนี้
                </div>
                <div>
                  1. ประชาชน
                  เข้าถึงและแสดงผลการตรวจของตนเองให้บุคลาการทางการแพทย์ที่รักษา
                </div>
                <div>
                  2. บุคลาการทางการแพทย์ เข้าถึงและใช้ผลการตรวจของประชาชน
                  ประกอบการพิจารณาวินิจฉัย ป้องกัน และรักษาโรคที่เฉพาะบุคคล
                  ส่งเสริมการรักษาแบบการแพทย์แม่นยำ (Precision Medicine)
                </div>
                <div>
                  3. ผู้ปฏิบัติงานในห้องปฏิบัติการ ได้แก่ นักเทคนิคการแพทย์ และ
                  นักวิทยาศาสตร์การแพทย์ ลงข้อมูล
                  ผลการตรวจในระบบแพลตฟอร์มดิจิทัล “ผูกพันธุ์”
                </div>
                <div>
                  ระบบฯ ถูกออกแบบให้รองรับการเชื่อมต่อ PHR ต่าง ๆ
                  ทำให้ประชาชนมีทางเลือกในการเข้าถึงข้อมูลพันธุกรรมมากขึ้น
                  และการเชื่อมโยงข้อมูลกับระบบ HIS
                  ทำให้สามารถรับ-ส่งข้อมูลพันธุกรรมเข้าสู่ระบบของโรงพยาบาลได้
                  ดังนั้น เพื่อให้ผู้ให้บริการระบบฯ สามารถให้บริการฯ
                  แก่ผู้ใช้บริการได้
                  ผู้ใช้บริการจะต้องแสดงเจตนาให้กรมวิทยาศาสตร์ กระทรวงสาธารณสุข
                  และผู้ให้บริการระบบฯ
                  ด้วยการตกลงยอมรับข้อกำหนดและเงื่อนไขการใช้บริการสำหรับประชาชน
                </div>
                <div>
                  ผู้ใช้บริการตกลงที่จะให้กรมวิทยาศาสตร์ กระทรวงสาธารณสุข
                  เก็บรวมรวม ใช้ จัดการ และเปิดเผยข้อมูลส่วนบุคคล
                  ของผู้ใช้บริการ รวมทั้งข้อมูลสุขภาพ
                  รวมทั้งยินยอมให้ผู้ให้บริการระบบฯ และโรงพยาบาลที่เข้าร่วมระบบฯ
                  เก็บรวบรวม ใช้ จัดการ
                  และเปิดเผยข้อมูลดังกล่าวเพื่อการดำเนินการตามวัตถุประสงค์ของระบบฯ
                </div>
                <div>
                  <br />
                </div>
                <div>
                  การตกลงยอมรับข้อกำหนดและเงื่อนไขการใช้บริการสำหรับประชาชน
                </div>
                <div>
                  1. ผู้ใช้บริการจะต้องใช้บริการ
                  ตามข้อกำหนดที่ได้ระบุไว้ในเอกสารข้อกำหนดและเงื่อนไขการใช้บริการ
                  สำหรับประชาชน ฉบับนี้เท่านั้น
                  โดยจะไม่สามารถใช้บริการได้เว้นเสียแต่ว่าผู้ใช้บริการจะทำการตกลงยอมรับข้อกำหนดและเงื่อนไขการใช้บริการสำหรับประชาชน
                </div>
                <div>
                  2. การเข้าใช้งานระบบแพลตฟอร์มดิจิทัล “ผูกพันธุ์”
                  ถือเป็นการแสดงเจตนาว่าผู้ใช้บริการได้ทำความเข้าใจ
                  และตกลงยอมรับข้อกำหนดและเงื่อนไขการใช้บริการสำหรับประชาชน
                  อย่างครบถ้วนสมบูรณ์แล้ว
                </div>
                <div>
                  3. การตกลงยอมรับข้อกำหนดและเงื่อนไขการใช้บริการสำหรับประชาชน
                  จะมีผลสมบูรณ์ตามกฎหมาย
                </div>
                <div>
                  <br />
                </div>
                <div>การแก้ไขข้อกำหนดและเงื่อนไขการใช้บริการสำหรับประชาชน</div>
                <div>
                  ผู้ให้บริการระบบดิจิทัลแพลตฟอร์ม “ผูกพันธุ์”
                  อาจมีการแก้ไขเปลี่ยนแปลงข้อกำหนดและเงื่อนไข
                  การใช้บริการสำหรับประชาชน ตามเหตุอันเห็นสมควร
                  โดยไม่จำเป็นต้องแจ้งให้ผู้ใช้บริการทราบล่วงหน้า ยกเว้น
                  มีเหตุที่อาจเกิดผลกระทบต่อข้อมูลส่วนบุคคล
                  การแก้ไขเปลี่ยนแปลงจะมีผลบังคับใช้เมื่อมีการประกาศ
                  ข้อกำหนดและเงื่อนไขการใช้บริการสำหรับประชาชน
                  ที่แก้ไขไว้บนระบบฯ
                  ผู้ใช้บริการจะต้องตกลงยอมรับการเปลี่ยนแปลงของข้อกำหนดและเงื่อนไขการใช้บริการสำหรับประชาชน
                  เพื่อใช้บริการฯ หลังจากมีการเปลี่ยนแปลงข้อกำหนด
                  และเงื่อนไขการใช้บริการสำหรับประชาชน
                  ผู้ใช้บริการควรตรวจสอบและทำความเข้าใจข้อกำหนดและเงื่อนไขการใช้บริการสำหรับประชาชน
                  ที่มีการเปลี่ยนแปลงอย่างถี่ถ้วนระมัดระวัง
                  และหากผู้ใช้บริการไม่ประสงค์ที่จะใช้งานระบบฯ ต่อไป
                  ภายใต้ข้อกำหนดและเงื่อนไขการใช้บริการสำหรับประชาชน ฉบับใหม่
                  ผู้ใช้บริการสามารถดำเนินการยกเลิกการใช้งานระบบฯ ได้ ปัจจุบัน
                  ข้อกำหนดและเงื่อนไขการใช้บริการสำหรับประชาชน
                  ถูกทบทวนครั้งล่าสุดเมื่อวันที่ 10 พฤศจิกายน 2566
                </div>
                <div>
                  <br />
                </div>
                <div>การคุ้มครองข้อมูลส่วนบุคคล</div>
                <div>
                  1. ผู้ให้บริการระบบฯ
                  ยึดมั่นและให้ความสำคัญกับการรักษาความเป็นส่วนตัวของผู้ใช้บริการ
                  โดยจะจัดให้มีการคุ้มครองข้อมูลส่วนบุคคลของผู้ใช้บริการงานตามเอกสารนโยบายการคุ้มครองข้อมูลส่วนบุคคลของประชาชน
                </div>
                <div>
                  2. ผู้ให้บริการระบบฯ
                  จะกระทำการโดยระมัดระวังอย่างสูงสุดเพื่อปกป้องข้อมูลของผู้ใช้บริการจากการถูกทำลาย
                  หรือบุกรุกโดยผู้ไม่มีสิทธิ์ในการเข้าถึงข้อมูล อย่างไรก็ตาม
                  ในปัจจุบันผู้ให้บริการระบบฯ ยังไม่สามารถรับประกัน
                  การปกป้องข้อมูลได้อย่างเด็ดขาดจากการถูกทำลายหรือเข้าถึงจากบุคลากรทางการแพทย์หรือบุคคลภายนอก
                  ที่ไม่เกี่ยวข้องหรือผู้ไม่หวังดี
                </div>
                <div>
                  <br />
                </div>
                <div>คุณสมบัติการใช้งานระบบแพลตฟอร์มดิจิทัล “ผูกพันธุ์”</div>
                <div>
                  ผู้ใช้บริการสามารถค้นหารายละเอียดของบริการฯ
                  ได้ผ่านเว็บไซต์หรือแอปพลิเคชันของระบบฯ
                  หรือในหนังสือแสดงความยินยอมเข้าร่วมระบบฯ
                  คุณสมบัติการใช้งานระบบแพลตฟอร์มดิจิทัล “ผูกพันธุ์”
                  ที่เป็นส่วนหนึ่งของบริการ ประกอบด้วยคุณสมบัติดังนี้
                  ซึ่งผู้ใช้บริการสามารถใช้งานได้ตลอด 24 ชั่วโมง
                  (ยกเว้นกรณีที่ระบบฯ
                  หยุดให้บริการเป็นการชั่วคราวเพื่อบำรุงรักษาระบบฯ หรือ
                  กรณีเกิดเหตุขัดข้อง) ทั้งนี้ ผู้ให้บริการระบบฯ
                  อาจเพิ่มเติมคุณสมบัติอื่น
                  หรือเปลี่ยนแปลงหรือยกเลิกคุณสมบัติเหล่านี้ได้ในอนาคต
                </div>
                <div>- การลงทะเบียนใช้งานระบบฯ</div>
                <div>- การถอนการลงทะเบียนใช้งานระบบฯ</div>
                <div>- การเลือกโรงพยาบาลสำหรับการรับ-ส่งข้อมูลเข้าสู่ระบบฯ</div>
                <div>
                  - การยกเลิกโรงพยาบาลสำหรับการรับ-ส่งข้อมูลเข้าสู่ระบบฯ
                </div>
                <div>
                  - การอนุญาตให้บุคลากรทางการแพทย์เข้าถึงข้อมูลส่วนบุคคลของตนเอง
                </div>
                <div>
                  -
                  การเพิกถอนบุคลากรทางการแพทย์ที่สามารถเข้าถึงข้อมูลส่วนบุคคลของตนเอง
                </div>
                <div>
                  <br />
                </div>
                <div>บัญชี การลงทะเบียน และการถอนการลงทะเบียน</div>
                <div>
                  1.
                  ผู้ใช้บริการจะต้องสร้างบัญชีโดยการลงทะเบียนผ่านทางแอปพลิเคชันเพื่อเข้าใช้บริการฯ
                  ในการลงทะเบียน
                  ผู้ใช้บริการจะต้องเลือกสถานพยาบาลที่ผู้ใช้บริการยินยอมให้นำข้อมูลสุขภาพเข้าสู่ระบบฯ
                  จากรายชื่อสถานพยาบาลที่ระบบฯ กำหนดให้เท่านั้น
                  โดยข้อมูลสุขภาพผู้ใช้บริการจะถูกนำเข้าระบบฯ โดยปกติทุก 24*
                  ชั่วโมง หากความยินยอมผู้ใช้บริการไม่มีเปลี่ยนแปลง
                  แพทย์จากสถานพยาบาลที่เข้าร่วมโครงการจะสามารถเข้าถึงข้อมูลสุขภาพของผู้ใช้บริการได้ทันทีต่อเมื่อกำลังรักษาผู้ใช้บริการ
                  หรือจะต้องได้รับความยินยอมเป็นรายครั้งจากผู้ใช้บริการ
                  โดยสถานพยาบาลที่นำเข้าข้อมูลเป็นผู้กำหนดขั้นตอนดังกล่าว
                  ทั้งนี้ ผู้ให้บริการระบบฯ
                  ไม่สามารถกำกับแพทย์ในการเข้าถึงข้อมูลสุขภาพของผู้ใช้บริการผ่านระบบฯ
                  ตามนโยบายข้างต้นได้อย่างเด็ดขาด
                  ผู้ใช้บริการตกลงที่จะใช้บริการฯ ด้วยข้อจำกัดดังกล่าว
                  และจะไม่สามารถใช้บริการฯ ได้
                  หากผู้ใช้บริการลงทะเบียนด้วยข้อมูลที่ผิดพลาด
                </div>
                <div>
                  *หมายเหตุ: ผู้ให้บริการระบบฯ
                  ไม่สามารถรับรองได้ว่าข้อมูลของผู้ใช้บริการจะพร้อมสำหรับให้บริการฯ
                  ภายในระยะเวลาที่กำหนด
                </div>
                <div>
                  2. ผู้ให้บริการระบบฯ ถือว่าการใช้บริการฯ หรือกิจกรรมใด ๆ
                  ที่ดำเนินการภายใต้บัญชีดังกล่าวเป็นกิจกรรมที่ผู้ใช้บริการผู้เป็นเจ้าของบัญชีได้ดำเนินการด้วยตนเองทั้งสิ้น
                  ทั้งนี้
                  เว้นแต่จะมีหลักฐานที่สามารถพิสูจน์ได้ว่าเกิดขึ้นโดยผู้ใช้บริการไม่รับรู้และไม่ยินยอม
                  หรือเกิดจากความผิดพลาดของระบบฯ หรือเหตุสุดวิสัย
                </div>
                <div>
                  3. ผู้ให้บริการระบบฯ มีสิทธิในการระงับการเข้าใช้งาน
                  หรือเพิกถอนบัญชีในระบบฯ
                  ของผู้ใช้บริการได้โดยไม่จำเป็นต้องแจ้งให้ทราบล่วงหน้า
                  หากทางผู้ให้บริการระบบฯ
                  ตรวจสอบพบว่าผู้ใช้บริการได้ละเมิดหรือกำลังกระทำการอันเป็นการละเมิดข้อกำหนดและเงื่อนไขฯ
                </div>
                <div>
                  4. ผู้ใช้บริการสามารถถอนการลงทะเบียนใช้งานระบบฯ ได้
                  โดยแพทย์จะไม่สามารถเข้าถึงข้อมูลสุขภาพทั้งหมดของผู้ใช้บริการที่อยู่ในระบบฯ
                  ได้อีกต่อไป
                  ผู้ใช้บริการตกลงว่าการเพิกถอนการลงทะเบียนและหยุดการใช้บริการฯ
                  เป็นการแก้ปัญหาความไม่พึงพอใจใด ๆ กับบริการฯ ทั้งนี้
                  การเปลี่ยนแปลงสถานะการเข้าร่วมโครงการของผูใช้
                  รวมกับการเลือกและยกเลิกสถานพยาบาลที่ให้ส่งข้อมูลเข้าสู่ระบบฯ
                  สามารถทำได้มากสุดวันละ 5 ครั้งเท่านั้น
                  หากผู้ใช้บริการประสงค์ที่จะถอนการลงทะเบียน
                  แต่ได้ทำธุรกรรมครบจำนวนดังกล่าว
                  ผู้ใช้บริการจะสามารถถอนการลงทะเบียนได้ในวันถัดไป
                </div>
                <div>
                  5. ผู้ใช้บริการตกลงว่าระบบฯ และผู้ให้บริการระบบฯ
                  ไม่มีภาระผูกพันหรือความรับผิดต่อเนื้อหา บริการ หรือกรณีใด ๆ
                  ที่เกิดจากหรือเกี่ยวข้องกับแอปพลิเคชันของบุคคลที่สาม
                </div>
                <div>
                  6. ผู้ใช้บริการตกลงว่า
                  ในขณะที่ความสัมพันธ์ระหว่างผู้ใช้บริการกับแอปพลิเคชันของบุคคลที่สาม
                  อาจถูกควบคุมโดยข้อตกลงกับบุคคลที่สามนั้น
                  การถอนการติดตั้งและ/หรือหยุดใช้งานแอปพลิเคชันของบุคคลที่สามที่มีความเกี่ยวข้องกับระบบฯ
                  เป็นการแก้ปัญหาความไม่พึงพอใจในตัวแอปพลิเคชันหรือเนื้อหาในแอปพลิเคชันของบุคคลที่สาม
                </div>
                <div>การให้บริการของระบบแพลตฟอร์มดิจิทัล “ผูกพันธุ์”</div>
                <div>
                  1.
                  ผู้ใช้บริการสามารถสร้างบัญชีผู้ใช้โดยการลงทะเบียนผ่านเว็บไซต์หรือแอปพลิเคชัน
                  ดังต่อไปนี้
                </div>
                <div>- เว็บไซต์หรือแอปพลิเคชัน “ผูกพันธุ์”</div>
                <div>- แอปพลิเคชัน “หมอพร้อม”</div>
                <div>- แอปพลิเคชัน “OnesID”</div>
                <div>- แอปพลิเคชัน “ThaiD”</div>
                <div>
                  และจำเป็นต้องพิสูจน์ตัวตนก่อน
                  ถึงจะสามารถเข้าถึงข้อมูลส่วนตัวของตนเองได้
                </div>
                <div>
                  2. ผู้ใช้บริการสามารถเข้าถึงข้อมูลพันธุกรรมของตนเองได้
                </div>
                <div>
                  3.
                  ผู้ใช้บริการสามารถเลือกแสดงความยินยอมให้บุคลากรทางการแพทย์เข้าถึงข้อมูลส่วนบุคคลของตนเองได้
                  โดยมีรูปแบบดังต่อไปนี้
                </div>
                <div>
                  - การแสดงความยินยอมรายครั้ง ผ่านระบบแพลตฟอร์มดิจิทัล
                  “ผูกพันธุ์”
                  เมื่อบุคลากรทางการแพทย์กดขออนุญาตเข้าถึงข้อมูลพันธุกรรรมของผู้ใช้บริการ
                  หากผู้ใช้บริการเลือกให้เข้าถึงข้อมูลดังกล่าว แบบรายครั้ง
                  ผู้ใช้บริการจำเป็นจะต้องกดยินยอมให้เข้าถึงข้อมูลดังกล่าวทุกครั้งที่มีการขอเข้าถึง
                  แม้ว่าบุคลากรทางการแพทย์ผู้นั้นจะเป็นคนเดียวกันกับผู้ที่ขอเข้าถึงข้อมูลครั้งแรกก็ตาม
                </div>
                <div>
                  - การแสดงความยินยอมครั้งเดียว ผ่านระบบแพลตฟอร์มดิจิทัล
                  “ผูกพันธุ์”
                  เมื่อบุคลากรทางการแพทย์ขออนุญาตเข้าถึงข้อมูลพันธุกรรรมของผู้ใช้บริการ
                  หากผู้ใช้บริการเลือกให้เข้าถึงข้อมูลดังกล่าว
                  แบบครั้งเดียวจะเป็นการอนุญาตให้บุลคาการทางการแพทย์คนดังกล่าวสามารถเข้าถึง
                  ข้อมูลพันธุกรรรมของผู้ใช้บริการได้ตลอดจนกว่าประชาชนจะยกเลิกความยินยอม
                </div>
                <div>
                  - การแสดงความยินยอมรายโรงพยาบาล
                  เมื่อประชาชนเข้ารับการรักษาในโรงพยาบาลนั้น ๆ
                  ผู้ใช้บริการมีสิทธิ์ที่จะอนุญาตให้โรงพยาบาลเข้าถึงและนำเข้าข้อมูลพันธุกรรรมในระบบสารสนเทศโรงพยาบาลกับระบบแพลตฟอร์มดิจิทัล
                  “ผูกพันธุ์” หรือไม่อนุญาตก็ได้
                </div>
                <div>
                  4.
                  ผู้ใช้บริการสามารถเข้าถึงรายชื่อแพทย์ที่ตนเองเป็นคนอนุญาตให้เข้าดูข้อมูลพันธุกรรมและสามารถจัดการยกเลิกสิทธิ์การเข้าถึงข้อมูลของบุคลากรทางการแพทย์ได้
                </div>
                <div>
                  5.
                  ผู้ใช้บริการสามารถเลือกโรงพยาบาลสำหรับประชาชนที่ต้องการให้ข้อมูลพันธุกรรมของตนเองไปแสดงในโรงพยาบาลที่ตนเองทำการเลือก
                </div>
                <div>
                  6. ผู้ใช้บริการจะต้องปรับปรุงข้อมูลบัญชี
                  รวมไปถึงข้อมูลส่วนตัวบนบัญชีให้ถูกต้องและเป็นปัจจุบันอยู่ตลอดเวลา
                </div>
                <div>
                  7. ผู้ให้บริการระบบฯ ถือว่าการใช้บริการฯ หรือกิจกรรมใด ๆ
                  ที่ดำเนินการภายใต้บัญชีดังกล่าวเป็นกิจกรรมที่ผู้ใช้บริการผู้เป็นเจ้าของบัญชีได้ดำเนินการด้วยตนเองทั้งสิ้น
                  ทั้งนี้
                  เว้นแต่จะมีหลักฐานที่สามารถพิสูจน์ได้ว่าเกิดขึ้นโดยผู้ใช้บริการไม่รับรู้และไม่ยินยอม
                  หรือเกิดจากความผิดพลาดของระบบฯ หรือเหตุสุดวิสัย
                </div>
                <div>
                  8. ผู้ให้บริการระบบฯ มีสิทธิในการระงับการเข้าใช้งาน
                  หรือเพิกถอนบัญชีในระบบฯ
                  ของผู้ใช้บริการได้โดยไม่จำเป็นต้องแจ้งให้ทราบล่วงหน้า
                  หากทางผู้ให้บริการระบบฯ
                  ตรวจสอบพบว่าผู้ใช้บริการได้ละเมิดหรือกำลังกระทำการอันเป็นการละเมิดข้อกำหนดและเงื่อนไขการใช้บริการสำหรับประชาชน
                </div>
                <div>
                  9.
                  ผู้ใช้บริการสามารถยกเลิกสิทธิ์การเข้าถึงข้อมูลพันธุกรรมของบุคลากรทางการแพทย์ผ่านระบบฯ
                  โดยบุคลากรการแพทย์คนดังกล่าวจะไม่สามารถเข้าถึงข้อมูลพันธุกรรมของผู้ใช้บริการที่อยู่ในระบบฯ
                  ได้อีกต่อไป
                </div>
                <div>
                  10. ผู้ใช้บริการตกลงว่าระบบฯ และผู้ให้บริการระบบฯ
                  ไม่มีภาระผูกพันหรือความรับผิดต่อเนื้อหา บริการ หรือกรณีใด ๆ
                  ที่เกิดจากหรือเกี่ยวข้องกับระบบฯ ของบุคคลที่สาม
                </div>
                <div>
                  11. ผู้ใช้บริการตกลงว่า
                  ในขณะที่ความสัมพันธ์ระหว่างผู้ใช้บริการกับระบบฯ ของบุคคลที่สาม
                  อาจถูกควบคุมโดยข้อตกลงกับบุคคลที่สามนั้น
                  การถอนการติดตั้งและ/หรือหยุดใช้งานระบบฯ ของบุคคลที่สาม
                  ที่มีความเกี่ยวข้องกับระบบฯ
                  เป็นการแก้ปัญหาความไม่พึงพอใจในตัวระบบฯ หรือเนื้อหาใน ระบบฯ
                  ของบุคคลที่สาม
                </div>
                <div>
                  12. บัญชีของผู้ใช้แต่ละบัญชีในระบบฯ
                  สงวนไว้เพื่อการใช้งานเฉพาะและโดยผู้เป็นเจ้าของบัญชีแต่เพียงผู้เดียวเท่านั้น
                  ผู้ใช้บริการไม่สามารถโอนสิทธิการใช้งานหรือให้ยืมบัญชีของตนแก่บุคคลอื่นไม่ว่ากรณีใดก็ตาม
                </div>
                <div>
                  13. ผู้ให้บริการระบบฯ ขอสงวนสิทธิ์ในการจำกัดการเข้าถึงบริการฯ
                  ของผู้ใช้บริการตามที่เห็นสมควร
                </div>
                <div>
                  14. ผู้ใช้บริการยอมรับว่า เท่าที่กฎหมายที่เกี่ยวข้องจะอนุญาต
                  การใช้งานและการให้บริการระบบฯ
                  เป็นความเสี่ยงของผู้ใช้บริการแต่เพียงฝ่ายเดียว
                  การให้บริการระบบฯ ถูกจัดทำขึ้น “ตามสภาพ” (as is) และ
                  “ตามที่มี” (as available) โดยอาจมีข้อบกพร่องรวมอยู่ด้วย
                  ผู้ให้บริการระบบฯ ไม่มีการรับประกันโดยนัยใด ๆ ทั้งสิ้น
                </div>
                <div>
                  <br />
                </div>
                <div>
                  การเลือกและยกเลิกโรงพยาบาลที่ให้รับ-ส่งข้อมูลเข้าสู่ระบบแพลตฟอร์มดิจิทัล
                  “ผูกพันธุ์”
                </div>
                <div>
                  ในขั้นตอนการลงทะเบียนระบบแพลตฟอร์มดิจิทัล “ผูกพันธุ์”
                  จะบังคับให้ผู้ใช้บริการทำการยินยอมให้ระบบฯ
                  แลกเปลี่ยนข้อมูลกับระบบสารสนเทศโรงพยาบาลก่อน
                  เมื่อลงทะเบียนเข้าใช้งานสำเร็จ
                  หากผู้ใช้บริการไม่ต้องการให้ระบบฯ
                  แลกเปลี่ยนข้อมูลกับระบบสารสนเทศโรงพยาบาลแล้ว
                  ผู้ใช้บริการสามารถยกเลิกการแลกเปลี่ยนข้อมูลดังกล่าว
                  หรือเลือกเฉพาะโรงพยาบาลที่ผู้ใช้บริการต้องการให้ข้อมูลผลการตรวจของตนเองไปอยู่ในระบบสารสนเทศของโรงพยาบาลที่ทำการเลือกได้
                </div>
                <div>ข้อจำกัด</div>
                <div>
                  ในการใช้บริการฯ ของระบบระบบแพลตฟอร์มดิจิทัล “ผูกพันธุ์”
                  ผู้ใช้บริการจะต้องไม่มีส่วนร่วมในกิจกรรมต่าง ๆ ดังต่อไปนี้
                </div>
                <div>
                  1. กิจกรรมที่เป็นการฝ่าฝืนกฎหมาย คำพิพากษา มติหรือคำสั่งศาล
                  หรือมาตรการทางปกครองที่มีผลผูกพัน ทางกฎหมาย
                </div>
                <div>
                  2.
                  กิจกรรมอื่นใดที่อาจขัดต่อความสงบเรียบร้อยหรือศีลธรรมอันดีงาม
                </div>
                <div>
                  3. กิจกรรมที่เป็นการละเมิดทรัพย์สินทางปัญญา เช่น
                  การละเมิดลิขสิทธิ์ ชื่อเสียง ความเป็นส่วนตัว เป็นต้น
                  และสิทธิอื่นๆ ทั้งหมดของผู้ให้บริการระบบฯ
                  และ/หรือบุคคลภายนอกที่มีการมอบให้ตามกฎหมายหรือสัญญา
                </div>
                <div>
                  4. กิจกรรมที่ส่งเสริมหรือนำไปสู่การเลือกปฏิบัติโดยเชื้อชาติ
                  สัญชาติ เพศ สถานะทางสังคม ถิ่นกำเนิดครอบครัว ลักษณะทางกายภาพ
                  สุขภาพหรือโรคประจำตัว และอื่น ๆ
                  รวมถึงการแสดงออกที่ชักชวนหรือส่งเสริมให้เกิด การฆ่าตัวตาย
                  พฤติกรรมการทำร้ายตัวเองหรือการใช้ยาในทางที่ผิด
                </div>
                <div>
                  5. กิจกรรมที่หลีกเลี่ยงเทคโนโลยีใด ๆ ที่ผู้ให้บริการระบบฯ
                  ผู้ที่ได้รับอนุญาต หรือบุคคลที่สามใด ๆ ใช้เพื่อ
                  ปกป้องเนื้อหาหรือบริการฯ
                </div>
                <div>
                  6. กิจกรรมที่อาจทำให้ผู้อื่นเกิดความเข้าใจผิดเกี่ยวกับระบบฯ
                  บริการของระบบฯ และ/หรือบุคคลภายนอก
                  หรือการจงใจเผยแพร่ข้อมูลเท็จ
                </div>
                <div>
                  7. กิจกรรมที่มีการแลกเปลี่ยนสิทธิในการใช้บริการฯ
                  หรือเข้าถึงเนื้อหาเพียงบางส่วนหรือทั้งหมดเป็นเงินสด
                  ทรัพย์สินหรือผลประโยชน์ใด ๆ
                </div>
                <div>
                  8. กิจกรรมที่มีการใช้บริการฯ เพื่อการซื้อขาย การตลาด โฆษณา
                  การชักชวน การได้มาซึ่งผลประโยชน์ส่วนตน
                  หรือวัตถุประสงค์ทางการค้าอื่น ๆ รวมถึงกิจกรรมที่ใช้บริการฯ
                  เพื่อวัตถุประสงค์ในการคุกคาม หรือหมิ่นประมาท
                  หรือกิจกรรมที่ใช้บริการฯ
                  เพื่อวัตถุประสงค์อื่นใดที่ไม่ใช่จุดประสงค์ที่แท้จริงของการให้บริการระบบฯ
                </div>
                <div>
                  9. กิจกรรมที่นำไปสู่การเก็บรวบรวม การเปิดเผย การทำสำเนา
                  การส่งต่อ การทำซ้ำ หรือการแก้ไข บิดเบือน
                  ข้อมูลส่วนบุคคลซึ่งเป็นเนื้อหาบนระบบฯ รวมไปถึงการทำสำเนา
                  โดยไม่ได้รับความเห็นชอบ
                  จากเจ้าของข้อมูลส่วนบุคคลและ/หรือผู้ให้บริการระบบฯ
                  หรือไม่ชอบด้วยกฎหมาย
                </div>
                <div>
                  10. กิจกรรมที่แทรกแซงเครื่องแม่ข่าย
                  และ/หรือระบบเครือข่ายของระบบฯ กิจกรรมซึ่งเป็นการใช้บริการฯ
                  ในทางที่ผิดด้วยการใช้บ็อท (BOTs) เครื่องมือเพื่อการโกง
                  หรือวิธีการทางเทคนิคใด ๆ
                  กิจกรรมที่ใช้ข้อบกพร่องหรือข้อผิดพลาดของบริการฯ
                  โดยไตร่ตรองไว้ก่อนแล้ว
                </div>
                <div>
                  11. กิจกรรมการตรวจสอบ สแกน หรือทดสอบจุดอ่อนของระบบฯ
                  หรือเครือข่ายใด ๆ
                </div>
                <div>
                  12.
                  กิจกรรมฝ่าฝืนหรือหลีกเลี่ยงการรักษาความปลอดภัยหรือมาตรการตรวจสอบตัวตน
                </div>
                <div>
                  13. กิจกรรมเข้าถึง ก้าวก่าย หรือใช้บริการฯ หรือ เนื้อหาใด ๆ
                  ซึ่งไม่เป็นไปตามขอบเขตการใช้งานของผู้ใช้บริการงาน
                  และวัตถุประสงค์ของระบบฯ
                </div>
                <div>
                  14. กิจกรรมที่ส่งเสริมหรือช่วยเหลือกิจกรรมใด ๆ
                  ที่กล่าวไว้ข้างต้น
                </div>
                <div>
                  15.
                  กิจกรรมที่ขัดแย้งกับข้อกำหนดและเงื่อนไขการใช้บริการสำหรับประชาชน
                  นี้ ตามที่ ผู้ให้บริการระบบฯ กำหนดไว้
                </div>
                <div>
                  16. กิจกรรมอื่น ๆ ที่ผู้ให้บริการระบบฯ เห็นว่าไม่เหมาะสม
                </div>
                <div>
                  <br />
                </div>
                <div>ความรับผิดชอบของผู้ใช้บริการ</div>
                <div>
                  1. ผู้ใช้บริการจะต้องใช้บริการฯ
                  โดยถือเป็นความเสี่ยงของผู้ใช้บริการเอง
                  และจะต้องเป็นผู้รับผิดชอบแต่เพียงผู้เดียวสำหรับการกระทำ/กิจกรรมที่ได้ทำไป
                  รวมถึงผลของการกระทำที่มีต่อบริการฯ นี้ด้วย
                </div>
                <div>
                  2. ข้อมูลการเข้าใช้งานระบบฯ และกิจกรรมใดๆ
                  ที่เกิดขึ้นขณะผู้ใช้เข้าใช้งานระบบฯ
                  เป็นความรับผิดชอบของผู้ใช้เองทั้งหมด
                </div>
                <div>
                  3. ผู้ให้บริการระบบฯ อาจใช้มาตรการที่เห็นว่าจำเป็นและเหมาะสม
                  หากผู้ให้บริการระบบฯ พบว่าผู้ใช้บริการรายใดกำลังใช้บริการฯ
                  ในทางที่ฝ่าฝืนข้อกำหนดและเงื่อนไขการใช้บริการสำหรับประชาชน
                  อย่างไรก็ตาม ผู้ให้บริการระบบฯ
                  จะไม่รับผิดชอบในการแก้ไขหรือป้องกันการฝ่าฝืนดังกล่าว
                </div>
                <div>
                  4. ในกรณีที่การใช้บริการฯ
                  ของผู้ใช้บริการก่อให้เกิดความเสียหายแก่ระบบฯ
                  หรือผู้ให้บริการระบบฯ หรือถูกเรียกเก็บค่าใช้จ่ายใด ๆ
                  (รวมถึงแต่ไม่จำกัดเพียงค่าทนายความ) ทั้งทางตรงและทางอ้อม
                  (รวมถึงแต่ไม่จำกัดเพียงกรณีที่มีบุคคลภายนอกฟ้องร้องเรียกค่าเสียหายจากผู้ให้บริการระบบฯ
                  )
                  อันเนื่องมาจากการที่ผู้ใช้บริการฝ่าฝืนข้อกำหนดและเงื่อนไขการใช้บริการสำหรับประชาชน
                  หรือฝ่าฝืนกฎหมายที่เกี่ยวข้องขณะใช้บริการฯ
                  ผู้ใช้บริการจะต้องทำการรับผิดชอบต่อความเสียหาย/ชดใช้ค่าเสียหายด้วยตนเอง
                  โดยไม่เกี่ยวข้องกับผู้ให้บริการระบบฯ แต่อย่างใด
                  ผู้ใช้บริการรับทราบว่าการชดใช้ค่าเสียหายเพียงอย่างเดียวอาจไม่เพียงพอต่อการเยียวยาความเสียหายอันเกิดจากการฝ่าฝืนกฎหมายและ/หรือละเมิดข้อกำหนดและเงื่อนไขฯ
                  ฉบับนี้ ผู้ให้บริการระบบฯ
                  มีสิทธิได้รับการเยียวยาความเสียหายจากการกระทำการหรืองดเว้นกระทำการอื่นใดได้ตามความเหมาะสม
                </div>
                <div>
                  5. ผู้ใช้บริการยอมรับที่จะปฏิบัติตาม ข้อจำกัด
                  และจะไม่ใช้บริการ เนื้อหาของระบบฯ หรือส่วนใดที่กล่าวมาข้างต้น
                  ในลักษณะใดก็ตามที่ไม่ได้รับอนุญาตอย่างชัดเจนในข้อกำหนดและเงื่อนไขการใช้บริการสำหรับประชาชน
                  ผู้ให้บริการระบบฯ ไม่ให้สิทธิ์ ชื่อ
                  หรือผลประโยชน์ใดก็ตามแก่ผู้ใช้บริการในบริการ
                  หรือเนื้อหาของระบบฯ
                  ยกเว้นสิทธิ์ที่ได้รับอนุญาตโดยชัดเจนในข้อกำหนดและเงื่อนไขการใช้บริการสำหรับประชาชน
                </div>
                <div>การให้บริการระบบแพลตฟอร์มดิจิทัล “ผูกพันธุ์”</div>
                <div>
                  ผู้ให้บริการระบบแพลตฟอร์มดิจิทัล “ผูกพันธุ์”
                  ขอสงวนสิทธิ์ในการจำกัดการเข้าถึงบริการระบบฯ
                  ของผู้ใช้บริการตามที่เห็นสมควรผู้ให้บริการระบบฯ
                  ขอสงวนสิทธิ์ในการเพิ่มเติม เปลี่ยนแปลง หรือยกเลิกการให้บริการฯ
                  เพียงบางส่วนหรือทั้งหมดโดยไม่จำเป็นต้องแจ้งให้ผู้ใช้บริการทราบล่วงหน้า
                  ผู้ใช้บริการยอมรับว่า เท่าที่กฎหมายที่เกี่ยวข้อง จะอนุญาต
                  การใช้งานและการให้บริการระบบฯ
                  เป็นความเสี่ยงของผู้ใช้บริการแต่เพียงฝ่ายเดียว
                  การให้บริการระบบฯ ถูกจัดทำขึ้น “ตามสภาพ” (as is) และ
                  “ตามที่มี” (as available) โดยอาจมีข้อบกพร่องรวมอยู่ด้วย
                  ผู้ให้บริการระบบฯ ไม่มีการรับประกันโดยนัยใด ๆ ทั้งสิ้น
                </div>
                <div>
                  <br />
                </div>
                <div>การยกเว้นความรับผิดชอบ</div>
                <div>
                  1. ผู้ให้บริการระบบแพลตฟอร์มดิจิทัล “ผูกพันธุ์”
                  ไม่สามารถรับประกันไม่ว่าจะอย่างชัดแจ้งหรือโดยปริยายว่า
                  การให้บริการฯ (รวมถึงข้อมูลส่วนบุคคล)
                  จะปราศจากข้อผิดพลาดหรือข้อบกพร่องตามจริงหรือตามกฎหมาย
                  ซึ่งอาจรวมถึง เสถียรภาพ การไว้วางใจได้ ความน่าเชื่อถือ
                  ความถูกต้อง ความครบถ้วนสมบูรณ์ การมีประสิทธิผล
                  ความเหมาะสมในการใช้บริการฯ เพื่อวัตถุประสงค์เฉพาะ
                  จุดบกพร่องที่เกี่ยวข้องกับความปลอดภัย (bug)
                  หรือการละเมิดสิทธิต่างๆ และผู้ให้บริการระบบฯ
                  จะไม่รับผิดชอบในการจัดหาบริการฯ
                  ที่ไม่มีข้อผิดพลาด/ข้อบกพร่องดังกล่าว แต่จะจัดหาบริการฯ
                  ที่ดีที่สุดตามความเหมาะสม
                </div>
                <div>
                  2. ผู้ให้บริการระบบแพลตฟอร์มดิจิทัล “ผูกพันธุ์”
                  ไม่สามารถรับรองได้ว่าผู้ใช้บริการจะได้รับผลประโยชน์
                  ตามวัตถุประสงค์ของระบบฯ เมื่อผู้ใช้บริการใช้บริการฯ
                  นอกจากนี้ผู้ให้บริการระบบฯ
                  ไม่สามารถรับประกันได้ด้วยว่าบุคลากรทางการแพทย์
                  ผู้ปฏิบัติการในห้องปฏิบัติการ และผู้ดูแลระบบฯ ฝั่งโรงพยาบาล
                  (Hospital Administrator)
                  จะปฏิบัติตามข้อกำหนดและเงื่อนไขการใช้บริการสำหรับผู้ดูแลระบบฯ
                  ฝั่งโรงพยาบาล ดังนั้น ผู้ให้บริการระบบฯ
                  จะไม่รับผิดชอบข้อผิดพลาดใด ๆ
                  ที่เกิดจากการปฏิบัติหรือไม่ปฏิบัติตามข้อกำหนดและเงื่อนไขของการใช้งานของผู้ใช้บริการดังกล่าว
                </div>
                <div>
                  3. ผู้ให้บริการระบบระบบแพลตฟอร์มดิจิทัล “ผูกพันธุ์”
                  ไม่รับรองว่าผู้ใช้บริการจะสามารถใช้งานบริการฯ
                  ร่วมกับเครื่องคอมพิวเตอร์หรืออุปกรณ์อิเล็กทรอนิกส์ทุกชนิดของผู้ใช้บริการ
                  รวมไปถึงการที่ผู้ให้บริการระบบฯ จะให้บริการฯ
                  โดยปราศจากไวรัสคอมพิวเตอร์ วอร์ม หรือ ม้าโทรจัน (Trojan Horse)
                  และผู้ให้บริการระบบฯ จะไม่รับผิดชอบชดใช้ต่อความเสียหายใด ๆ
                  ที่เป็นผลมาจากตัวทำลายเหล่านั้น
                </div>
                <div>
                  4. ผู้ให้บริการระบบฯ
                  ไม่มีความจำเป็นต้องรับผิดชอบต่อค่าเสียหายใด ๆ
                  ที่เกิดขึ้นกับผู้ใช้บริการ ในการใช้หรือไม่สามารถใช้บริการฯ
                  แบบใด ๆ หรือเนื่องจากเหตุใดก็ตาม ข้อจำกัดมีผลบังคับใช้เสมอ
                  ไม่ว่า ผู้ให้บริการระบบฯ
                  จะได้รับทราบหรือควรตระหนักถึงความเป็นไปได้ของความเสียหายดังกล่าว
                  ในเขตอำนาจศาลที่ไม่อนุญาตให้ยกเว้นหรือจำกัดความรับผิดชอบต่อความเสียหายที่เป็นผลสืบเนื่องหรือเกิดขึ้นโดยไม่ได้ตั้งใจ
                  การรับผิดชอบของผู้ให้บริการระบบฯ
                  จำกัดแค่ขอบเขตสูงสุดที่กฎหมายอนุญาตเท่านั้น
                </div>
                <div>
                  5. ผู้ให้บริการระบบฯ จะไม่ต้องรับผิดชอบต่อค่าเสียหายโดยอ้อม
                  ค่าเสียหายพิเศษ ค่าเสียหายเนื่องจากการผิดสัญญา
                  ค่าเสียหายต่อเนื่องหรือค่าเสียหายเชิงลงโทษใด ๆ
                  ในส่วนที่เกี่ยวข้องกับการผิดสัญญาหรือการกระทำการละเมิด
                  อันเนื่องมากจากความประมาทของผู้ให้บริการระบบฯ เอง
                  การชดใช้ค่าเสียหายตามปกติในส่วนที่เกี่ยวข้องกับ
                  การผิดสัญญาหรือการกระทำละเมิดจากการเลินเล่อของผู้ให้บริการระบบฯ
                  จะเป็นไปตามความเหมาะสม ของการพิจารณาตามกฎหมาย
                </div>
                <div>
                  <br />
                </div>
                <div>
                  ระบบแพลตฟอร์มดิจิทัล “ผูกพันธุ์” และหน่วยงานของบุคคลที่สาม
                </div>
                <div>
                  ระบบแพลตฟอร์มดิจิทัล “ผูกพันธุ์” ทำงานร่วมกับ
                  หรืออาจมีการโต้ตอบในลักษณะหนึ่งกับแพลตฟอร์มเช่น แอปพลิเคชัน
                  เว็บไซต์ ระบบสารสนเทศโรงพยาบาล ของบุคคลที่สาม
                  และอุปกรณ์ของบุคคลที่สาม เพื่อให้ผู้ใช้บริการ
                  สามารถเข้าถึงบริการฯได้
                  โดยแพลตฟอร์มและอุปกรณ์ของบุคคลที่สามเหล่านี้
                  อาจมีข้อกำหนดและเงื่อนไขในการใช้งาน
                  และนโยบายการคุ้มครองข้อมูลส่วนบุคคลของตัวเอง และการใช้งานระบบฯ
                  และอุปกรณ์ของบุคคลที่สามเหล่านี้
                  ถูกควบคุมและเป็นไปตามข้อกำหนดเงื่อนไขและนโยบายการคุ้มครองข้อมูลส่วนบุคคลดังกล่าว
                  ผู้ใช้บริการเข้าใจ และยอมรับว่าผู้ให้บริการระบบฯ
                  ไม่ได้เป็นผู้สนับสนุนและไม่ได้รับผิดชอบ
                  หรือมีความรับผิดในพฤติกรรม คุณลักษณะ
                  หรือเนื้อหาของระบบฯหรืออุปกรณ์ของบุคคลที่สามใด ๆ
                  หรือธุรกรรมที่ผู้ใช้บริการอาจป้อนให้แก่ผู้ให้บริการของระบบฯ
                  และอุปกรณ์ของบุคคลที่สามดังกล่าว
                  รวมถึงไม่รับประกันความเข้ากันได้
                  หรือความเข้ากันได้อย่างต่อเนื่องของระบบฯ
                  และอุปกรณ์ของบุคคลที่สามกับบริการฯ
                </div>
                <div>
                  สิทธิ์ที่ผู้ใช้บริการมอบให้ผู้ให้บริการระบบแพลตฟอร์มดิจิทัล
                  “ผูกพันธุ์”
                </div>
                <div>
                  ในการพิจารณาสิทธิ์ที่ผู้ใช้บริการมอบให้ผู้ให้บริการระบบฯ
                  ภายใต้ข้อกำหนดและเงื่อนไขฯ ผู้ใช้บริการ
                  ได้ให้สิทธิ์ผู้ให้บริการระบบฯ ในการให้บริการฯ ใช้ระบบประมวลผล
                  แบนด์วิดธ์ และ ฮาร์ดแวร์ที่ใช้เก็บข้อมูลบนอุปกรณ์
                  ของผู้ใช้บริการ
                  เพื่อเป็นการอำนวยความสะดวกในการปฏิบัติการของบริการฯ
                </div>
                <div>
                  การยกเลิกสิ้นสุดข้อกำหนดและเงื่อนไขการใช้บริการสำหรับประชาชน
                </div>
                <div>
                  ผู้ให้บริการระบบฯ อาจทำการยกเลิกข้อกำหนดและเงื่อนไขฯ
                  เหล่านี้เมื่อใดก็ได้ตามเหตุอันเห็นสมควรโดยอาจแจ้งให้ผู้ใช้บริการทราบผ่านทางเว็บไซต์หรือแอปพลิเคชัน
                  “ผูกพันธุ์” และการยกเลิกสิ้นสุดจะมีผลทันที ณ ขณะนั้น
                </div>
                <div>
                  <br />
                </div>
                <div>การโอนสิทธิ์</div>
                <div>
                  1. ผู้ให้บริการระบบฯ
                  อาจโอนสิทธิ์ในข้อกำหนดและเงื่อนไขการใช้บริการสำหรับประชาชน
                  และสิทธิ์ใดก็ตามที่มีภายใต้ข้อกำหนดและเงื่อนไขการใช้บริการสำหรับประชาชน
                  ฉบับนี้ ทั้งหมดหรือบางส่วน อีกทั้ง ผู้ให้บริการระบบฯ
                  อาจมอบหมายภาระผูกพันภายใต้ข้อกำหนดและเงื่อนไขการใช้บริการสำหรับประชาชนนี้ได้
                </div>
                <div>
                  2. ผู้ใช้บริการระบบฯ
                  ไม่อาจโอนสิทธิ์ในข้อกำหนดและเงื่อนไขการใช้บริการสำหรับประชาชนทั้งหมด
                  หรือบางส่วน หรือถ่ายสิทธิ์
                  หรืออนุญาตให้ใช้สิทธิ์ต่อภายใต้ข้อกำหนดและเงื่อนไขการใช้บริการสำหรับประชาชนนี้แก่บุคคลที่สามใดก็ตาม
                </div>
                <div>การเป็นโมฆะบางส่วน การละเว้น และ การตีความ</div>
                <div>
                  เว้นแต่ได้ระบุไว้เป็นอื่นในข้อกำหนดและเงื่อนไขการใช้บริการสำหรับประชาชน
                  นี้
                  ข้อกำหนดข้อหนึ่งข้อใดในข้อกำหนดและเงื่อนไขการใช้บริการสำหรับประชาชน
                  จะตกเป็นโมฆะหรือไม่มีอำนาจบังคับใช้ได้ด้วยเหตุผลใดก็ตาม
                  หรือภายในขอบเขตใด ๆ
                  การเป็นโมฆะหรือการไม่มีอำนาจบังคับใช้นั้นจะไม่มีผลต่อ
                  หรือส่งผลให้ข้อกำหนดที่เหลือ
                  ของข้อกำหนดและเงื่อนไขการใช้บริการสำหรับประชาชน นี้เป็นโมฆะ
                  หรือไม่มีอำนาจบังคับใช้ด้วย ไม่ว่าในกรณีใดก็ตาม
                  และการบังคับใช้ข้อกำหนดดังกล่าวจะต้องมีผลใช้ภายในขอบเขตที่ชอบโดยกฎหมาย
                  รวมถึงจะไม่มีการละเว้นสิทธิ์ ของผู้ให้บริการระบบฯ
                  หรือบุคคลที่สามผู้รับผลประโยชน์จากข้อกำหนดและเงื่อนไขการใช้บริการสำหรับประชาชน
                  ฉบับนี้
                </div>
                <div>
                  ตามที่ใช้ในข้อกำหนดเหล่านี้ คำว่า “รวม” และ “รวมถึง” และ
                  การหลากคำข้างต้น จะถือว่ามีคำว่า “ไม่มีข้อจำกัด” ตามมาด้วย
                </div>
                <div>
                  <br />
                </div>
                <div>กฎหมายที่บังคับและขอบเขตอำนาจ</div>
                <div>
                  ข้อกำหนดและเงื่อนไขการใช้บริการสำหรับประชาชน นี้
                  (รวมถึงข้อพิพาท/การเรียกร้องความเสียหาย
                  ที่ไม่ได้ระบุในข้อกำหนดและเงื่อนไขฯ
                  ซึ่งเกิดจากหรือเกี่ยวเนื่องกับข้อกำหนดและเงื่อนไขการใช้บริการสำหรับประชาชน)
                  จะใช้บังคับกับความสัมพันธ์ระหว่างผู้ใช้บริการและผู้ให้บริการระบบฯ
                  โดยจะอยู่ภายใต้การบังคับใช้กฎหมายของประเทศไทย
                  ผู้ใช้บริการตกลงที่จะระงับข้อพิพาทนอกศาลโดยติดต่อผู้ให้บริการระบบฯ
                  หากข้อพิพาทดังกล่าวไม่สามารถยุติได้
                  ผู้ใช้บริการถึงจะสามารถนําคดีขึ้นสู่ศาลได้ นอกจากนั้น
                  ผู้ใช้บริการและผู้ให้บริการระบบฯ เห็นชอบให้การระงับข้อพิพาท
                  การเรียกร้องความเสียหาย
                  หรือความขัดแย้งที่อาจเกิดขึ้นจากบริการฯ
                  หรือเกิดขึ้นระหว่างผู้ใช้บริการและผู้ให้บริการระบบฯ
                  ที่เกี่ยวกับบริการฯ อยู่ภายใต้เขตอำนาจของศาลประเทศไทย
                </div>
                <div>
                  <br />
                </div>
                <div>การแจ้งเตือนและการติดต่อ</div>
                <div>
                  เมื่อผู้ให้บริการระบบฯ
                  มีความประสงค์ที่จะแจ้งเตือนหรือติดต่อผู้ใช้บริการเกี่ยวกับการบริการฯ
                  ผู้ให้บริการระบบฯ
                  อาจทำการติดต่อไปยังผู้ใช้บริการโดยตรงหรือผ่านหน่วยงานฯ
                  ตามที่เห็นสมควรในแต่ละกรณี เช่นเดียวกัน
                  หากผู้ใช้บริการมีความประสงค์ที่จะแจ้งปัญหาหรือติดต่อ
                  เกี่ยวกับการบริการฯ สามารถติดต่อผู้ให้บริการระบบฯ
                  ตามข้อมูลที่ปรากฎตามด้านล่างนี้
                </div>
                <div>
                  <br />
                </div>
                <div>ช่องทางการติดต่อ</div>
                <div>
                  หากประชาชนประสงค์จะติดต่อ หรือมีข้อสงสัย
                  หรือต้องการสอบถามข้อมูลเกี่ยวกับรายละเอียด การเก็บรวบรวม ใช้
                  และ/หรือเปิดเผยข้อมูลส่วนบุคคล
                  รวมถึงสิทธิของประชาชนนโยบายฉบับนี้
                  หรือต้องการยกเลิกการให้ความยินยอมในการเก็บรวบรวม ใช้
                  และ/หรือเปิดเผยข้อมูลส่วนบุคคล
                  หรือกรณีที่พบว่ามีการใช้ข้อมูลส่วนบุคคลของประชาชนไปในทางที่ไม่ชอบ
                  ประชาชนสามารถติดต่อสำนักงาน ทางช่องทางดังต่อไปนี้
                </div>
                <div>
                  <br />
                </div>
                <div>
                  สถาบันชีววิทยาศาสตร์ทางการแพทย์ กรมวิทยาศาสตร์การแพทย์
                </div>
                <div>
                  สถานที่ติดต่อ: 88/7 ซอยบำราศนราดูร ถ.ติวานนท์ ต.ตลาดขวัญ
                  อ.เมือง จ.นนทบุรี 11000
                </div>
                <div>เวลาทำการปกติ: วันจันทร์ถึงศุกร์ เวลา 8:30 – 16:30 น.</div>
                <div>เว็บไซต์: https://phukphan.dmsc.moph.go.th/</div>
                <div>
                  <br />
                </div>
                <div>ติดต่อสอบถาม :</div>
                <div>นางสาวพรนภัส อยู่นุช</div>
                <div>อีเมลล์: pornnapat.y@dmsc.mail.go.th</div>
                <div>หมายเลขโทรศัพท์: 0-2589-9850 ถึง 8 ต่อ 98096</div>
                <div>นายพนาพัฒน์ ไพเราะ</div>
                <div>อีเมลล์: panapat.p@dmsc.mail.go.th</div>
                <div>หมายเลขโทรศัพท์: 0-2951-0000 ต่อ 99394</div>
                <div>นางสาวนภัชชา ถาวงศ์</div>
                <div>อีเมลล์: penpitcha.t@dmsc.mail.go.th</div>
                <div>หมายเลขโทรศัพท์: 0-2589-9850 ถึง 8 ต่อ 98096</div>
                <div>นายอาคม สาลี</div>
                <div>อีเมลล์: arkom.s@dmsc.mail.go.th</div>
                <div>หมายเลขโทรศัพท์: 0-2951-0000 ต่อ 99460</div>
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
}

export function Doctor() {
  const [valueTab, setValueTab] = useState(0);
  return (
    <>
      <div className={styles.containerTab}>
        <div
          onClick={() => {
            setValueTab(0);
          }}
          className={valueTab === 0 ? styles.tab : styles.tabN}
        >
          นโยบายความเป็นส่วนตัว
        </div>
        <div
          onClick={() => {
            setValueTab(1);
          }}
          className={valueTab === 1 ? styles.tab : styles.tabN}
        >
          ข้อกำหนดและเงื่อนไขการใช้บริการ
        </div>
      </div>
      <div className={styles.containerCard}>
        <div className={styles.scrollbar}>
          {valueTab === 0 ? (
            <div className={styles.card}>
              <div className={styles.title}>สำหรับแพทย์/ เภสัชกร</div>
              <br />
              <div className={styles.detail}>
                <div>
                  ประกาศนโยบายความเป็นส่วนตัวฉบับนี้
                  มีเพื่อชี้แจงให้บุคลากรทางการแพทย์ทราบถึงวัตถุประสงค์
                  และรายละเอียดของการเก็บรวบรวม เข้าถึง ใช้งาน จัดการ
                  และเปิดเผยข้อมูลส่วนบุคคลของบุคลากรทางการแพทย์จากการใช้บริการระบบแพลตฟอร์มดิจิทัล
                  “ผูกพันธุ์” และสิทธิตามกฎหมายของบุคลากรทางการแพทย์
                  ที่เกี่ยวข้องกับข้อมูลส่วนบุคคล
                </div>
                <div>
                  <br />
                </div>
                <div>1. คำนิยาม</div>
                <div>
                  1.1 “ระบบแพลตฟอร์มดิจิทัล” หรือ “Digital Platform” ผูกพันธุ์
                  (ระบบฯ) หมายความว่า บริการดิจิทัลภาครัฐที่พัฒนา
                  หรือจัดหาและให้บริการ โดยกรมวิทยาศาสตร์การแพทย์
                  โดยมีวัตถุประสงค์ให้ประชาชน บุคลากรทางการแพทย์
                  สามารถเข้าถึงข้อมูลพันธุกรรม ได้แก่
                  ผลการตรวจทางเภสัชพันธุศาสตร์ เป็นต้น โดยระบบแพลตฟอร์มดิจิทัล
                  “ผูกพันธุ์” แบ่งการใช้งานออกเป็น 2 ระบบ ได้แก่
                </div>
                <div>
                  <span className={styles.dot}></span>
                  “แอปพลิเคชัน” หรือ “Application” ผูกพันธุ์ หมายความว่า
                  แอปพลิเคชัน “ผูกพันธุ์” ตลอดจนโปรแกรมคอมพิวเตอร์ ชุดคำสั่ง
                  หรือแอปพลิเคชันอื่น ๆ ที่ต้องใช้หรืออาจใช้ร่วมกัน
                  หรือเกี่ยวเนื่องกันกับแอปพลิเคชันดังกล่าว เพื่อการใช้บริการ
                  “ผูกพันธุ์” ไม่ว่าจะใช้งานผ่านโทรศัพท์มือถือ แท็บเล็ต เว็บ
                  หรือผ่านอุปกรณ์อื่นใดก็ตาม ทั้งนี้ ในกรณีที่ แอปพลิเคชัน
                  “ผูกพันธุ์”
                  เปลี่ยนชื่อเป็นอย่างอื่นหรือมีแอปพลิเคชันอื่นรวมอยู่ด้วย
                  ให้หมายความรวมถึงแอปพลิเคชันนั้นด้วย
                </div>
                <div>
                  <span className={styles.dot}></span>
                  “เว็บไซต์” หรือ “website” ผูกพันธุ์ หมายความว่า เว็บไซต์
                  “ผูกพันธุ์” ตลอดจนหน้าเว็บเพจที่ทำขึ้นเพื่อนำเสนอข้อมูลต่าง ๆ
                  ผ่านทางคอมพิวเตอร์ และอินเทอร์เน็ต
                  โดยมีหลายหน้าที่เชื่อมโยงเข้ากับไฮเปอร์ลิงก์
                  เพื่อให้สามารถเปิดไปยังหน้าเพจต่าง ๆ และถูกจัดเก็บไว้ใน www.
                  (เวิลด์ไวด์เว็บ) โดยเว็บไซต์ผูกพันธุ์ หรือ
                  https://phukphan.dmsc.moph.go.th/ มีไว้เพื่อให้ประชาชน
                  บุคลากรทางการแพทย์ สามารถเข้าถึงข้อมูลพันธุกรรมได้
                  นอกจากนี้ยังให้เจ้าหน้าที่ห้องปฏิบัติการสามารถเปิดห้องปฏิบัติการของตนเองและสามารถรายงานผลการตรวจทางพันธุกรรมได้
                </div>
                <div>
                  1.2 “ข้อมูลส่วนบุคคล” หมายความว่า ข้อมูลส่วนตัว หรือ
                  ข้อมูลเกี่ยวกับผู้ใช้บริการ
                  ซึ่งทำให้สามารถระบุตัวตนของผู้ใช้บริการได้ไม่ว่าทางตรงหรือทางอ้อม
                  ซึ่งรวมถึงข้อมูลทั่วไปของผู้ใช้บริการ ข้อมูลที่ใช้ยืนยันตัวตน
                  ข้อมูลชีวมาตรหรือ biometrics (เช่น ลายนิ้วมือ ใบหน้า เป็นต้น)
                  ข้อมูลสุขภาพ และข้อมูลส่วนบุคคลอื่นใดเกี่ยวกับผู้ใช้บริการ
                  ตามกฎหมายว่าด้วยการคุ้มครองข้อมูลส่วนบุคคล ทั้งนี้
                  ไม่รวมถึงข้อมูลเกี่ยวกับผู้ใช้บริการ
                  ในกรณีที่ผู้ใช้บริการถึงแก่กรรม และไม่รวมถึงข้อมูลทางสถิติ
                  หรือข้อมูลที่ไม่สามารถระบุตัวบุคคลที่เป็นเจ้าของข้อมูลส่วนบุคคลได้
                  ซึ่งไม่ถือเป็นข้อมูลส่วนบุคคล
                  ตามกฎหมายว่าด้วยการคุ้มครองข้อมูลส่วนบุคคล
                </div>
                <div>
                  1.3 “ข้อมูลสุขภาพ” หมายความว่า
                  ข้อมูลส่วนบุคคลของผู้ใช้บริการที่มีเนื้อหาเกี่ยวกับสุขภาพ
                  ได้แก่ ข้อมูลการแพ้ยา ข้อมูลโรควินิจฉัย ข้อมูลการจ่ายยา
                  ข้อมูลวัคซีน ข้อมูลหัตถการ ข้อมูลค่าผลตรวจ ทางการแพทย์
                  ข้อมูลผลตรวจห้องปฏิบัติและผลสรุปภาพถ่ายทางการแพทย์
                  ข้อมูลสุขภาพละเอียดอ่อน เช่น ข้อมูลพันธุกรรม เป็นต้น
                  และข้อมูลการเข้ารับบริการการรักษาพยาบาล
                  รวมไปถึงข้อมูลสุขภาพอื่น ๆ ที่อาจมีเพิ่มเติมในอนาคต
                </div>
                <div>
                  1.4 “ผู้ใช้บริการ” หมายความว่า ผู้ใช้งาน ระบบแพลตฟอร์มดิจิทัล
                  “ผูกพันธุ์” แบ่งการใช้งานตามระบบฯ และบทบาทดังต่อไปนี้
                </div>
                <div>
                  <span className={styles.dot}></span>
                  “ประชาชน” หมายความว่า ผู้ป่วย หรือ บุคคลทั่วไป
                  ที่เข้าใช้งานระบบแพลตฟอร์มดิจิทัล “ผูกพันธุ์”
                </div>
                <div>
                  <span className={styles.dot}></span>
                  “บุคลากรทางการแพทย์” หมายความว่า ผู้ประกอบวิชาชีพทางการแพทย์
                  ได้แก่ แพทย์ เภสัชกรพยาบาล เทคนิคการแพทย์ กายภาพบำบัด
                  แพทย์แผนไทย นักสาธารณสุขชุมชน รวมทั้ง
                  ผู้ที่มีหน้าที่ในการดูแลรักษาผู้ป่วยในด้านอื่น ๆ
                </div>
                <div>
                  <span className={styles.dot}></span>
                  “ผู้ปฏิบัติงานในห้องปฏิบัติการ” หมายความว่า
                  ผู้มีหน้าที่รับผิดชอบในการดำเนินการวิเคราะห์
                  ผลการตรวจทางพันธุกรรมที่โรงพยาบาลได้ทำการส่งตัวอย่างมาที่กรมวิทยาศาสตร์การแพทย์
                  ได้แก่ นักเทคนิคการแพทย์ และ นักวิทยาศาสตร์การแพทย์
                </div>
                <div>
                  1.5 “โรงพยาบาล” หมายความว่า
                  สถานที่รวมตลอดถึงยานพาหนะซึ่งจัดไว้เพื่อการประกอบโรคศิลปะ
                  ตามกฎหมายว่าด้วยการประกอบโรคศิลปะ
                  การประกอบวิชาชีพเวชกรรมตามกฎหมายว่าด้วยวิชาชีพเวชกรรม
                  การประกอบวิชาชีพการพยาบาลและการผดุงครรภ์ตามกฎหมายว่าด้วยวิชาชีพ
                  การพยาบาลและการผดุงครรภ์
                  การประกอบวิชาชีพทันตกรรมตามกฎหมายว่าด้วยวิชาชีพทันตกรรม
                  เทคนิคการแพทย์ตามกฎหมายว่าด้วยวิชาชีพเทคนิค การแพทย์
                  การประกอบวิชาชีพการแพทย์แผนไทยและการประกอบวิชาชีพการแพทย์แผนไทยประยุกต์ตามกฎหมายว่าด้วยวิชาชีพการแพทย์แผนไทย
                  หรือการประกอบวิชาชีพทางการแพทย์และสาธารณสุขอื่นตามกฎหมายว่าด้วยการนั้น
                </div>
                <div>
                  1.6 “ระบบสารสนเทศโรงพยาบาล” หรือ “Hospital Information System:
                  HIS” หมายความว่า ระบบการจัดการโรงพยาบาลที่ช่วยในการจัดเก็บ
                  จัดการ และส่งต่อข้อมูลจำนวนมากทั้งจากภายใน และภายนอกโรงพยาบาล
                  ให้ผู้บริหารสามารถจัดสรรทรัพยากรต่างๆ
                  ของโรงพยาบาลได้อย่างคุ้มค่า
                  เพิ่มประสิทธิภาพของการทำงานและการรักษาผู้ป่วยได้อย่างรวดเร็ว
                </div>
                <div>
                  1.7 “ระบบรับ-ส่งตัวอย่างเพื่อตรวจวิเคราะห์” หรือ “iLAB PLUS”
                  หมายความว่า ระบบรับ-ส่งตัวอย่าง
                  เพื่อตรวจวิเคราะห์กรมวิทยาศาสตร์การแพทย์ กระทรวงสาธารณสุข
                  โดยผู้ใช้จะแบ่งเป็นสำหรับหน่วยงานผู้ขอรับบริการ
                  และสำหรับเจ้าหน้าที่กรมวิทยาศาสตร์การแพทย์
                  ซึ่งผู้ขอรับบริการเป็นผู้ส่งตัวอย่างให้กับห้องปฏิบัติการของกรมวิทยาศาสตร์การแพทย์
                  จากนั้นจะทำการวิเคราะห์ผลทางห้องปฏิบัติการ
                  เมื่อวิเคราะห์ผลเรียบร้อยแล้วจะทำการออกรายงานผล
                  รับรองผลการตรวจวิเคราะห์
                  และส่งผลการตรวจวิเคราะห์กลับให้ทางผู้ขอรับบริการนั้น ๆ
                </div>
                <div>
                  1.8 “ผู้ให้บริการ”
                  หมายความหน่วยงานที่มีหน้าที่และ/หรือได้รับมอบหมายในการจัดทำ
                  พัฒนา และให้บริการระบบแพลตฟอร์มดิจิทัล“ผูกพันธุ์”
                </div>
                <div>
                  <br />
                </div>
                <div>
                  2. วัตถุประสงค์ของการเก็บรวบรวม เข้าถึง ใช้งาน จัดการ
                  และเปิดเผยข้อมูลส่วนบุคคลของ บุคลากรทางการแพทย์
                </div>
                <div>
                  ข้อมูลส่วนบุคคลจะถูกเก็บรวบรวม เข้าถึง ใช้งาน จัดการ
                  และเปิดเผย
                  โดยมีวัตถุประสงค์เพื่อให้ผู้ขอใช้บริการเข้าถึงข้อมูลพันธุกรรมที่กรมวิทยาศาสตร์การแพทย์และห้องปฏิบัติการอื่น
                  ๆ ให้บริการ โดยมีผู้ใช้บริการ และบทบาทที่เกี่ยวข้อง ดังนี้
                </div>
                <div>
                  <span className={styles.dot}></span>
                  ประชาชน
                  เข้าถึงและแสดงผลการตรวจของตนเองให้บุคลาการทางการแพทย์ที่รักษา
                </div>
                <div>
                  <span className={styles.dot}></span>
                  บุคลากรทางการแพทย์ เข้าถึงและใช้ผลการตรวจของประชาชน
                  ประกอบการพิจารณาวินิจฉัย ป้องกันและรักษาโรคที่เฉพาะบุคคล
                  ส่งเสริมการรักษาแบบการแพทย์แม่นยำ (Precision Medicine)
                </div>
                <div>
                  <span className={styles.dot}></span>
                  ผู้ปฏิบัติงานในห้องปฏิบัติการ
                  บันทึกผลการตรวจทางพันธุกรรมในระบบแพลตฟอร์มดิจิทัล “ผูกพันธุ์”
                </div>
                <div>
                  นอกจากนี้ ระบบแพลตฟอร์มดิจิทัล “ผูกพันธุ์”
                  ยังสามารถเชื่อมต่อกับระบบสารสนเทศโรงพยาบาล
                  เพื่อแลกเปลี่ยนข้อมูลพันธุกรรม
                  เนื่องจากการตรวจทางพันธุกรรมบางรายการ สามารถตรวจครั้งเดียว
                  และใช้ผลการตรวจได้ตลอดชีวิต
                  ดังนั้นจึงทำให้ประชาชนและภาครัฐประหยัดเงิน และเวลาในการตรวจซ้ำ
                  เมื่อประชาชนเข้ารับการรักษาต่างโรงพยาบาล
                  และบุคลากรทางการแพทย์สามารถพิจารณาใช้ผลการตรวจดังกล่าว
                  ในการวางแผนป้องกันและรักษาโรคได้ทันที
                </div>
                <div>
                  ในขณะเดียวกัน
                  ข้อมูลส่วนบุคคลบางรายการมีความจำเป็นที่จะต้องทำการเก็บรวบรวม
                  เข้าถึง ใช้งาน จัดการ และเปิดเผย
                  เนื่องจากเป็นข้อมูลที่มีความสำคัญต่อการให้บริการระบบฯ
                  ซึ่งการเก็บรวบรวม เข้าถึง ใช้งาน จัดการ
                  และเปิดเผยข้อมูลส่วนบุคคลของประชาชน จะไม่ถูกกระทำการใด ๆ
                  ที่นอกเหนือไปจากวัตถุประสงค์ที่ได้ระบุไว้ข้างต้น
                  เว้นแต่เป็นการใช้เพื่อ
                </div>
                <div>
                  <span className={styles.dot}></span>
                  การควบคุมคุณภาพและเพิ่มประสิทธิภาพและส่งเสริมการให้บริการของระบบฯ
                </div>
                <div>
                  <span className={styles.dot}></span>
                  ความปลอดภัยของเครือข่ายและข้อมูล
                </div>
                <div>
                  <span className={styles.dot}></span>
                  การปฏิบัติตามเงื่อนไขการให้บริการของระบบฯ
                </div>
                <div>
                  <span className={styles.dot}></span>
                  การให้บริการเพื่อประโยชน์ของประชาชน
                </div>
                <div>
                  <span className={styles.dot}></span>
                  วัตถุประสงค์อื่น ๆ ซึ่งจะต้องได้รับความยินยอมจากประชาชนก่อน
                </div>
                <div>
                  <span className={styles.dot}></span>
                  ประโยชน์สาธารณะด้านการสาธารณสุข
                  ตามพระราชบัญญัติคุ้มครองข้อมูลส่วนบุคคล พ.ศ. 2562
                </div>
                <div>
                  <span className={styles.dot}></span>
                  การศึกษาวิจัยทางวิทยาศาสตร์ ประวัติศาสตร์ หรือสถิติ
                  หรือประโยชน์สาธารณะอื่น
                  ตามพระราชบัญญัติคุ้มครองข้อมูลส่วนบุคคล พ.ศ. 2562
                </div>
                <div>
                  <span className={styles.dot}></span>
                  การปฏิบัติตามกฎหมายว่าด้วยการคุ้มครองข้อมูลส่วนบุคคล พ.ศ. 2562
                  หรือกรณีที่กฎหมายฉบับอื่นบัญญัติให้กระทำ
                </div>
                <div>
                  <br />
                </div>
                <div>
                  3. การเก็บรวบรวม เข้าถึง ใช้งาน จัดการ
                  และเปิดเผยข้อมูลส่วนบุคคลบนระบบแพลตฟอร์มดิจิทัล “ผูกพันธุ์”
                </div>
                <div>
                  ข้อมูลส่วนบุคคล
                  คือข้อมูลที่ทำให้สามารถระบุตัวตนหรือบ่งชี้ลักษณะเฉพาะตัวของบุคลากรทางการแพทย์ได้
                  ไม่ว่าจะทั้งทางตรงหรือทางอ้อม
                  แต่ไม่รวมถึงข้อมูลของผู้ถึงแก่กรรม
                  เมื่อบุคลากรทางการแพทย์เข้าใช้งาน
                  และให้ความยินยอมในการเข้าใช้บริการในระบบแพลตฟอร์มดิจิทัล
                  “ผูกพันธุ์” แล้วนั้น กรมวิทยาศาสตร์การแพทย์ กระทรวงสาธารณสุข
                  รวมทั้งผู้พัฒนาและดูแลระบบแพลตฟอร์มดิจิทัล “ผูกพันธุ์”
                  จะสามารถเก็บรวบรวม เข้าถึง ใช้งาน จัดการ
                  และเปิดเผยข้อมูลส่วนบุคคลของบุคลากรทางการแพทย์ในระบบแพลตฟอร์มดิจิทัล
                  “ผูกพันธุ์”
                  ซึ่งข้อมูลส่วนบุคคลจะครอบคลุมทั้งข้อมูลก่อนและหลังจากวันที่
                  บุคลากรทางการแพทย์แสดงความยินยอมในการใช้บริการระบบแพลตฟอร์มดิจิทัล
                  “ผูกพันธุ์” โดยจะประกอบไปด้วยข้อมูลและวัตถุประสงค์ในการรวบรวม
                  ใช้ และเปิดเผย ดังนี้
                </div>
                <div>3.1 ข้อมูลส่วนตัว เช่น</div>
                <div>
                  <span className={styles.dot}></span>
                  หมายเลขบัตรประชาชน
                  เพื่อใช้ในยืนยันตัวตนของผู้ปฏิบัติงานในห้องปฏิบัติการกับฐานข้อมูลกรมการปกครอง
                </div>
                <div>
                  <span className={styles.dot}></span>
                  คำนำหน้า ชื่อ นามสกุล เพศ อายุ และหมายเลขโทรศัพท์
                  เพื่อระบุตัวตนและยืนยันตัวตน
                </div>
                <div>
                  <span className={styles.dot}></span>
                  รหัสไปรษณีย์ เพื่อนำไปใช้ในการศึกษาวิจัยทางวิทยาศาสตร์
                  ประวัติศาสตร์ หรือสถิติ หรือประโยชน์สาธารณะอื่น ๆ
                  ตามพระราชบัญญัติคุ้มครองข้อมูลส่วนบุคคล พ.ศ. 2562
                </div>
                <div>
                  <span className={styles.dot}></span>
                  หมายเลขหลังบัตรประชาชน
                  ถูกนำมาใช้เพื่อยืนยันตัวตนของบุคลากรทางการแพทย์
                  กับฐานข้อมูลกรมการปกครอง
                  เป็นการป้องกันการฉ้อโกงโดยแสดงตนเป็นบุคคลอื่น
                  ซึ่งข้อมูลนี้จะไม่ถูกเก็บไว้เมื่อทำการยืนยันตัวตนหรือสมัครใช้งานสำเร็จ
                </div>
                <div>
                  <span className={styles.dot}></span>
                  เลขที่ใบประกอบวิชาชีพเวชกรรม
                  ใช้ในการตรวจสอบว่าผู้ปฏิบัติงานในห้องปฏิบัติการ
                  เป็นบุคลากรทางการแพทย์จริงจากระบบของสภาเทคนิคการแพทย์
                  หรือจากระบบ “หมอพร้อม”
                </div>
                <div>3.2 ข้อมูลสถานพยาบาล เช่น</div>
                <div>
                  <span className={styles.dot}></span>
                  ข้อมูลการตรวจทางพันธุกรรมที่ถูกเรียกดู
                </div>
                <div>
                  <span className={styles.dot}></span>
                  วันและเวลาที่ถูกเรียกดู
                </div>
                <div>
                  <span className={styles.dot}></span>
                  ข้อมูล User id ของบุคลากรทางการแพทย์ผู้ทำการเรียกดูข้อมูล
                </div>
                <div>
                  <span className={styles.dot}></span>
                  สถานะของการเรียกดูข้อมูล
                  (อนุญาตแล้ว/ยังไม่ได้รับอนุญาต/ปฏิเสธการเข้าถึงข้อมูล)
                </div>
                <div>
                  <span className={styles.dot}></span>
                  ข้อมูลส่วนตัวของผู้ป่วย
                </div>
                <div>
                  <span className={styles.dot}></span>
                  ข้อมูลห้องปฏิบัติการ
                </div>
                <div>สถานพยาบาล ณ ตอนที่บุคลากรทางการแพทย์เรียกดูข้อมูล</div>
                <div>
                  <span className={styles.dot}></span>
                  ประเภทของการเข้ารับบริการ (ประชาชน/กรณีฉุกเฉิน)
                </div>
                <div>3.3 ข้อมูลการเข้าร่วมระบบฯ เช่น</div>
                <div>
                  <span className={styles.dot}></span>
                  ข้อมูล user id ของบุคลากรทางการแพทย์
                </div>
                <div>
                  <span className={styles.dot}></span>
                  ข้อมูลประเภทบัญชีของบุคลากรทางการแพทย์ (Doctor)
                </div>
                <div>
                  <span className={styles.dot}></span>
                  วันที่และเวลาที่บุคลากรทางการแพทย์เข้าร่วมระบบฯ
                </div>
                <div>
                  <span className={styles.dot}></span>
                  เวอร์ชันความยินยอมที่บุคลากรทางการแพทย์ยอมรับ
                  และวันที่และเวลาที่บุคลากรทางการแพทย์ยอมรับ
                </div>
                <div>
                  3.4 ข้อมูลการเข้าใช้งานระบบแพลตฟอร์มดิจิทัล “ผูกพันธุ์” (Login
                  Record) เช่น
                </div>
                <div>
                  <span className={styles.dot}></span>
                  ชื่อโรงพยาบาลที่บุคลากรทางการแพทย์ปฏิบัติงาน
                </div>
                <div>
                  <span className={styles.dot}></span>
                  ข้อมูลส่วนบุคคลของบุคลากรทางการแพทย์
                </div>
                <div>
                  <span className={styles.dot}></span>
                  สถานะของการเข้าใช้งานระบบฯ (สำเร็จ/ไม่สำเร็จ)
                </div>
                <div>3.5 ข้อมูลการร้องขอความยินยอมผู้ป่วย เช่น</div>
                <div>
                  <span className={styles.dot}></span>
                  ชื่อ-นามสกุลของบุคลากรทางการแพทย์
                </div>
                <div>
                  <span className={styles.dot}></span>
                  ชื่อโรงพยาบาลที่บุคลากรทางการแพทย์ใช้งานในขณะที่บุคลากรทางการแพทย์ร้องขอความยินยอม
                </div>
                <div>
                  <span className={styles.dot}></span>
                  วันที่และเวลาของการร้องขอความยินยอม
                </div>
                <div>
                  <span className={styles.dot}></span>
                  ชื่อ-นามสกุล หรือ
                  เลขบัตรประจำตัวประชาชนของผู้ป่วยที่บุคลากรทางการแพทย์ร้องขอความยินยอม
                </div>
                <div>
                  3.6 ข้อมูลประวัติการเข้าถึงและเรียกดูข้อมูลสุขภาพ
                  ซึ่งเป็นการบันทึกการเรียกดูข้อมูลสุขภาพของ
                  บุคลากรทางการแพทย์ในโรงพยาบาลที่เข้าร่วมระบบฯ
                  เพื่อใช้ตรวจสอบและดูแลจัดการเข้าถึง
                  และใช้งานข้อมูลสุขภาพของประชาชน เช่น
                </div>
                <div>
                  <span className={styles.dot}></span>
                  วันที่และเวลาของการเรียกดูข้อมูล
                </div>
                <div>
                  <span className={styles.dot}></span>
                  ข้อมูลของบุคลากรทางการแพทย์ผู้ทำการเรียกดูข้อมูล
                </div>
                <div>
                  <span className={styles.dot}></span>
                  สถานะของการเรียกดูข้อมูล (อนุญาต/ไม่อนุญาต)
                </div>
                <div>
                  <span className={styles.dot}></span>
                  ข้อมูลส่วนบุคคลของประชาชนที่ยินยอมให้บุคลากรทางการแพทย์เข้าถึงข้อมูล
                </div>
                <div>
                  <span className={styles.dot}></span>
                  โรงพยาบาลของบุคลากรทางการแพทย์ ณ ตอนที่เรียกดูข้อมูล
                </div>
                <div>
                  <span className={styles.dot}></span>
                  ประเภทของการเข้ารับบริการ (ประชาชน/กรณีฉุกเฉิน)
                </div>
                <div>
                  <br />
                </div>
                <div>4. แหล่งที่มาของข้อมูลส่วนบุคคล</div>
                <div>
                  ข้อมูลส่วนบุคคลของบุคลากรทางการแพทย์จะถูกเก็บรวบรวมโดยแบ่งเป็น
                </div>
                <div>
                  4.1 ข้อมูลส่วนตัว
                  จะถูกเก็บรวบรวมและจัดการผ่านระบบอิเล็กทรอนิกส์ของระบบแพลตฟอร์มดิจิทัล
                  “ผูกพันธุ์” โดยมีการนำเข้าข้อมูลและพิสูจน์ตัวตนจากแพลตฟอร์ม
                  ดังต่อไปนี้
                </div>
                <div>
                  <span className={styles.dot}></span>
                  “หมอพร้อม” ภายใต้การดูแลของสำนักสุขภาพดิจิทัล
                  สำนักปลัดกระทรวงสาธารณสุข
                </div>
                <div>
                  <span className={styles.dot}></span>
                  “OnesID” ภายใต้การดูแลของ SOFTMAX CO., LTD.
                </div>
                <div>
                  <span className={styles.dot}></span>
                  “ThaiD” ภายใต้การดูแลของกรมการปกครอง
                </div>
                <div>
                  หรือ
                  ผ่านการกรอกแบบฟอร์มลงทะเบียนเข้าใช้งานผ่านระบบแพลตฟอร์มดิจิทัล
                  “ผูกพันธุ์”
                </div>
                <div>
                  4.2 ข้อมูลสถานพยาบาลที่บุคลากรทางการแพทย์สังกัด
                  ผ่านการกรอกแบบฟอร์มลงทะเบียนเข้าใช้งานผ่านระบบแพลตฟอร์มดิจิทัล
                  “ผูกพันธุ์”
                </div>
                <div>
                  4.3 ข้อมูลประวัติการเข้าถึงเรียกดูข้อมูลผลการตรวจทางพันธุกรรม
                  ข้อมูลการเข้าร่วมระบบแพลตฟอร์มดิจิทัล “ผูกพันธุ์”
                  ข้อมูลการใช้งานระบบแพลตฟอร์มดิจิทัล “ผูกพันธุ์”
                  และข้อมูลการสืบค้น ระบบแพลตฟอร์มดิจิทัล “ผูกพันธุ์”
                  จะถูกรวบรวมข้อมูลโดยอัตโนมัติในขณะที่บุคลากรทางการแพทย์ใช้งานระบบแพลตฟอร์มดิจิทัล
                  “ผูกพันธุ์”
                </div>
                <div>
                  4.4 ข้อมูลการร้องขอความยินยอมผู้ป่วยแบบรายครั้ง
                  ระบบแพลตฟอร์มดิจิทัล “ผูกพันธุ์”
                  จะเก็บรวบรวมข้อมูลนี้โดยอัตโนมัติ
                  เมื่อบุคลากรทางการแพทย์ทำการร้องขอความยินยอมผู้ป่วยแบบรายครั้ง
                </div>
                <div>
                  การเปิดเผยข้อมูลส่วนบุคคลของบุคลากรทางการแพทย์ในระบบแพลตฟอร์มดิจิทัล
                  “ผูกพันธุ์”
                  อาจมีการเปิดเผยให้แก่บุคคลที่ทำงานให้และทำงานร่วมกับผู้ให้บริการระบบฯ
                  อาทิเช่น ผู้ตรวจสอบระบบฯ ผู้พัฒนาดูแลระบบฯ
                  และผู้ประชาสัมพันธ์ระบบฯ
                  โดยบุคคลดังกล่าวดำเนินงานในนามผู้ควบคุมข้อมูล
                  และผู้ควบคุมข้อมูลมีหน้าท่ำกับดูแลการเข้าถึงข้อมูลของบุคคลดังกล่าว
                  เพื่อวัตถุประสงค์ในการปรับปรุง พัฒนา และส่งเสริมบริการของระบบฯ
                  ให้ปลอดภัย ถูกต้อง และมีประสิทธิภาพมากขึ้น
                </div>
                <div>
                  การใช้งานหรือเปิดเผยข้อมูลส่วนบุคคลของบุคลากรทางการแพทย์ภายในระบบแพลตฟอร์มดิจิทัล
                  “ผูกพันธุ์” จะเป็นไปตามวัตถุประสงค์ที่กล่าวไว้ข้างต้น
                  ความยินยอมเข้าร่วมระบบฯ ของบุคลากรทางการแพทย์
                  ข้อกำหนดและเงื่อนไขการใช้บริการสำหรับบุคลากรทางการแพทย์
                  และประกาศนโยบายคุ้มครองข้อมูลฉบับนี้อย่างเคร่งครัด
                  โดยผู้พัฒนาและดูแลระบบฯ
                  จะไม่นำข้อมูลส่วนบุคคลของบุคลากรทางการแพทย์
                  ไปใช้เพื่อการกระทำอื่นใดอันไม่เป็นไปตามวัตถุประสงค์
                  เว้นแต่จะได้รับความยินยอมอย่างถูกต้องจากบุคลากรทางการแพทย์
                  หรือมีการบังคับใช้ภายใต้หลักเกณฑ์ที่กฎหมายกำหนด
                  โดยบุคคลหรือหน่วยงานที่เข้าถึงข้อมูลหรือผู้ควบคุมข้อมูลส่วนบุคคลดังกล่าวจะต้องเก็บรวบรวม
                  เข้าถึง ใช้งาน จัดการ
                  และเปิดเผยข้อมูลส่วนบุคคลของบุคลากรทางการแพทย์ตามเงื่อนไขหรือขอบเขตเท่าที่จำเป็นเท่านั้น
                  ทั้งนี้ระบบแพลตฟอร์มดิจิทัล “ผูกพันธุ์”
                  จะต้องบันทึกการใช้หรือการเปิดเผยข้อมูลส่วนบุคคลดังกล่าวไว้
                  เพื่อให้เจ้าของข้อมูลส่วนบุคคลสามารถตรวจสอบได้
                  เป็นหนังสือหรือด้วยระบบอิเล็กทรอนิกส์ หากระบบฯ
                  ค้นพบการใช้งานแพลตฟอร์มดังกล่าว
                  ที่นอกขอบเขตข้อกำหนดและเงื่อนไขการใช้บริการสำหรับบุคลากรทางการแพทย์
                  ระบบฯ จะระงับการใช้งานของบุคลากรทางการแพทย์ทันที
                </div>
                <div>
                  <br />
                </div>
                <div>5. การจัดเก็บข้อมูลส่วนบุคคลของบุคลากรทางการแพทย์</div>
                <div>
                  ข้อมูลของบุคลากรทางการแพทย์จะถูกจัดเก็บในฐานข้อมูลบนศูนย์ข้อมูล
                  (server) ของกรมวิทยาศาสตร์การแพทย์
                  โดยข้อมูลของบุคลากรทางการแพทย์ จะถูกรักษาไว้อย่างดี
                  โดยมีการสำรองข้อมูล มาตรการในการรักษาความปลอดภัย
                  และกลไกในการปกป้องข้อมูลจากการสูญเสียต่าง ๆ
                  การเปิดเผยข้อมูลส่วนบุคคลของบุคลากรทางการแพทย์จะมีผลบังคับใช้ตลอดระยะเวลาที่บุคลากรทางการแพทย์ให้ความยินยอมใช้งานระบบแพลตฟอร์มดิจิทัล
                  “ผูกพันธุ์” หรือจนกว่าระบบแพลตฟอร์มดิจิทัล “ผูกพันธุ์”
                  จะยุติการให้บริการ
                  หรือเป็นไปตามข้อกำหนดของระเบียบกฎหมายที่เกี่ยวข้อง
                </div>
                <div>
                  <br />
                </div>
                <div>
                  6. การปฏิเสธคำขอหรือการคัดค้านเกี่ยวกับข้อมูลส่วนบุคคล
                </div>
                <div>
                  การดำเนินการต่าง ๆ
                  ที่เกิดขึ้นกับข้อมูลส่วนบุคคลของบุคลากรทางการแพทย์จะเป็นตามพระราชบัญญัติคุ้มครองข้อมูลส่วนบุคคล
                  พ.ศ. 2562
                </div>
                <div>
                  <br />
                </div>
                <div>
                  7.
                  ข้อมูลเกี่ยวกับผู้ประมวลผลและผู้ควบคุมข้อมูลส่วนบุคคลของบุคลากรทางการแพทย์
                </div>
                <div>
                  เมื่อบุคลากรทางการแพทย์เข้าร่วมใช้งานระบบแพลตฟอร์มดิจิทัล
                  “ผูกพันธุ์” ข้อมูลส่วนบุคคลของ
                  บุคลากรทางการแพทย์จะถูกเก็บรวบรวม เข้าถึง ใช้งาน จัดการ
                  และเปิดเผยโดยบุคคลหรือนิติบุคคลที่เกี่ยวข้องตามหน้าที่ความรับผิดชอบที่ได้รับมอบหมาย
                  ซึ่งจำแนกออกเป็น
                </div>
                <div>
                  7.1 ผู้ควบคุมข้อมูลส่วนบุคคล หมายถึง
                  บุคคลหรือนิติบุคคลซึ่งมีหน้าที่ตัดสินใจเกี่ยวกับการเก็บรวบรวม
                  เข้าถึง ใช้งาน จัดการ และเปิดเผยข้อมูลส่วนบุคคล ในที่นี้
                  ผู้ควบคุมข้อมูลส่วนบุคคลในระบบฯ ได้แก่
                </div>
                <div>
                  <span className={styles.dot}></span>
                  กรมวิทยาศาสตร์การแพทย์
                  โดยสถาบันชีววิทยาศาสตร์ทางซึ่งเป็นผู้ควบคุมดูแลข้อมูลที่อยู่ใน
                  ระบบฯ โดยมีหน้าที่
                </div>
                <div>
                  - เก็บรวบรวม เข้าถึง ใช้งาน จัดการ
                  และเปิดเผยข้อมูลของบุคลากรทางการแพทย์ตามที่บุคลากรทางการแพทย์ได้ให้ความยินยอมไว้
                </div>
                <div>
                  -
                  จัดให้มีมาตรการรักษาความมั่นคงปลอดภัยข้อมูลส่วนบุคคลอย่างเหมาะสม
                  รวมทั้งแจ้งให้ผู้ควบคุมข้อมูลส่วนบุคคลทราบถึงการละเมิดข้อมูลส่วนบุคคลที่เกิดขึ้น
                </div>
                <div>
                  -
                  จัดทำและเก็บรักษาบันทึกรายการกิจกรรมการประมวลผลข้อมูลส่วนบุคคลที่เกิดขึ้นอย่างถูกต้องครบถ้วน
                </div>
                <div>
                  <span className={styles.dot}></span>
                  กรมการปกครอง
                  ซึ่งจะเป็นผู้ควบคุมข้อมูลส่วนบุคคลสำหรับข้อมูลส่วนตัวจากการดำเนินการตรวจสอบเลขหลังบัตรประชาชนเพื่อยืนยันตัวบุคคล
                  ที่กระทำโดยบุคลากรทางการแพทย์ผ่านขั้นตอนการกรอกข้อมูลเพื่อสมัครเข้าใช้งานระบบฯ
                </div>
                <div>
                  <span className={styles.dot}></span>
                  สำนักสุขภาพดิจิทัล สำนักปลัดกระทรวงสาธารณสุข
                  ซึ่งจะเป็นผู้ควบคุมข้อมูลส่วนบุคคลสำหรับข้อมูลส่วนตัวจากการดำเนินการสมัครใช้งานและยืนยันตัวตน
                  (e-KYC) ที่กระทำโดยบุคลากรทางการแพทย์ผ่านทางแอปพลิเคชัน
                  “หมอพร้อม”
                </div>
                <div>
                  <span className={styles.dot}></span>
                  บริษัท ซอฟต์แม็กซ์ จำกัด
                  ซึ่งจะเป็นผู้ควบคุมข้อมูลส่วนบุคคลสำหรับข้อมูลส่วนตัวจากการดำเนินการสมัครใช้งานและยืนยันตัวตน
                  (e-KYC) ที่กระทำโดยบุคลากรทางการแพทย์ผ่านทางแอปพลิเคชัน
                  “OnesID”
                </div>
                <div>
                  7.2 ผู้ประมวลผลข้อมูลส่วนบุคคล หมายถึง
                  บุคคลหรือนิติบุคคลซึ่งดำเนินการเกี่ยวกับ การเก็บรวบรวม เข้าถึง
                  ใช้งาน จัดการ
                  และเปิดเผยข้อมูลส่วนบุคคลตามคำสั่งหรือในนามของผู้ควบคุมข้อมูลส่วนบุคคล
                  ในที่นี้ ผู้ประมวลผลข้อมูลส่วนบุคคลในระบบฯ ได้แก่
                </div>
                <div>
                  7.3 กรมวิทยาศาสตร์การแพทย์ โดย ศูนย์เทคโนโลยีสารสนเทศ
                  ซึ่งมีหน้าที่ดำเนินการเก็บรวบรวม ใช้งาน จัดการ
                  และเปิดเผยข้อมูลของบุคลากรทางการแพทย์ตามที่ได้รับมอบหมายจากผู้ควบคุมข้อมูลและตามที่บุคลากรทางการแพทย์ได้แสดงความยินยอมไว้
                  เว้นแต่จะขัดต่อข้อกฎหมายหรือพระราชบัญญัติคุ้มครองข้อมูลส่วนบุคคล
                  พ.ศ. 2562
                </div>
                <div>
                  7.4 บุคคลอื่น
                  ที่ผู้ควบคุมข้อมูลกำหนดเพื่อดำเนินการตามวัตถุประสงค์ของระบบฯ
                </div>
                <div>
                  <br />
                </div>
                <div>8. การเปลี่ยนแปลงนโยบายการคุ้มครองข้อมูลส่วนบุคคล</div>
                <div>
                  ผู้ให้บริการระบบแพลตฟอร์มดิจิทัล “ผูกพันธุ์”
                  ขอสงวนสิทธิในการปรับปรุงหรือแก้ไขรายละเอียดนโยบายคุ้มครองข้อมูลส่วนบุคคล
                </div>
                <div>
                  <span className={styles.dot}></span>
                  เพื่อวัตถุประสงค์ของระบบฯ
                </div>
                <div>
                  <span className={styles.dot}></span>
                  เพื่อพัฒนา ทดสอบ และให้บริการระบบฯ
                </div>
                <div>
                  <span className={styles.dot}></span>
                  เพื่อให้เกิดผลประโยชน์ต่อผู้ใช้บริการ
                  และสาธารณสุขให้มากยิ่งขึ้น
                </div>
                <div>
                  <span className={styles.dot}></span>
                  เพื่อให้สอดคล้องกับพระราชบัญญัติคุ้มครองข้อมูลส่วนบุคคล พ.ศ.
                  2562 หรือหลักกฎหมายอื่น ๆ ที่เกี่ยวข้อง
                </div>
                <div>
                  ซึ่งระบบฯ
                  จะประกาศอย่างชัดเจนให้บุคลากรทางการแพทย์ทราบก่อนการดำเนินการพร้อมทั้งขอความยินยอมจากบุคลากรทางการแพทย์อีกครั้งหากจำเป็น
                  ปัจจุบัน
                  นโยบายการคุ้มครองข้อมูลส่วนบุคคลของบุคลากรทางการแพทย์ถูกทบทวนครั้งล่าสุดเมื่อวันที่
                  10 พฤศจิกายน 2566
                </div>
                <div>
                  <br />
                </div>
                <div>
                  9. การรักษาความปลอดภัยของข้อมูลส่วนบุคคลของบุคลากรทางการแพทย์
                </div>
                <div>
                  ระบบแพลตฟอร์มดิจิทัล “ผูกพันธุ์”
                  ได้มีการออกแบบและพัฒนาโดยตระหนักและให้ความสำคัญกับการรักษาความปลอดภัยของข้อมูลในทุกกระบวนการ
                  เพื่อปกป้องข้อมูลของบุคลากรทางการแพทย์จากการทำลาย
                  หรือบุกรุกจากผู้ไม่หวังดีหรือผู้ไม่มีสิทธิในการเข้าถึงข้อมูล
                  มีระบบการลงทะเบียนด้วย e-KYC และทำการเข้ารหัสข้อมูล (Data
                  Encryption)
                  ซึ่งทำให้ผู้ที่ดักจับข้อมูลไม่สามารถนำข้อมูลไปใช้ต่อได้
                </div>
                <div>
                  ข้อมูลส่วนบุคคลในระบบแพลตฟอร์มดิจิทัล “ผูกพันธุ์”
                  จะถูกปกป้องอย่างเคร่งครัด จึงทำให้
                  การใช้งานของข้อมูลในระบบดังกล่าว
                  เป็นไปตามข้อกำหนดทางกฎหมายที่เกี่ยวข้อง ทั้งนี้ แม้ว่าระบบฯ
                  ได้มีการออกแบบและพัฒนาเพื่อรักษาความปลอดภัยเป็นอย่างดีที่สุดก็ตาม
                  ระบบแพลตฟอร์มดิจิทัล “ผูกพันธุ์”
                  ไม่สามารถปกป้องข้อมูลของบุคลากรทางการแพทย์ได้อย่างเด็ดขาด
                  ดังนั้น บุคลากรทางการแพทย์ ควรตระหนักเรื่องการรักษาความปลอดภัย
                  และดูแลอุปกรณ์ของบุคลากรทางการแพทย์เป็นอย่างดีเช่นเดียวกัน
                </div>
                <div>
                  <br />
                </div>
                <div>10. การจำกัดความรับผิดชอบ</div>
                <div>
                  ทางระบบแพลตฟอร์มดิจิทัล “ผูกพันธุ์”
                  ขอสงวนสิทธิที่จะไม่รับผิดชอบต่อความเสียหาย ค่าใช้จ่าย
                  ความสูญเสียที่อาจเกิดขึ้นจากการดำเนินการของโครงการฯ
                  ทั้งทางตรงและทางอ้อม รวมถึงความถูกต้องแม่นยำของข้อมูล
                  ความล่าช้าในการโอนถ่ายข้อมูล ระยะเวลาในการเปิดเผยข้อมูล
                  เหตุขัดข้องหรืออุปสรรคของการเชื่อมต่อ ความผิดพลาดในการแสดงผล
                  ความเสถียรของระบบฯ และไวรัสคอมพิวเตอร์จากการใช้งานระบบฯ
                </div>
                <div>
                  <br />
                </div>
                <div>11. ช่องทางการติดต่อ</div>
                <div>
                  หากบุคลากรทางการแพทย์ประสงค์จะติดต่อ หรือมีข้อสงสัย
                  หรือต้องการสอบถามข้อมูลเกี่ยวกับรายละเอียดการเก็บรวบรวม ใช้
                  และ/หรือเปิดเผยข้อมูลส่วนบุคคล
                  รวมถึงสิทธิของบุคลากรทางการแพทย์นโยบายฉบับนี้
                  หรือต้องการยกเลิกการให้ความยินยอมในการเก็บรวบรวม ใช้
                  และ/หรือเปิดเผยข้อมูลส่วนบุคคล
                  หรือกรณีที่พบว่ามีการใช้ข้อมูลส่วนบุคคลของบุคลากรทางการแพทย์ไปในทางที่ไม่ชอบ
                  บุคลากรทางการแพทย์สามารถติดต่อสำนักงานทางช่องทางดังต่อไปนี้
                </div>
                <div>
                  <br />
                </div>
                <div>
                  สถาบันชีววิทยาศาสตร์ทางการแพทย์ กรมวิทยาศาสตร์การแพทย์
                </div>
                <div>
                  สถานที่ติดต่อ: 88/7 ซอยบำราศนราดูร ถ.ติวานนท์ ต.ตลาดขวัญ
                  อ.เมือง จ.นนทบุรี 11000
                </div>
                <div>เวลาทำการปกติ: วันจันทร์ถึงศุกร์ เวลา 8:30 – 16:30 น.</div>
                <div>เว็บไซต์: https://phukphan.dmsc.moph.go.th/</div>
                <div>
                  <br />
                </div>
                <div>ติดต่อสอบถาม :</div>
                <div style={{ fontWeight: 700 }}>นางสาวพรนภัส อยู่นุช</div>
                <div>อีเมลล์: pornnapat.y@dmsc.mail.go.th</div>
                <div>หมายเลขโทรศัพท์: 0-2589-9850 ถึง 8 ต่อ 98096</div>

                <div style={{ fontWeight: 700 }}>นายพนาพัฒน์ ไพเราะ</div>
                <div>อีเมลล์: panapat.p@dmsc.mail.go.th</div>
                <div>หมายเลขโทรศัพท์: 0-2951-0000 ต่อ 99394</div>

                <div style={{ fontWeight: 700 }}>นางสาวนภัชชา ถาวงศ์</div>
                <div>อีเมลล์: penpitcha.t@dmsc.mail.go.th</div>
                <div>หมายเลขโทรศัพท์: 0-2589-9850 ถึง 8 ต่อ 98096</div>

                <div style={{ fontWeight: 700 }}>นายอาคม สาลี</div>
                <div>อีเมลล์: arkom.s@dmsc.mail.go.th</div>
                <div>หมายเลขโทรศัพท์: 0-2951-0000 ต่อ 99460</div>
              </div>
            </div>
          ) : (
            <div className={styles.card}>
              <div className={styles.title}>สำหรับแพทย์/ เภสัชกร</div>
              <br />
              <div className={styles.detail}>
                <div>
                  บุคลากรทางการแพทย์ตกลงใช้บริการของระบบแพลตฟอร์มดิจิทัล
                  “ผูกพันธุ์” ของกระทรวงสาธารณะสุข
                  ตามรายละเอียดการให้บริการที่ระบบฯ กำหนด
                  โดยยอมรับและตกลงที่จะผูกพัน
                  และปฏิบัติตามข้อกำหนดและเงื่อนไขการใช้บริการ ดังต่อไปนี้
                </div>
                <div>
                  <br />
                </div>
                <div>1. คำนิยาม</div>
                <div>
                  1.1 “ระบบแพลตฟอร์มดิจิทัล” หรือ “Digital Platform” ผูกพันธุ์
                  (ระบบฯ) หมายความว่า บริการดิจิทัลภาครัฐที่พัฒนา
                  หรือจัดหาและให้บริการ โดยกรมวิทยาศาสตร์การแพทย์
                  โดยมีวัตถุประสงค์ให้ประชาชน บุคลาการทางการแพทย์
                  สามารถเข้าถึงข้อมูลพันธุกรรม ได้แก่
                  ผลการตรวจทางเภสัชพันธุศาสตร์ เป็นต้น โดยระบบแพลตฟอร์มดิจิทัล
                  “ผูกพันธุ์” แบ่งการใช้งานออกเป็น 2 ระบบ ได้แก่
                </div>
                <div>
                  <span className={styles.dot}></span>
                  “แอปพลิเคชัน” หรือ “Application” ผูกพันธุ์ หมายความว่า
                  แอปพลิเคชัน “ผูกพันธุ์” ตลอดจนโปรแกรมคอมพิวเตอร์ ชุดคำสั่ง
                  หรือแอปพลิเคชันอื่น ๆ ที่ต้องใช้หรืออาจใช้ร่วมกัน
                  หรือเกี่ยวเนื่องกันกับแอปพลิเคชันดังกล่าว เพื่อการใช้บริการ
                  “ผูกพันธุ์” ไม่ว่าจะใช้งานผ่านโทรศัพท์มือถือ แท็บเล็ต เว็บ
                  หรือผ่านอุปกรณ์อื่นใดก็ตาม ทั้งนี้ ในกรณีที่ แอปพลิเคชัน
                  “ผูกพันธุ์”
                  เปลี่ยนชื่อเป็นอย่างอื่นหรือมีแอปพลิเคชันอื่นรวมอยู่ด้วย
                  ให้หมายความรวมถึงแอปพลิเคชันนั้นด้วย
                </div>
                <div>
                  <span className={styles.dot}></span>
                  “เว็บไซต์” หรือ “website” ผูกพันธุ์ หมายความว่า เว็บไซต์
                  “ผูกพันธุ์” ตลอดจนหน้าเว็บเพจที่ทำขึ้นเพื่อนำเสนอข้อมูลต่าง ๆ
                  ผ่านทางคอมพิวเตอร์ และอินเทอร์เน็ต
                  โดยมีหลายหน้าที่เชื่อมโยงเข้ากับไฮเปอร์ลิงก์
                  เพื่อให้สามารถเปิดไปยังหน้าเพจต่าง ๆ และถูกจัดเก็บไว้ใน www.
                  (เวิลด์ไวด์เว็บ) โดยเว็บไซต์ผูกพันธุ์ หรือ
                  https://phukphan.dmsc.moph.go.th/ มีไว้เพื่อให้ประชาชน
                  บุคลากรทางการแพทย์ สามารถเข้าถึงข้อมูลพันธุกรรมได้
                  นอกจากนี้ยังให้เจ้าหน้าที่ห้องปฏิบัติการสามารถเปิดห้องปฏิบัติการของตนเองและสามารถรายงานผลการตรวจทางพันธุกรรมได้
                </div>
                <div>
                  1.2 “ข้อมูลส่วนบุคคล” หมายความว่า ข้อมูลส่วนตัว หรือ
                  ข้อมูลเกี่ยวกับผู้ใช้บริการ
                  ซึ่งทำให้สามารถระบุตัวตนของผู้ใช้บริการได้ไม่ว่าทางตรงหรือทางอ้อม
                  ซึ่งรวมถึงข้อมูลทั่วไปของผู้ใช้บริการ ข้อมูลที่ใช้ยืนยันตัวตน
                  ข้อมูลชีวมาตรหรือ biometrics (เช่น ลายนิ้วมือ ใบหน้า เป็นต้น)
                  ข้อมูลสุขภาพ และข้อมูลส่วนบุคคลอื่นใดเกี่ยวกับผู้ใช้บริการ
                  ตามกฎหมายว่าด้วยการคุ้มครองข้อมูลส่วนบุคคล ทั้งนี้
                  ไม่รวมถึงข้อมูลเกี่ยวกับผู้ใช้บริการ
                  ในกรณีที่ผู้ใช้บริการถึงแก่กรรม และไม่รวมถึงข้อมูลทางสถิติ
                  หรือข้อมูลที่ไม่สามารถระบุตัวบุคคลที่เป็นเจ้าของข้อมูลส่วนบุคคลได้
                  ซึ่งไม่ถือเป็นข้อมูลส่วนบุคคล
                  ตามกฎหมายว่าด้วยการคุ้มครองข้อมูลส่วนบุคคล
                </div>
                <div>
                  1.3 “ข้อมูลสุขภาพ” หมายความว่า
                  ข้อมูลส่วนบุคคลของผู้ใช้บริการที่มีเนื้อหาเกี่ยวกับสุขภาพ
                  ได้แก่ ข้อมูลการแพ้ยา ข้อมูลโรควินิจฉัย ข้อมูลการจ่ายยา
                  ข้อมูลวัคซีน ข้อมูลหัตถการ ข้อมูลค่าผลตรวจ ทางการแพทย์
                  ข้อมูลผลตรวจห้องปฏิบัติและผลสรุปภาพถ่ายทางการแพทย์
                  ข้อมูลสุขภาพละเอียดอ่อน เช่น ข้อมูลพันธุกรรม เป็นต้น
                  และข้อมูลการเข้ารับบริการการรักษาพยาบาล
                  รวมไปถึงข้อมูลสุขภาพอื่น ๆ ที่อาจมีเพิ่มเติมในอนาคต
                </div>
                <div>
                  1.4 “ผู้ใช้บริการ” หมายความว่า ผู้ใช้งาน ระบบแพลตฟอร์มดิจิทัล
                  “ผูกพันธุ์” แบ่งการใช้งานตามระบบฯ และบทบาทดังต่อไปนี้
                </div>
                <div>
                  <span className={styles.dot}></span>
                  “ประชาชน” หมายความว่า ผู้ป่วย หรือ บุคคลทั่วไป
                  ที่เข้าใช้งานระบบแพลตฟอร์มดิจิทัล “ผูกพันธุ์”
                </div>
                <div>
                  <span className={styles.dot}></span>
                  “บุคลากรทางการแพทย์” หมายความว่า ผู้ประกอบวิชาชีพทางการแพทย์
                  ได้แก่ แพทย์ เภสัชกรพยาบาล เทคนิคการแพทย์ กายภาพบำบัด
                  แพทย์แผนไทย นักสาธารณสุขชุมชน รวมทั้ง
                  ผู้ที่มีหน้าที่ในการดูแลรักษาผู้ป่วยในด้านอื่น ๆ
                </div>
                <div>
                  <span className={styles.dot}></span>
                  “ผู้ปฏิบัติงานในห้องปฏิบัติการ” หมายความว่า
                  ผู้มีหน้าที่รับผิดชอบในการดำเนินการวิเคราะห์
                  ผลการตรวจทางพันธุกรรมที่โรงพยาบาลได้ทำการส่งตัวอย่างมาที่กรมวิทยาศาสตร์การแพทย์
                  ได้แก่ นักเทคนิคการแพทย์ และ นักวิทยาศาสตร์การแพทย์
                </div>
                <div>
                  1.5 “โรงพยาบาล” หมายความว่า
                  สถานที่รวมตลอดถึงยานพาหนะซึ่งจัดไว้เพื่อการประกอบโรคศิลปะ
                  ตามกฎหมายว่าด้วยการประกอบโรคศิลปะ
                  การประกอบวิชาชีพเวชกรรมตามกฎหมายว่าด้วยวิชาชีพเวชกรรม
                  การประกอบวิชาชีพการพยาบาลและการผดุงครรภ์ตามกฎหมายว่าด้วยวิชาชีพ
                  การพยาบาลและการผดุงครรภ์
                  การประกอบวิชาชีพทันตกรรมตามกฎหมายว่าด้วยวิชาชีพทันตกรรม
                  เทคนิคการแพทย์ตามกฎหมายว่าด้วยวิชาชีพเทคนิค การแพทย์
                  การประกอบวิชาชีพการแพทย์แผนไทยและการประกอบวิชาชีพการแพทย์แผนไทยประยุกต์ตามกฎหมายว่าด้วยวิชาชีพการแพทย์แผนไทย
                  หรือการประกอบวิชาชีพทางการแพทย์และสาธารณสุขอื่นตามกฎหมายว่าด้วยการนั้น
                </div>
                <div>
                  1.6 “ระบบสารสนเทศโรงพยาบาล” หรือ “Hospital Information System:
                  HIS” หมายความว่า ระบบการจัดการโรงพยาบาลที่ช่วยในการจัดเก็บ
                  จัดการ และส่งต่อข้อมูลจำนวนมากทั้งจากภายใน และภายนอกโรงพยาบาล
                  ให้ผู้บริหารสามารถจัดสรรทรัพยากรต่างๆ
                  ของโรงพยาบาลได้อย่างคุ้มค่า
                  เพิ่มประสิทธิภาพของการทำงานและการรักษาผู้ป่วยได้อย่างรวดเร็ว
                </div>
                <div>
                  1.7 “ระบบรับ-ส่งตัวอย่างเพื่อตรวจวิเคราะห์” หรือ “iLAB PLUS”
                  หมายความว่า ระบบรับ-ส่งตัวอย่าง
                  เพื่อตรวจวิเคราะห์กรมวิทยาศาสตร์การแพทย์ กระทรวงสาธารณสุข
                  โดยผู้ใช้จะแบ่งเป็นสำหรับหน่วยงานผู้ขอรับบริการ
                  และสำหรับเจ้าหน้าที่กรมวิทยาศาสตร์การแพทย์
                  ซึ่งผู้ขอรับบริการเป็นผู้ส่งตัวอย่างให้กับห้องปฏิบัติการของกรมวิทยาศาสตร์การแพทย์
                  จากนั้นจะทำการวิเคราะห์ผลทางห้องปฏิบัติการ
                  เมื่อวิเคราะห์ผลเรียบร้อยแล้วจะทำการออกรายงานผล
                  รับรองผลการตรวจวิเคราะห์
                  และส่งผลการตรวจวิเคราะห์กลับให้ทางผู้ขอรับบริการนั้น ๆ
                </div>
                <div>
                  1.8 “ผู้ให้บริการ”
                  หมายความหน่วยงานที่มีหน้าที่และ/หรือได้รับมอบหมายในการจัดทำ
                  พัฒนา และให้บริการระบบแพลตฟอร์มดิจิทัล“ผูกพันธุ์”
                </div>
                <div>
                  <br />
                </div>
                <div>บทนำ</div>
                <div>
                  ระบบแพลตฟอร์มดิจิทัล “ผูกพันธุ์” (ระบบฯ) คือ
                  แพลตฟอร์มดิจิทัลที่มีจุดประสงค์เพื่อรวบรวมข้อมูลพันธุกรรม
                  ที่กรมวิทยาศาสตร์การแพทย์และห้องปฏิบัติการอื่น ๆ ให้บริการ
                  และให้ผู้ใช้บริการงานสามารถเข้าถึงผลการตรวจผ่านช่องทางต่าง ๆ
                  เช่น เว็บไซต์และแอปพลิเคชัน “ผูกพันธุ์”
                  ระเบียนสุขภาพอิเล็กทรอนิกส์ส่วนบุคคล (Personal Health Record:
                  PHR) และระบบสารสนเทศของโรงพยาบาล (Hospital Information System:
                  HIS) เป็นต้น โดยมีผู้ใช้บริการงานระบบ และบทบาทที่เกี่ยวข้อง
                  ดังนี้
                </div>
                <div>
                  1. ประชาชน
                  เข้าถึงและแสดงผลการตรวจของตนเองให้บุคลาการทางการแพทย์ที่รักษา
                </div>
                <div>
                  2. บุคลาการทางการแพทย์ เข้าถึงและใช้ผลการตรวจของประชาชน
                  ประกอบการพิจารณาวินิจฉัย ป้องกัน และรักษาโรคที่เฉพาะบุคคล
                  ส่งเสริมการรักษาแบบการแพทย์แม่นยำ (Precision Medicine)
                </div>
                <div>
                  3. ผู้ปฏิบัติงานในห้องปฏิบัติการ ได้แก่ นักเทคนิคการแพทย์ และ
                  นักวิทยาศาสตร์การแพทย์ ลงข้อมูล
                  ผลการตรวจในระบบแพลตฟอร์มดิจิทัล “ผูกพันธุ์”
                </div>
                <div>
                  ระบบฯ ถูกออกแบบให้รองรับการเชื่อมต่อ PHR ต่าง ๆ
                  ทำให้ประชาชนมีทางเลือกในการเข้าถึงข้อมูลพันธุกรรมมากขึ้น
                  และการเชื่อมโยงข้อมูลกับระบบ HIS
                  ทำให้สามารถรับ-ส่งข้อมูลพันธุกรรมเข้าสู่ระบบของโรงพยาบาลได้
                  ดังนั้น เพื่อให้ผู้ให้บริการระบบฯ สามารถให้บริการฯ
                  แก่ผู้ใช้บริการได้
                  ผู้ใช้บริการจะต้องแสดงเจตนาให้กรมวิทยาศาสตร์ กระทรวงสาธารณสุข
                  และผู้ให้บริการระบบฯ
                  ด้วยการตกลงยอมรับข้อกำหนดและเงื่อนไขการใช้บริการสำหรับประชาชน
                </div>
                <div>
                  ผู้ใช้บริการตกลงที่จะให้กรมวิทยาศาสตร์ กระทรวงสาธารณสุข
                  เก็บรวมรวม ใช้ จัดการ และเปิดเผยข้อมูลส่วนบุคคล
                  ของผู้ใช้บริการ รวมทั้งข้อมูลสุขภาพ
                  รวมทั้งยินยอมให้ผู้ให้บริการระบบฯ และโรงพยาบาลที่เข้าร่วมระบบฯ
                  เก็บรวบรวม ใช้ จัดการ
                  และเปิดเผยข้อมูลดังกล่าวเพื่อการดำเนินการตามวัตถุประสงค์ของระบบฯ
                </div>
                <div>
                  <br />
                </div>
                <div>
                  การแก้ไขข้อกำหนดและเงื่อนไขการใช้บริการสำหรับบุคลากรทางการแพทย์
                </div>
                <div>
                  ผู้ให้บริการระบบดิจิทัลแพลตฟอร์ม “ผูกพันธุ์”
                  อาจมีการแก้ไขเปลี่ยนแปลงข้อกำหนดและเงื่อนไขการใช้บริการสำหรับบุคลากรทางการแพทย์
                  ตามเหตุอันเห็นสมควร
                  โดยไม่จำเป็นต้องแจ้งให้ผู้ใช้บริการทราบล่วงหน้า ยกเว้น
                  มีเหตุที่อาจเกิดผลกระทบต่อข้อมูลส่วนบุคคล
                  การแก้ไขเปลี่ยนแปลงจะมีผลบังคับใช้เมื่อมีการประกาศ
                  ข้อกำหนดและเงื่อนไขการใช้บริการสำหรับบุคลากรทางการแพทย์
                  ที่แก้ไขไว้บนระบบฯ
                  ผู้ใช้บริการจะต้องตกลงยอมรับการเปลี่ยนแปลงของข้อกำหนดและเงื่อนไขการใช้บริการสำหรับบุคลากรทางการแพทย์
                  เพื่อใช้บริการฯ
                  หลังจากมีการเปลี่ยนแปลงข้อกำหนดและเงื่อนไขการใช้บริการสำหรับบุคลากรทางการแพทย์
                  ผู้ใช้บริการควรตรวจสอบและทำความเข้าใจข้อกำหนด
                  และเงื่อนไขการใช้บริการสำหรับบุคลากรทางการแพทย์
                  ที่มีการเปลี่ยนแปลงอย่างถี่ถ้วนระมัดระวัง และหากผู้ใช้บริการ
                  ไม่ประสงค์ที่จะใช้งานระบบฯ
                  ต่อไปภายใต้ข้อกำหนดและเงื่อนไขการใช้บริการสำหรับบุคลากรทางการแพทย์
                  ฉบับใหม่ ผู้ใช้บริการสามารถดำเนินการยกเลิกการใช้งานระบบฯ ได้
                  ปัจจุบัน
                  ข้อกำหนดและเงื่อนไขการใช้บริการสำหรับบุคลากรทางการแพทย์
                  ถูกทบทวนครั้งล่าสุดเมื่อวันที่ 10 พฤศจิกายน 2566
                </div>
                <div>
                  <br />
                </div>
                <div>การคุ้มครองข้อมูลส่วนบุคคล</div>
                <div>
                  1. ผู้ให้บริการระบบฯ
                  ยึดมั่นและให้ความสำคัญกับการรักษาความเป็นส่วนตัวของผู้ใช้บริการ
                  โดยจะจัดให้มีการคุ้มครองข้อมูล
                  ส่วนบุคคลของผู้ใช้บริการตามเอกสารนโยบายการคุ้มครองข้อมูลส่วนบุคคลของบุคลากรทางการแพทย์
                </div>
                <div>
                  2. ผู้ให้บริการระบบฯ
                  จะกระทำการโดยระมัดระวังอย่างสูงสุดเพื่อปกป้องข้อมูลของผู้ใช้บริการจากการถูกทำลาย
                  หรือบุกรุกโดยผู้ไม่มีสิทธิ์ในการเข้าถึงข้อมูล อย่างไรก็ตาม
                  ในปัจจุบันผู้ให้บริการระบบฯ
                  ยังไม่สามารถรับประกันการปกป้องข้อมูลได้อย่างเด็ดขาดจากการถูกทำลายหรือเข้าถึงจากแพทย์หรือบุคคลภายนอกที่ไม่เกี่ยวข้องหรือผู้ไม่หวังดี
                </div>
                <div>บัญชีผู้ใช้บริการ</div>
                <div>
                  1. ผู้ใช้บริการจะต้องยืนยันตัวตนผ่านแพลตฟอร์ม หมอพร้อม หรือ
                  OnesID หรือ ThaiD เมื่อสมัครใช้งานสำเร็จ ผู้ให้บริการระบบฯ
                  จะอนุมัติให้ผู้ใช้บริการสามารถเข้าใช้งาน
                  จากการตรวจเลขใบกระกอบวิชาชีพของบุคลากรทางการแพทย์ ดังนั้น
                  ผู้ใช้บริการจำเป็นต้องเป็นบุคลากรทางการแพทย์ที่มีเลขใบประกอบวิชาชีพเท่านั้น
                  ถึงจะสามารถเข้าใช้งานระบบฯได้
                </div>
                <div>
                  2. รายละเอียดข้อมูลส่วนตัว บนบัญชีของผู้ใช้บริการในระบบฯ
                  จะเป็นไปการลงทะเบียนผ่านแพลตฟอร์ม หมอพร้อม หรือ ThaiD หรือ
                  OnesID หรือระบบแพลตฟอร์มดิจิทัล “ผูกพันธุ์”เท่านั้น
                </div>
                <div>3. ผู้ใช้บริการระบบสามารถใช้งานระบบฯ ได้ดังต่อไปนี้</div>
                <div>
                  <span className={styles.dot}></span>
                  สามารถค้นหาเลขบัตรประจำตัวประชาชนหรือชื่อ-นามสกุลของประชาชนเพื่อขออนุญาตเข้าถึงข้อมุลของประชาชนได้
                </div>
                <div>
                  <span className={styles.dot}></span>
                  สามารถเรียกดูประวัติการเข้าถึงข้อมูลของประชาชนที่ตนเองเป็นคนขออนุญาต
                </div>
                <div>
                  <span className={styles.dot}></span>
                  สามารถถ่ายทอดประสบการณ์การรักษา
                  แนวทางการตรวจหรืองานวิจัยให้กับบุคลากรทางการแพทย์ท่านอื่นๆสามารถเข้ามาศึกษารายละเอียดข้อมูลดังกล่าวได้
                </div>
                <div>
                  4.
                  ข้อมูลส่วนบุคคลของผู้ใช้บริการจะมาจากการลทะเบียนผ่านแพลตฟอร์ม
                  หมอพร้อม หรือ ThaiD หรือ OnesID หรือระบบแพลตฟอร์มดิจิทัล
                  “ผูกพันธุ์” หากข้อมูลดังกล่างไม่ถูกต้อง
                  ผู้ใช้บริการจะต้องติดต่อผู้ให้บริการระบบฯ
                  แก้ไข้ข้อมูลให้ถูกต้อง
                </div>
                <div>
                  5.
                  ความถูกต้องครบถ้วนและเป็นจริงของข้อมูลเกี่ยวกับบัญชีผู้ใช้ไม่ได้อยู่ภายใต้ความรับผิดชอบของผู้ให้บริการระบบฯ
                  โดยตรง
                </div>
                <div>
                  6. ผู้ให้บริการระบบฯ ถือว่าการใช้บริการฯ หรือกิจกรรมใด ๆ
                  ที่ดำเนินการภายใต้บัญชีดังกล่าวเป็นกิจกรรมที่ผู้ใช้บริการผู้เป็นเจ้าของบัญชีได้ดำเนินการด้วยตนเองทั้งสิ้น
                  ทั้งนี้
                  เว้นแต่จะมีหลักฐานที่สามารถพิสูจน์ได้ว่าเกิดขึ้นโดยผู้ใช้บริการไม่รับรู้และไม่ยินยอม
                  หรือเกิดจากความผิดพลาดของระบบฯ หรือเหตุสุดวิสัย
                </div>
                <div>
                  7. หากผู้ใชริบริการต้องการเข้าถึงข้อมูลส่วนบุคคลของประชาชน
                  ผู้ใช้บริการจำเป็นต้องขออนุญาตเข้าถึงข้อมูลส่วนตัวของประชาชนก่อน
                  ถึงจะสามารถดูข้อมูลดังกล่าวได้
                  โดยที่ประชาชนมีสิทธิในการอนุญาตหรือเพิกถอนในการเข้าถึงข้อมูลของตนเองได้
                </div>
                <div>
                  8. ผู้ให้บริการระบบฯ
                  มีสิทธิในการระงับการเข้าใช้งานหรือเพิกถอนบัญชีในระบบฯ
                  รวมถึงการใช้บริการฯ ต่าง ๆ ผ่านบัญชีในระบบฯ
                  ของผู้ใช้บริการได้โดยไม่จำเป็นต้องแจ้งให้ทราบล่วงหน้า
                  หากทางผู้ให้บริการระบบฯ
                  ตรวจสอบพบว่าผู้ใช้บริการได้ละเมิดหรือกำลังกระทำการอันเป็นการละเมิดข้อกำหนดและเงื่อนไขฯ
                </div>
                <div>
                  9. บัญชีของผู้ใช้บริการแต่ละบัญชีในระบบฯ
                  สงวนไว้เพื่อการใช้งานเฉพาะและโดยผู้เป็นเจ้าของบัญชีแต่เพียงผู้เดียวเท่านั้น
                  ผู้ใช้บริการไม่สามารถโอนสิทธิการใช้งานหรือให้ยืมบัญชีของตนแก่บุคคลอื่นไม่ว่ากรณีใดก็ตาม
                </div>
                <div>
                  <br />
                </div>
                <div>คุณสมบัติการใช้งานระบบแพลตฟอร์มดิจิทัล “ผูกพันธุ์”</div>
                <div>
                  ผู้ใช้บริการสามารถค้นหารายละเอียดของบริการฯ
                  ได้ผ่านเว็บไซต์หรือแอปพลิเคชันของระบบฯ
                  หรือในหนังสือแสดงความยินยอมเข้าร่วมระบบฯ
                  คุณสมบัติการใช้งานระบบแพลตฟอร์มดิจิทัล “ผูกพันธุ์”
                  ที่เป็นส่วนหนึ่งของบริการ ประกอบด้วยคุณสมบัติดังนี้
                  ซึ่งผู้ใช้บริการสามารถใช้งานได้ตลอด 24 ชั่วโมง
                  (ยกเว้นกรณีที่ระบบฯ
                  หยุดให้บริการเป็นการชั่วคราวเพื่อบำรุงรักษาระบบฯ หรือ
                  กรณีเกิดเหตุขัดข้อง) ทั้งนี้ ผู้ให้บริการระบบฯ
                  อาจเพิ่มเติมคุณสมบัติอื่น
                  หรือเปลี่ยนแปลงหรือยกเลิกคุณสมบัติเหล่านี้ได้ในอนาคต
                </div>
                <div>
                  <span className={styles.dot}></span>
                  การลงทะเบียนใช้งานระบบฯ
                </div>
                <div>
                  <span className={styles.dot}></span>
                  การถอนการลงทะเบียนใช้งานระบบฯ
                </div>
                <div>
                  <span className={styles.dot}></span>
                  การค้นหาข้อมูลส่วนบุคคลของประชาชนเพื่อขอเข้าถึงข้อมูลส่วนบุคคลของประชาชน
                </div>
                <div>
                  <span className={styles.dot}></span>
                  สิทธิ์การเข้าถึงข้อมูลส่วนบุคคลของประชาชน
                </div>
                <div>
                  <br />
                </div>
                <div>การให้บริการของระบบแพลตฟอร์มดิจิทัล “ผูกพันธุ์”</div>
                <div>
                  1. ผู้ใช้บริการหรือหน่วยงานฯ
                  จะต้องเป็นผู้ดูแลรับผิดชอบในการจัดหาเครื่องคอมพิวเตอร์
                  อุปกรณ์โทรศัพท์เคลื่อนที่ หรืออุปกรณ์อิเล็กทรอนิกส์ใด ๆ
                  รวมถึงระบบปฏิบัติการและการเชื่อมต่อข้อมูลที่จำเป็นสำหรับการใช้บริการฯ
                </div>
                <div>
                  2.
                  ผู้ใช้บริการสามารถสร้างบัญชีผู้ใช้โดยการลงทะเบียนผ่านเว็บไซต์หรือแอปพลิเคชัน
                  ดังต่อไปนี้
                </div>
                <div>
                  <span className={styles.dot}></span>
                  เว็บไซต์หรือแอปพลิเคชัน “ผูกพันธุ์”
                </div>
                <div>
                  <span className={styles.dot}></span>
                  แอปพลิเคชัน “หมอพร้อม”
                </div>
                <div>
                  <span className={styles.dot}></span>
                  แอปพลิเคชัน “OnesID”
                </div>
                <div>
                  <span className={styles.dot}></span>
                  แอปพลิเคชัน “ThaiD”
                </div>
                <div>
                  และจำเป็นต้องพิสูจน์ตัวตนก่อน
                  ถึงจะสามารถเข้าถึงข้อมูลพันุกรรมของประชาชนได้
                </div>
                <div>
                  3.
                  ผู้ใช้บริการสามารถสืบค้นชื่อ-นามสกุลหรือเลขบัตรประจำตัวประชาชนของประชาชนที่มีข้อมูลพันธุกรรม
                  และสามารถเข้าถึงข้อมูลดังกล่าวได้โดยจะต้องได้รับคำยินยอมจากเจ้าของข้อมูลก่อน
                </div>
                <div>
                  4.
                  ผู้ใช้บริการสามารถเรียกดูประวัติการเข้าถึงข้อมูลส่วนบุคคลของประชาชน
                  ที่ตนเองเป็นข้อเข้าถึงข้อมูลได้
                </div>
                <div>
                  5. ผู้ใช้บริการตกลงว่าระบบฯ และผู้ให้บริการระบบฯ
                  ไม่มีภาระผูกพันหรือความรับผิดต่อเนื้อหา บริการ หรือกรณีใด ๆ
                  ที่เกิดจากหรือเกี่ยวข้องกับระบบฯ ของบุคคลที่สาม
                </div>
                <div>
                  6. ผู้ใช้บริการตกลงว่า
                  ในขณะที่ความสัมพันธ์ระหว่างผู้ใช้บริการกับระบบฯ ของบุคคลที่สาม
                  อาจถูกควบคุมโดยข้อตกลงกับบุคคลที่สามนั้น
                  การถอนการติดตั้งและ/หรือหยุดใช้งานระบบฯ ของบุคคลที่สาม
                  ที่มีความเกี่ยวข้องกับระบบฯ
                  เป็นการแก้ปัญหาความไม่พึงพอใจในตัวระบบฯ หรือเนื้อหาใน ระบบฯ
                  ของบุคคลที่สาม
                </div>
                <div>
                  7. บัญชีของผู้ใช้แต่ละบัญชีในระบบฯ
                  สงวนไว้เพื่อการใช้งานเฉพาะและโดยผู้เป็นเจ้าของบัญชีแต่เพียงผู้เดียวเท่านั้น
                  ผู้ใช้บริการไม่สามารถโอนสิทธิการใช้งานหรือให้ยืมบัญชีของตนแก่บุคคลอื่นไม่ว่ากรณีใดก็ตาม
                </div>
                <div>
                  8. ผู้ให้บริการระบบฯ ขอสงวนสิทธิ์ในการจำกัดการเข้าถึงบริการฯ
                  ของผู้ใช้บริการตามที่เห็นสมควร
                </div>
                <div>
                  9. ผู้ใช้บริการยอมรับว่า เท่าที่กฎหมายที่เกี่ยวข้องจะอนุญาต
                  การใช้งานและการให้บริการระบบฯ
                  เป็นความเสี่ยงของผู้ใช้บริการแต่เพียงฝ่ายเดียว
                  การให้บริการระบบฯ ถูกจัดทำขึ้น “ตามสภาพ” (as is) และ
                  “ตามที่มี” (as available) โดยอาจมีข้อบกพร่องรวมอยู่ด้วย
                  ผู้ให้บริการระบบฯ ไม่มีการรับประกันโดยนัยใด ๆ ทั้งสิ้น
                </div>
                <div>
                  <br />
                </div>
                <div>เนื้อหา</div>
                <div>
                  1. ข้อมูลที่ผู้ใช้บริการจะเข้าถึง เรียกดู และใช้นั้น
                  เป็นเนื้อหาฯ ที่ระบบฯ ได้รับมาจากหน่วยงานที่ร่วมมือ เช่น ระบบ
                  iLAB PLUS ห้องปฏิบัติการที่รับการตรวจพันธุกรรม
                  เพื่อนำมาประกอบการพิจารณาวินิจฉัย
                  ป้องกันและรักษาโรคที่เฉพาะบุคคล
                  ส่งเสริมการรักษาแบบการแพทย์แม่นยำ (Precision Medicine)
                  โดยจะต้องได้รับการยินยอมจากเจ้าของข้อมูลหรือประชาชนก่อน
                  อย่างไรก็ตามผู้ให้บริการระบบฯ
                  อนุญาตให้ผู้ใช้บริการเรียกดูเนื้อหาฯ
                  และข้อมูลส่วนบุคคของประชาชนเพื่อวัตถุประสงค์ในการใช้บริการฯ
                  นั่นคือ เพื่อประกอบการรักษา เท่านั้น
                </div>
                <div>
                  2. ผู้ใช้บริการจำเป็นจะต้องปฏิบัติตามข้อกำหนดและเงื่อนไขฯ
                  เมื่อมีการเรียกดูเนื้อหาฯ หรือนำไปใช้ และไม่ใช้เนื้อหาฯ
                  เกินจากขอบเขตของการใช้งานตามวัตถุประสงค์ ยกตัวอย่างเช่น
                  การลักลอบทำสำเนา การส่งต่อ การทำซ้ำ การแก้ไขบิดเบือน
                  หรือการนำเนื้อหาฯ ไปใช้เพื่อวัตถุประสงค์เชิงพาณิชย์อื่นใด
                  เป็นต้น
                </div>
                <div>
                  3. กรณีที่ผู้ให้บริการระบบฯ
                  ตรวจสอบพบว่าผู้ใช้บริการได้มีการใช้เนื้อหาฯ
                  ในลักษณะที่อาจเป็นการฝ่าฝืนกฎหมายหรือละเมิดข้อกำหนดและเงื่อนไขฯ
                  ผู้ให้บริการระบบฯ
                  ขอสงวนสิทธิ์การตัดสิทธิ์ของผู้ใช้บริการในการเรียกดูและใช้เนื้อหาฯ
                  โดยไม่จำเป็นต้องแจ้งให้ผู้ใช้บริการทราบล่วงหน้า
                </div>
                <div>
                  <br />
                </div>
                <div>ข้อจำกัด</div>
                <div>
                  ในการใช้บริการฯ ของระบบระบบแพลตฟอร์มดิจิทัล “ผูกพันธุ์”
                  ผู้ใช้บริการจะต้องไม่มีส่วนร่วมในกิจกรรมต่าง ๆ ดังต่อไปนี้
                </div>
                <div>
                  1. กิจกรรมที่เป็นการฝ่าฝืนกฎหมาย คำพิพากษา มติหรือคำสั่งศาล
                  หรือมาตรการทางปกครองที่มีผลผูกพัน ทางกฎหมาย
                </div>
                <div>
                  2.
                  กิจกรรมอื่นใดที่อาจขัดต่อความสงบเรียบร้อยหรือศีลธรรมอันดีงาม
                </div>
                <div>
                  3. กิจกรรมที่เป็นการละเมิดทรัพย์สินทางปัญญา เช่น
                  การละเมิดลิขสิทธิ์ ชื่อเสียง ความเป็นส่วนตัว เป็นต้น
                  และสิทธิอื่นๆ ทั้งหมดของผู้ให้บริการระบบฯ
                  และ/หรือบุคคลภายนอกที่มีการมอบให้ตามกฎหมายหรือสัญญา
                </div>
                <div>
                  4. กิจกรรมที่ส่งเสริมหรือนำไปสู่การเลือกปฏิบัติโดยเชื้อชาติ
                  สัญชาติ เพศ สถานะทางสังคม ถิ่นกำเนิดครอบครัว ลักษณะทางกายภาพ
                  สุขภาพหรือโรคประจำตัว และอื่น ๆ
                  รวมถึงการแสดงออกที่ชักชวนหรือส่งเสริมให้เกิด การฆ่าตัวตาย
                  พฤติกรรมการทำร้ายตัวเองหรือการใช้ยาในทางที่ผิด
                </div>
                <div>
                  5. กิจกรรมที่หลีกเลี่ยงเทคโนโลยีใด ๆ ที่ผู้ให้บริการระบบฯ
                  ผู้ที่ได้รับอนุญาต หรือบุคคลที่สามใด ๆ ใช้เพื่อ
                  ปกป้องเนื้อหาหรือบริการฯ
                </div>
                <div>
                  6. กิจกรรมที่อาจทำให้ผู้อื่นเกิดความเข้าใจผิดเกี่ยวกับระบบฯ
                  บริการของระบบฯ และ/หรือบุคคลภายนอก
                  หรือการจงใจเผยแพร่ข้อมูลเท็จ
                </div>
                <div>
                  7. กิจกรรมที่มีการแลกเปลี่ยนสิทธิในการใช้บริการฯ
                  หรือเข้าถึงเนื้อหาเพียงบางส่วนหรือทั้งหมดเป็นเงินสด
                  ทรัพย์สินหรือผลประโยชน์ใด ๆ
                </div>
                <div>
                  8. กิจกรรมที่มีการใช้บริการฯ เพื่อการซื้อขาย การตลาด โฆษณา
                  การชักชวน การได้มาซึ่งผลประโยชน์ส่วนตน
                  หรือวัตถุประสงค์ทางการค้าอื่น ๆ รวมถึงกิจกรรมที่ใช้บริการฯ
                  เพื่อวัตถุประสงค์ในการคุกคาม หรือหมิ่นประมาท
                  หรือกิจกรรมที่ใช้บริการฯ
                  เพื่อวัตถุประสงค์อื่นใดที่ไม่ใช่จุดประสงค์ที่แท้จริงของการให้บริการระบบฯ
                </div>
                <div>
                  9. กิจกรรมที่นำไปสู่การเก็บรวบรวม การเปิดเผย การทำสำเนา
                  การส่งต่อ การทำซ้ำ หรือการแก้ไข บิดเบือน
                  ข้อมูลส่วนบุคคลซึ่งเป็นเนื้อหาบนระบบฯ รวมไปถึงการทำสำเนา
                  โดยไม่ได้รับความเห็นชอบ
                  จากเจ้าของข้อมูลส่วนบุคคลและ/หรือผู้ให้บริการระบบฯ
                  หรือไม่ชอบด้วยกฎหมาย
                </div>
                <div>
                  10. กิจกรรมที่แทรกแซงเครื่องแม่ข่าย
                  และ/หรือระบบเครือข่ายของระบบฯ กิจกรรมซึ่งเป็นการใช้บริการฯ
                  ในทางที่ผิดด้วยการใช้บ็อท (BOTs) เครื่องมือเพื่อการโกง
                  หรือวิธีการทางเทคนิคใด ๆ
                  กิจกรรมที่ใช้ข้อบกพร่องหรือข้อผิดพลาดของบริการฯ
                  โดยไตร่ตรองไว้ก่อนแล้ว
                </div>
                <div>
                  11. กิจกรรมการตรวจสอบ สแกน หรือทดสอบจุดอ่อนของระบบฯ
                  หรือเครือข่ายใด ๆ
                </div>
                <div>
                  12.
                  กิจกรรมฝ่าฝืนหรือหลีกเลี่ยงการรักษาความปลอดภัยหรือมาตรการตรวจสอบตัวตน
                </div>
                <div>
                  13. กิจกรรมเข้าถึง ก้าวก่าย หรือใช้บริการฯ หรือ เนื้อหาใด ๆ
                  ซึ่งไม่เป็นไปตามขอบเขตการใช้งานของผู้ใช้บริการงาน
                  และวัตถุประสงค์ของระบบฯ
                </div>
                <div>
                  14. กิจกรรมที่ส่งเสริมหรือช่วยเหลือกิจกรรมใด ๆ
                  ที่กล่าวไว้ข้างต้น
                </div>
                <div>
                  15.
                  กิจกรรมที่ขัดแย้งกับข้อกำหนดและเงื่อนไขการใช้บริการสำหรับบุคลากรทางการแพทย์
                  นี้ ตามที่ผู้ให้บริการระบบฯ กำหนดไว้
                </div>
                <div>
                  16. กิจกรรมอื่น ๆ ที่ผู้ให้บริการระบบฯ เห็นว่าไม่เหมาะสม
                </div>
                <div>
                  <br />
                </div>
                <div>ความรับผิดชอบของผู้ใช้บริการ</div>
                <div>
                  1. ผู้ใช้บริการจะต้องใช้บริการฯ
                  โดยถือเป็นความเสี่ยงของผู้ใช้บริการเอง
                  และจะต้องเป็นผู้รับผิดชอบแต่เพียงผู้เดียวสำหรับการกระทำ/กิจกรรมที่ได้ทำไป
                  รวมถึงผลของการกระทำที่มีต่อบริการฯ นี้ด้วย
                </div>
                <div>
                  2. ข้อมูลการเข้าใช้งานระบบฯ และกิจกรรมใดๆ
                  ที่เกิดขึ้นขณะผู้ใช้เข้าใช้งานระบบฯ
                  เป็นความรับผิดชอบของผู้ใช้เองทั้งหมด
                </div>
                <div>
                  3. ผู้ให้บริการระบบฯ อาจใช้มาตรการที่เห็นว่าจำเป็นและเหมาะสม
                  หากผู้ให้บริการระบบฯ พบว่าผู้ใช้บริการรายใด
                  กำลังใช้บริการฯในทางที่ฝ่าฝืนข้อกำหนดและเงื่อนไขฯ อย่างไรก็ตาม
                  ผู้ให้บริการระบบฯ จะไม่รับผิดชอบ
                  ในการแก้ไขหรือป้องกันการฝ่าฝืนดังกล่าว
                </div>
                <div>
                  4. ในกรณีที่การใช้บริการฯ
                  ของผู้ใช้บริการก่อให้เกิดความเสียหายแก่ระบบฯ
                  หรือผู้ให้บริการระบบฯ หรือถูกเรียกเก็บค่าใช้จ่ายใด ๆ
                  (รวมถึงแต่ไม่จำกัดเพียงค่าทนายความ) ทั้งทางตรงและทางอ้อม
                  (รวมถึงแต่ไม่จำกัดเพียงกรณีที่มีบุคคลภายนอกฟ้องร้องเรียกค่าเสียหายจากผู้ให้บริการระบบฯ
                  )
                  อันเนื่องมาจากการที่ผู้ใช้บริการฝ่าฝืนข้อกำหนดและเงื่อนไขการใช้บริการสำหรับประชาชน
                  หรือฝ่าฝืนกฎหมายที่เกี่ยวข้องขณะใช้บริการฯ
                  ผู้ใช้บริการจะต้องทำการรับผิดชอบต่อความเสียหาย/ชดใช้ค่าเสียหายด้วยตนเอง
                  โดยไม่เกี่ยวข้องกับผู้ให้บริการระบบฯ แต่อย่างใด
                  ผู้ใช้รับทราบว่าการชดใช้ค่าเสียหายเพียงอย่างเดียวอาจไม่เพียงพอต่อการเยียวยาความเสียหายอันเกิดจากการฝ่าฝืนกฎหมายและ/หรือละเมิดข้อกำหนดและเงื่อนไขฯ
                  ฉบับนี้ ผู้ให้บริการระบบฯ
                  มีสิทธิได้รับการเยียวยาความเสียหายจากการกระทำการหรืองดเว้นกระทำการอื่นใดได้ตามความเหมาะสม
                </div>
                <div>
                  5. ผู้ใช้บริการยอมรับที่จะปฏิบัติตาม ข้อจำกัด
                  และจะไม่ใช้บริการ เนื้อหาของระบบฯ หรือส่วนใดที่กล่าวมาข้างต้น
                  ในลักษณะใดก็ตามที่ไม่ได้รับอนุญาตอย่างชัดเจนในข้อกำหนดและเงื่อนไขการใช้บริการสำหรับ
                  บุคลากรทางการแพทย์ผู้ให้บริการระบบฯ ไม่ให้สิทธิ์ ชื่อ
                  หรือผลประโยชน์ใดก็ตามแก่ผู้ใช้บริการในบริการ
                  หรือเนื้อหาของระบบฯ
                  ยกเว้นสิทธิ์ที่ได้รับอนุญาตโดยชัดเจนในข้อกำหนดและเงื่อนไขการใช้บริการ
                  สำหรับบุคลากรทางการแพทย์
                </div>
                <div>การให้บริการระบบแพลตฟอร์มดิจิทัล “ผูกพันธุ์”</div>
                <div>
                  ผู้ให้บริการระบบแพลตฟอร์มดิจิทัล “ผูกพันธุ์”
                  ขอสงวนสิทธิ์ในการจำกัดการเข้าถึงบริการระบบฯ
                  ของผู้ใช้บริการตามที่เห็นสมควรผู้ให้บริการระบบฯ
                  ขอสงวนสิทธิ์ในการเพิ่มเติม เปลี่ยนแปลง หรือยกเลิกการให้บริการฯ
                  เพียงบางส่วนหรือทั้งหมดโดยไม่จำเป็นต้องแจ้งให้ผู้ใช้บริการทราบล่วงหน้า
                  ผู้ใช้บริการยอมรับว่า เท่าที่กฎหมายที่เกี่ยวข้อง จะอนุญาต
                  การใช้งานและการให้บริการระบบฯ
                  เป็นความเสี่ยงของผู้ใช้บริการแต่เพียงฝ่ายเดียว
                  การให้บริการระบบฯ ถูกจัดทำขึ้น “ตามสภาพ” (as is) และ
                  “ตามที่มี” (as available) โดยอาจมีข้อบกพร่องรวมอยู่ด้วย
                  ผู้ให้บริการระบบฯ ไม่มีการรับประกันโดยนัยใด ๆ ทั้งสิ้น
                </div>
                <div>
                  <br />
                </div>
                <div>การยกเว้นความรับผิดชอบ</div>
                <div>
                  1. ผู้ให้บริการระบบแพลตฟอร์มดิจิทัล “ผูกพันธุ์”
                  ไม่สามารถรับประกันไม่ว่าจะอย่างชัดแจ้งหรือโดยปริยายว่า
                  การให้บริการฯ (รวมถึงข้อมูลส่วนบุคคล)
                  จะปราศจากข้อผิดพลาดหรือข้อบกพร่องตามจริงหรือตามกฎหมาย
                  ซึ่งอาจรวมถึง เสถียรภาพ การไว้วางใจได้ ความน่าเชื่อถือ
                  ความถูกต้อง ความครบถ้วนสมบูรณ์ การมีประสิทธิผล
                  ความเหมาะสมในการใช้บริการฯ เพื่อวัตถุประสงค์เฉพาะ
                  จุดบกพร่องที่เกี่ยวข้องกับความปลอดภัย (bug)
                  หรือการละเมิดสิทธิต่างๆ และผู้ให้บริการระบบฯ
                  จะไม่รับผิดชอบในการจัดหาบริการฯ
                  ที่ไม่มีข้อผิดพลาด/ข้อบกพร่องดังกล่าว แต่จะจัดหาบริการฯ
                  ที่ดีที่สุดตามความเหมาะสม
                </div>
                <div>
                  2. ผู้ให้บริการระบบแพลตฟอร์มดิจิทัล “ผูกพันธุ์”
                  ไม่สามารถรับรองได้ว่าผู้ใช้บริการจะได้รับผลประโยชน์
                  ตามวัตถุประสงค์ของระบบฯ เมื่อผู้ใช้บริการใช้บริการฯ
                  นอกจากนี้ผู้ให้บริการระบบฯ
                  ไม่สามารถรับประกันได้ด้วยว่าบุคลากรทางการแพทย์
                  ผู้ปฏิบัติการในห้องปฏิบัติการ และผู้ดูแลระบบฯ ฝั่งโรงพยาบาล
                  (Hospital Administrator)
                  จะปฏิบัติตามข้อกำหนดและเงื่อนไขการใช้บริการสำหรับผู้ดูแลระบบฯ
                  ฝั่งโรงพยาบาล ดังนั้น ผู้ให้บริการระบบฯ
                  จะไม่รับผิดชอบข้อผิดพลาดใด ๆ
                  ที่เกิดจากการปฏิบัติหรือไม่ปฏิบัติตามข้อกำหนดและเงื่อนไขของการใช้งานของผู้ใช้บริการดังกล่าว
                </div>
                <div>
                  3. ผู้ให้บริการระบบระบบแพลตฟอร์มดิจิทัล “ผูกพันธุ์”
                  ไม่รับรองว่าผู้ใช้บริการจะสามารถใช้งานบริการฯ
                  ร่วมกับเครื่องคอมพิวเตอร์หรืออุปกรณ์อิเล็กทรอนิกส์ทุกชนิดของผู้ใช้บริการ
                  รวมไปถึงการที่ผู้ให้บริการระบบฯ จะให้บริการฯ
                  โดยปราศจากไวรัสคอมพิวเตอร์ วอร์ม หรือ ม้าโทรจัน (Trojan Horse)
                  และผู้ให้บริการระบบฯ จะไม่รับผิดชอบชดใช้ต่อความเสียหายใด ๆ
                  ที่เป็นผลมาจากตัวทำลายเหล่านั้น
                </div>
                <div>
                  4. ผู้ให้บริการระบบฯ
                  ไม่มีความจำเป็นต้องรับผิดชอบต่อค่าเสียหายใด ๆ
                  ที่เกิดขึ้นกับผู้ใช้บริการ ในการใช้หรือไม่สามารถใช้บริการฯ
                  แบบใด ๆ หรือเนื่องจากเหตุใดก็ตาม ข้อจำกัดมีผลบังคับใช้เสมอ
                  ไม่ว่า ผู้ให้บริการระบบฯ
                  จะได้รับทราบหรือควรตระหนักถึงความเป็นไปได้ของความเสียหายดังกล่าว
                  ในเขตอำนาจศาลที่ไม่อนุญาตให้ยกเว้นหรือจำกัดความรับผิดชอบต่อความเสียหายที่เป็นผลสืบเนื่องหรือเกิดขึ้นโดยไม่ได้ตั้งใจ
                  การรับผิดชอบของผู้ให้บริการระบบฯ
                  จำกัดแค่ขอบเขตสูงสุดที่กฎหมายอนุญาตเท่านั้น
                </div>
                <div>
                  5. ผู้ให้บริการระบบฯ จะไม่ต้องรับผิดชอบต่อค่าเสียหายโดยอ้อม
                  ค่าเสียหายพิเศษ ค่าเสียหายเนื่องจากการผิดสัญญา
                  ค่าเสียหายต่อเนื่องหรือค่าเสียหายเชิงลงโทษใด ๆ
                  ในส่วนที่เกี่ยวข้องกับการผิดสัญญาหรือการกระทำการละเมิด
                  อันเนื่องมากจากความประมาทของผู้ให้บริการระบบฯ เอง
                  การชดใช้ค่าเสียหายตามปกติในส่วนที่เกี่ยวข้องกับ
                  การผิดสัญญาหรือการกระทำละเมิดจากการเลินเล่อของผู้ให้บริการระบบฯ
                  จะเป็นไปตามความเหมาะสม ของการพิจารณาตามกฎหมาย
                </div>
                <div>
                  สิทธิ์ที่ผู้ใช้บริการมอบให้ผู้ให้บริการระบบแพลตฟอร์มดิจิทัล
                  “ผูกพันธุ์”
                </div>
                <div>
                  ในการพิจารณาสิทธิ์ที่ผู้ใช้บริการมอบให้ผู้ให้บริการระบบฯ
                  ภายใต้ข้อกำหนดและเงื่อนไขฯ ผู้ใช้บริการ
                  ได้ให้สิทธิ์ผู้ให้บริการระบบฯ ในการให้บริการฯ ใช้ระบบประมวลผล
                  แบนด์วิดธ์ และ ฮาร์ดแวร์ที่ใช้เก็บข้อมูลบนอุปกรณ์
                  ของผู้ใช้บริการ
                  เพื่อเป็นการอำนวยความสะดวกในการปฏิบัติการของบริการฯ
                </div>
                <div>
                  การยกเลิกสิ้นสุดข้อกำหนดและเงื่อนไขการใช้บริการสำหรับบุคลากรทางการแพทย์
                </div>
                <div>
                  ผู้ให้บริการระบบฯ อาจทำการยกเลิกข้อกำหนดและเงื่อนไขฯ
                  เหล่านี้เมื่อใดก็ได้ตามเหตุอันเห็นสมควรโดยอาจแจ้งให้ผู้ใช้บริการทราบผ่านทางเว็บไซต์หรือแอปพลิเคชัน
                  “ผูกพันธุ์” และการยกเลิกสิ้นสุดจะมีผลทันที ณ ขณะนั้น
                </div>
                <div>
                  <br />
                </div>
                <div>บริการของหน่วยงานที่ร่วมมือ</div>
                <div>
                  เนื้อหาหรือบริการใด ๆ
                  จากหน่วยงานที่ร่วมมือซึ่งเป็นส่วนหนึ่งของระบบฯ
                  จะอยู่ภายใต้ความรับผิดชอบของหน่วยงานนั้นๆ แต่เพียงผู้เดียว
                  โดยอาจรวมถึงการที่เนื้อหาหรือบริการจะต้องเป็นไปภายใต้ข้อกำหนดและเงื่อนไขการใช้งานที่หน่วยงานดังกล่าวได้กำหนดไว้สำหรับเนื้อหาหรือบริการนั้น
                  ๆ
                </div>
                <div>
                  <br />
                </div>
                <div>การโอนสิทธิ์</div>
                <div>
                  1. ผู้ให้บริการระบบฯ
                  อาจโอนสิทธิ์ในข้อกำหนดและเงื่อนไขการใช้บริการสำหรับบุคลากรทางการแพทย์
                  และสิทธิ์ใดก็ตามที่มีภายใต้ข้อกำหนดและเงื่อนไขการใช้บริการสำหรับบุคลากรทางการแพทย์
                  ฉบับนี้ ทั้งหมด หรือบางส่วน อีกทั้ง ผู้ให้บริการระบบฯ
                  อาจมอบหมายภาระผูกพันภายใต้ข้อกำหนดและเงื่อนไขการใช้บริการสำหรับบุคลากรทางการแพทย์นี้ได้
                </div>
                <div>
                  2.
                  ผู้ใช้ไม่อาจโอนสิทธิ์ในข้อกำหนดและเงื่อนไขการใช้บริการสำหรับบุคลากรทางการแพทย์
                  ทั้งหมดหรือบางส่วน หรือถ่ายสิทธิ์
                  หรืออนุญาตให้ใช้สิทธิ์ต่อภายใต้ข้อกำหนดและเงื่อนไขการใช้บริการสำหรับบุคลากรทางการแพทย์นี้
                  แก่บุคคลที่สามใดก็ตาม
                </div>
                <div>
                  <br />
                </div>
                <div>การเป็นโมฆะบางส่วน การละเว้น และ การตีความ</div>
                <div>
                  เว้นแต่ได้ระบุไว้เป็นอื่นในข้อกำหนดและเงื่อนไขการใช้บริการสำหรับบุคลากรทางการแพทย์นี้
                  ข้อกำหนดข้อหนึ่งข้อใด
                  ในข้อกำหนดและเงื่อนไขการใช้บริการสำหรับบุคลากรทางการแพทย์จะตกเป็นโมฆะ
                  หรือไม่มีอำนาจบังคับใช้ได้ด้วยเหตุผลใดก็ตาม หรือภายในขอบเขตใด
                  ๆ การเป็นโมฆะหรือการไม่มีอำนาจบังคับใช้นั้นจะไม่มีผลต่อ
                  หรือส่งผลให้ข้อกำหนดที่เหลือ
                  ของข้อกำหนดและเงื่อนไขการใช้บริการสำหรับบุคลากรทางการแพทย์
                  นี้เป็นโมฆะ หรือไม่มีอำนาจบังคับใช้ด้วย ไม่ว่าในกรณีใดก็ตาม
                  และการบังคับใช้ข้อกำหนดดังกล่าวจะต้องมีผลใช้ภายในขอบเขตที่ชอบโดยกฎหมาย
                  รวมถึงจะไม่มีการละเว้นสิทธิ์ของผู้ให้บริการระบบฯ
                  หรือบุคคลที่สามผู้รับผลประโยชน์จากข้อกำหนด
                  และเงื่อนไขการใช้บริการสำหรับบุคลากรทางการแพทย์ ฉบับนี้
                </div>
                <div>
                  ตามที่ใช้ในข้อกำหนดเหล่านี้ คำว่า “รวม” และ “รวมถึง” และ
                  การหลากคำข้างต้น จะถือว่ามีคำว่า “ไม่มีข้อจำกัด” ตามมาด้วย
                </div>
                <div>
                  <br />
                </div>
                <div>กฎหมายที่บังคับและขอบเขตอำนาจ</div>
                <div>
                  ข้อกำหนดและเงื่อนไขการใช้บริการสำหรับบุคลากรทางการแพทย์ นี้
                  (รวมถึงข้อพิพาท/การเรียกร้องความเสียหาย
                  ที่ไม่ได้ระบุในข้อกำหนดและเงื่อนไขฯ
                  ซึ่งเกิดจากหรือเกี่ยวเนื่องกับข้อกำหนดและเงื่อนไขการใช้บริการสำหรับบุคลากร
                  ทางการแพทย์)
                  จะใช้บังคับกับความสัมพันธ์ระหว่างผู้ใช้บริการและผู้ให้บริการระบบฯ
                  โดยจะอยู่ภายใต้การบังคับใช้กฎหมายของประเทศไทย
                  ผู้ใช้บริการตกลงที่จะระงับข้อพิพาทนอกศาลโดยติดต่อผู้ให้บริการระบบฯ
                  หากข้อพิพาทดังกล่าวไม่สามารถยุติได้
                  ผู้ใช้บริการถึงจะสามารถนําคดีขึ้นสู่ศาลได้ นอกจากนั้น
                  ผู้ใช้บริการและผู้ให้บริการระบบฯ เห็นชอบให้การระงับข้อพิพาท
                  การเรียกร้องความเสียหาย
                  หรือความขัดแย้งที่อาจเกิดขึ้นจากบริการฯ
                  หรือเกิดขึ้นระหว่างผู้ใช้บริการและผู้ให้บริการระบบฯ
                  ที่เกี่ยวกับบริการฯ อยู่ภายใต้เขตอำนาจของศาลประเทศไทย
                </div>
                <div>
                  <br />
                </div>
                <div>การแจ้งเตือนและการติดต่อ</div>
                <div>
                  เมื่อผู้ให้บริการระบบฯ
                  มีความประสงค์ที่จะแจ้งเตือนหรือติดต่อผู้ใช้บริการเกี่ยวกับการบริการฯ
                  ผู้ให้บริการระบบฯ
                  อาจทำการติดต่อไปยังผู้ใช้บริการโดยตรงหรือผ่านหน่วยงานฯ
                  ตามที่เห็นสมควรในแต่ละกรณี เช่นเดียวกัน
                  หากผู้ใช้บริการมีความประสงค์ที่จะแจ้งปัญหาหรือติดต่อ
                  เกี่ยวกับการบริการฯ สามารถติดต่อผู้ให้บริการระบบฯ
                  ตามข้อมูลที่ปรากฎตามด้านล่างนี้
                </div>
                <div>
                  <br />
                </div>
                <div>ช่องทางการติดต่อ</div>
                <div>
                  หากบุคลากรทางการแพทย์ประสงค์จะติดต่อ หรือมีข้อสงสัย
                  หรือต้องการสอบถามข้อมูลเกี่ยวกับรายละเอียดการเก็บรวบรวม ใช้
                  และ/หรือเปิดเผยข้อมูลส่วนบุคคล
                  รวมถึงสิทธิของบุคลากรทางการแพทย์นโยบายฉบับนี้
                  หรือต้องการยกเลิกการให้ความยินยอมในการเก็บรวบรวม ใช้
                  และ/หรือเปิดเผยข้อมูลส่วนบุคคล หรือกรณีที่พบว่า
                  มีการใช้ข้อมูลส่วนบุคคลของบุคลาการทางการแพทย์ไปในทางที่ไม่ชอบ
                  บุคลากรทางการแพทย์สามารถติดต่อสำนักงานทาง ช่องทางดังต่อไปนี้
                </div>
                <div>
                  <br />
                </div>
                <div>
                  สถาบันชีววิทยาศาสตร์ทางการแพทย์ กรมวิทยาศาสตร์การแพทย์
                </div>
                <div>
                  สถานที่ติดต่อ: 88/7 ซอยบำราศนราดูร ถ.ติวานนท์ ต.ตลาดขวัญ
                  อ.เมือง จ.นนทบุรี 11000
                </div>
                <div>เวลาทำการปกติ: วันจันทร์ถึงศุกร์ เวลา 8:30 – 16:30 น.</div>
                <div>เว็บไซต์: https://phukphan.dmsc.moph.go.th/</div>
                <div>
                  <br />
                </div>
                <div>ติดต่อสอบถาม :</div>
                <div>นางสาวพรนภัส อยู่นุช</div>
                <div>อีเมลล์: pornnapat.y@dmsc.mail.go.th</div>
                <div>หมายเลขโทรศัพท์: 0-2589-9850 ถึง 8 ต่อ 98096</div>
                <div>นายพนาพัฒน์ ไพเราะ</div>
                <div>อีเมลล์: panapat.p@dmsc.mail.go.th</div>
                <div>หมายเลขโทรศัพท์: 0-2951-0000 ต่อ 99394</div>
                <div>นางสาวนภัชชา ถาวงศ์</div>
                <div>อีเมลล์: penpitcha.t@dmsc.mail.go.th</div>
                <div>หมายเลขโทรศัพท์: 0-2589-9850 ถึง 8 ต่อ 98096</div>
                <div>นายอาคม สาลี</div>
                <div>อีเมลล์: arkom.s@dmsc.mail.go.th</div>
                <div>หมายเลขโทรศัพท์: 0-2951-0000 ต่อ 99460</div>
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
}

export function Laboratory() {
  const [valueTab, setValueTab] = useState(0);
  return (
    <>
      <div className={styles.containerTab}>
        <div
          onClick={() => {
            setValueTab(0);
          }}
          className={valueTab === 0 ? styles.tab : styles.tabN}
        >
          นโยบายความเป็นส่วนตัว
        </div>
        <div
          onClick={() => {
            setValueTab(1);
          }}
          className={valueTab === 1 ? styles.tab : styles.tabN}
        >
          ข้อกำหนดและเงื่อนไขการใช้บริการ
        </div>
      </div>
      <div className={styles.containerCard}>
        <div className={styles.scrollbar}>
          {valueTab === 0 ? (
            <div className={styles.card}>
              <div className={styles.title}>สำหรับห้องปฏิบัติการ</div>
              <br />
              <div className={styles.detail}>
                <div>
                  ประกาศนโยบายความเป็นส่วนตัวฉบับนี้
                  มีเพื่อชี้แจงให้ผู้ปฏิบัติงานในห้องปฏิบัติการทราบถึงวัตถุประสงค์
                  และรายละเอียดของการเก็บรวบรวม เข้าถึง ใช้งาน จัดการ
                  และเปิดเผยข้อมูลส่วนบุคคลของผู้ปฏิบัติงานในห้องปฏิบัติการจากการใช้บริการระบบแพลตฟอร์มดิจิทัล
                  “ผูกพันธุ์”
                  และสิทธิตามกฎหมายของผู้ปฏิบัติงานในห้องปฏิบัติการที่เกี่ยวข้องกับข้อมูลส่วนบุคคล
                </div>
                <div>
                  <br />
                </div>
                <div>1. คำนิยาม</div>
                <div>
                  1.1 “ระบบแพลตฟอร์มดิจิทัล” หรือ “Digital Platform” ผูกพันธุ์
                  (ระบบฯ) หมายความว่า บริการดิจิทัลภาครัฐที่พัฒนา
                  หรือจัดหาและให้บริการ โดยกรมวิทยาศาสตร์การแพทย์
                  โดยมีวัตถุประสงค์ให้ประชาชน บุคลากรทางการแพทย์
                  สามารถเข้าถึงข้อมูลพันธุกรรม ได้แก่
                  ผลการตรวจทางเภสัชพันธุศาสตร์ เป็นต้น โดยระบบแพลตฟอร์มดิจิทัล
                  “ผูกพันธุ์” แบ่งการใช้งานออกเป็น 2 ระบบ ได้แก่
                </div>
                <div>
                  <span className={styles.dot}></span>
                  “แอปพลิเคชัน” หรือ “Application” ผูกพันธุ์ หมายความว่า
                  แอปพลิเคชัน “ผูกพันธุ์” ตลอดจนโปรแกรมคอมพิวเตอร์ ชุดคำสั่ง
                  หรือแอปพลิเคชันอื่น ๆ ที่ต้องใช้หรืออาจใช้ร่วมกัน
                  หรือเกี่ยวเนื่องกันกับแอปพลิเคชันดังกล่าว เพื่อการใช้บริการ
                  “ผูกพันธุ์” ไม่ว่าจะใช้งานผ่านโทรศัพท์มือถือ แท็บเล็ต เว็บ
                  หรือผ่านอุปกรณ์อื่นใดก็ตาม ทั้งนี้ ในกรณีที่ แอปพลิเคชัน
                  “ผูกพันธุ์”
                  เปลี่ยนชื่อเป็นอย่างอื่นหรือมีแอปพลิเคชันอื่นรวมอยู่ด้วย
                  ให้หมายความรวมถึงแอปพลิเคชันนั้นด้วย
                </div>
                <div>
                  <span className={styles.dot}></span>
                  “เว็บไซต์” หรือ “website” ผูกพันธุ์ หมายความว่า เว็บไซต์
                  “ผูกพันธุ์” ตลอดจนหน้าเว็บเพจที่ทำขึ้นเพื่อนำเสนอข้อมูลต่าง ๆ
                  ผ่านทางคอมพิวเตอร์ และอินเทอร์เน็ต
                  โดยมีหลายหน้าที่เชื่อมโยงเข้ากับไฮเปอร์ลิงก์
                  เพื่อให้สามารถเปิดไปยังหน้าเพจต่าง ๆ และถูกจัดเก็บไว้ใน www.
                  (เวิลด์ไวด์เว็บ) โดยเว็บไซต์ผูกพันธุ์ หรือ
                  https://phukphan.dmsc.moph.go.th/ มีไว้เพื่อให้ประชาชน
                  บุคลากรทางการแพทย์ สามารถเข้าถึงข้อมูลพันธุกรรมได้
                  นอกจากนี้ยังให้เจ้าหน้าที่ห้องปฏิบัติการสามารถเปิดห้องปฏิบัติการของตนเองและสามารถรายงานผลการตรวจทางพันธุกรรมได้
                </div>
                <div>
                  1.2 “ข้อมูลส่วนบุคคล” หมายความว่า ข้อมูลส่วนตัว หรือ
                  ข้อมูลเกี่ยวกับผู้ใช้บริการ
                  ซึ่งทำให้สามารถระบุตัวตนของผู้ใช้บริการได้ไม่ว่าทางตรงหรือทางอ้อม
                  ซึ่งรวมถึงข้อมูลทั่วไปของผู้ใช้บริการ ข้อมูลที่ใช้ยืนยันตัวตน
                  ข้อมูลชีวมาตรหรือ biometrics (เช่น ลายนิ้วมือ ใบหน้า เป็นต้น)
                  ข้อมูลสุขภาพ และข้อมูลส่วนบุคคลอื่นใดเกี่ยวกับผู้ใช้บริการ
                  ตามกฎหมายว่าด้วยการคุ้มครองข้อมูลส่วนบุคคล ทั้งนี้
                  ไม่รวมถึงข้อมูลเกี่ยวกับผู้ใช้บริการ
                  ในกรณีที่ผู้ใช้บริการถึงแก่กรรม และไม่รวมถึงข้อมูลทางสถิติ
                  หรือข้อมูลที่ไม่สามารถระบุตัวบุคคลที่เป็นเจ้าของข้อมูลส่วนบุคคลได้
                  ซึ่งไม่ถือเป็นข้อมูลส่วนบุคคล
                  ตามกฎหมายว่าด้วยการคุ้มครองข้อมูลส่วนบุคคล
                </div>
                <div>
                  1.3 “ข้อมูลสุขภาพ” หมายความว่า
                  ข้อมูลส่วนบุคคลของผู้ใช้บริการที่มีเนื้อหาเกี่ยวกับสุขภาพ
                  ได้แก่ ข้อมูลการแพ้ยา ข้อมูลโรควินิจฉัย ข้อมูลการจ่ายยา
                  ข้อมูลวัคซีน ข้อมูลหัตถการ ข้อมูลค่าผลตรวจ ทางการแพทย์
                  ข้อมูลผลตรวจห้องปฏิบัติและผลสรุปภาพถ่ายทางการแพทย์
                  ข้อมูลสุขภาพละเอียดอ่อน เช่น ข้อมูลพันธุกรรม เป็นต้น
                  และข้อมูลการเข้ารับบริการการรักษาพยาบาล
                  รวมไปถึงข้อมูลสุขภาพอื่น ๆ ที่อาจมีเพิ่มเติมในอนาคต
                </div>
                <div>
                  1.4 “ผู้ใช้บริการ” หมายความว่า ผู้ใช้งาน ระบบแพลตฟอร์มดิจิทัล
                  “ผูกพันธุ์” แบ่งการใช้งานตามระบบฯ และบทบาทดังต่อไปนี้
                </div>
                <div>
                  “ประชาชน” หมายความว่า ผู้ป่วย หรือ บุคคลทั่วไป
                  ที่เข้าใช้งานระบบแพลตฟอร์มดิจิทัล “ผูกพันธุ์”
                </div>
                <div>
                  “บุคลากรทางการแพทย์” หมายความว่า ผู้ประกอบวิชาชีพทางการแพทย์
                  ได้แก่ แพทย์ เภสัชกรพยาบาล เทคนิคการแพทย์ กายภาพบำบัด
                  แพทย์แผนไทย นักสาธารณสุขชุมชน รวมทั้ง
                  ผู้ที่มีหน้าที่ในการดูแลรักษาผู้ป่วยในด้านอื่น ๆ
                </div>
                <div>
                  “ผู้ปฏิบัติงานในห้องปฏิบัติการ” หมายความว่า
                  ผู้มีหน้าที่รับผิดชอบในการดำเนินการวิเคราะห์
                  ผลการตรวจทางพันธุกรรมที่โรงพยาบาลได้ทำการส่งตัวอย่างมาที่กรมวิทยาศาสตร์การแพทย์
                  ได้แก่ นักเทคนิคการแพทย์ และ นักวิทยาศาสตร์การแพทย์
                </div>
                <div>
                  1.5 “โรงพยาบาล” หมายความว่า
                  สถานที่รวมตลอดถึงยานพาหนะซึ่งจัดไว้เพื่อการประกอบโรคศิลปะ
                  ตามกฎหมายว่าด้วยการประกอบโรคศิลปะ
                  การประกอบวิชาชีพเวชกรรมตามกฎหมายว่าด้วยวิชาชีพเวชกรรม
                  การประกอบวิชาชีพการพยาบาลและการผดุงครรภ์ตามกฎหมายว่าด้วยวิชาชีพ
                  การพยาบาลและการผดุงครรภ์
                  การประกอบวิชาชีพทันตกรรมตามกฎหมายว่าด้วยวิชาชีพทันตกรรม
                  เทคนิคการแพทย์ตามกฎหมายว่าด้วยวิชาชีพเทคนิค การแพทย์
                  การประกอบวิชาชีพการแพทย์แผนไทยและการประกอบวิชาชีพการแพทย์แผนไทยประยุกต์ตามกฎหมายว่าด้วยวิชาชีพการแพทย์แผนไทย
                  หรือการประกอบวิชาชีพทางการแพทย์และสาธารณสุขอื่นตามกฎหมายว่าด้วยการนั้น
                </div>
                <div>
                  1.6 “ระบบสารสนเทศโรงพยาบาล” หรือ “Hospital Information System:
                  HIS” หมายความว่า ระบบการจัดการโรงพยาบาลที่ช่วยในการจัดเก็บ
                  จัดการ และส่งต่อข้อมูลจำนวนมากทั้งจากภายใน และภายนอกโรงพยาบาล
                  ให้ผู้บริหารสามารถจัดสรรทรัพยากรต่างๆ
                  ของโรงพยาบาลได้อย่างคุ้มค่า
                  เพิ่มประสิทธิภาพของการทำงานและการรักษาผู้ป่วยได้อย่างรวดเร็ว
                </div>
                <div>
                  1.7 “ระบบรับ-ส่งตัวอย่างเพื่อตรวจวิเคราะห์” หรือ “iLAB PLUS”
                  หมายความว่า ระบบรับ-ส่งตัวอย่าง
                  เพื่อตรวจวิเคราะห์กรมวิทยาศาสตร์การแพทย์ กระทรวงสาธารณสุข
                  โดยผู้ใช้จะแบ่งเป็นสำหรับหน่วยงานผู้ขอรับบริการ
                  และสำหรับเจ้าหน้าที่กรมวิทยาศาสตร์การแพทย์
                  ซึ่งผู้ขอรับบริการเป็นผู้ส่งตัวอย่างให้กับห้องปฏิบัติการของกรมวิทยาศาสตร์การแพทย์
                  จากนั้นจะทำการวิเคราะห์ผลทางห้องปฏิบัติการ
                  เมื่อวิเคราะห์ผลเรียบร้อยแล้วจะทำการออกรายงานผล
                  รับรองผลการตรวจวิเคราะห์
                  และส่งผลการตรวจวิเคราะห์กลับให้ทางผู้ขอรับบริการนั้น ๆ
                </div>
                <div>
                  1.8 “ผู้ให้บริการ”
                  หมายความหน่วยงานที่มีหน้าที่และ/หรือได้รับมอบหมายในการจัดทำ
                  พัฒนา และให้บริการระบบแพลตฟอร์มดิจิทัล“ผูกพันธุ์”
                </div>
                <div>
                  <br />
                </div>
                <div>
                  2. วัตถุประสงค์ของการเก็บรวบรวม เข้าถึง ใช้งาน จัดการ
                  และเปิดเผยข้อมูลส่วนบุคคลของ บุคลากรทางการแพทย์
                </div>
                <div>
                  ข้อมูลส่วนบุคคลจะถูกเก็บรวบรวม เข้าถึง ใช้งาน จัดการ
                  และเปิดเผย
                  โดยมีวัตถุประสงค์เพื่อให้ผู้ขอใช้บริการเข้าถึงข้อมูลพันธุกรรมที่กรมวิทยาศาสตร์การแพทย์และห้องปฏิบัติการอื่น
                  ๆ ให้บริการ โดยมีผู้ใช้บริการ และบทบาทที่เกี่ยวข้อง ดังนี้
                </div>
                <div>
                  <span className={styles.dot}></span>
                  ประชาชน
                  เข้าถึงและแสดงผลการตรวจของตนเองให้บุคลาการทางการแพทย์ที่รักษา
                </div>
                <div>
                  <span className={styles.dot}></span>
                  บุคลากรทางการแพทย์ เข้าถึงและใช้ผลการตรวจของประชาชน
                  ประกอบการพิจารณาวินิจฉัย ป้องกันและรักษาโรคที่เฉพาะบุคคล
                  ส่งเสริมการรักษาแบบการแพทย์แม่นยำ (Precision Medicine)
                </div>
                <div>
                  <span className={styles.dot}></span>
                  ผู้ปฏิบัติงานในห้องปฏิบัติการ
                  บันทึกผลการตรวจทางพันธุกรรมในระบบแพลตฟอร์มดิจิทัล “ผูกพันธุ์”
                </div>
                <div>
                  นอกจากนี้ ระบบแพลตฟอร์มดิจิทัล “ผูกพันธุ์”
                  ยังสามารถเชื่อมต่อกับระบบสารสนเทศโรงพยาบาล
                  เพื่อแลกเปลี่ยนข้อมูลพันธุกรรม
                  เนื่องจากการตรวจทางพันธุกรรมบางรายการ สามารถตรวจครั้งเดียว
                  และใช้ผลการตรวจได้ตลอดชีวิต
                  ดังนั้นจึงทำให้ประชาชนและภาครัฐประหยัดเงิน และเวลาในการตรวจซ้ำ
                  เมื่อประชาชนเข้ารับการรักษาต่างโรงพยาบาล
                  และบุคลากรทางการแพทย์สามารถพิจารณาใช้ผลการตรวจดังกล่าว
                  ในการวางแผนป้องกันและรักษาโรคได้ทันที
                </div>
                <div>
                  ในขณะเดียวกัน
                  ข้อมูลส่วนบุคคลบางรายการมีความจำเป็นที่จะต้องทำการเก็บรวบรวม
                  เข้าถึง ใช้งาน จัดการ และเปิดเผย
                  เนื่องจากเป็นข้อมูลที่มีความสำคัญต่อการให้บริการระบบฯ
                  ซึ่งการเก็บรวบรวม เข้าถึง ใช้งาน จัดการ
                  และเปิดเผยข้อมูลส่วนบุคคลของประชาชน จะไม่ถูกกระทำการใด ๆ
                  ที่นอกเหนือไปจากวัตถุประสงค์ที่ได้ระบุไว้ข้างต้น
                  เว้นแต่เป็นการใช้เพื่อ
                </div>
                <div>
                  <span className={styles.dot}></span>
                  การควบคุมคุณภาพและเพิ่มประสิทธิภาพและส่งเสริมการให้บริการของระบบฯ
                </div>
                <div>
                  <span className={styles.dot}></span>
                  ความปลอดภัยของเครือข่ายและข้อมูล
                </div>
                <div>
                  <span className={styles.dot}></span>
                  การปฏิบัติตามเงื่อนไขการให้บริการของระบบฯ
                </div>
                <div>
                  <span className={styles.dot}></span>
                  การให้บริการเพื่อประโยชน์ของประชาชน
                </div>
                <div>
                  <span className={styles.dot}></span>
                  วัตถุประสงค์อื่น ๆ ซึ่งจะต้องได้รับความยินยอมจากประชาชนก่อน
                </div>
                <div>
                  <span className={styles.dot}></span>
                  ประโยชน์สาธารณะด้านการสาธารณสุข
                  ตามพระราชบัญญัติคุ้มครองข้อมูลส่วนบุคคล พ.ศ. 2562
                </div>
                <div>
                  <span className={styles.dot}></span>
                  การศึกษาวิจัยทางวิทยาศาสตร์ ประวัติศาสตร์ หรือสถิติ
                  หรือประโยชน์สาธารณะอื่น
                  ตามพระราชบัญญัติคุ้มครองข้อมูลส่วนบุคคล พ.ศ. 2562
                </div>
                <div>
                  <span className={styles.dot}></span>
                  การปฏิบัติตามกฎหมายว่าด้วยการคุ้มครองข้อมูลส่วนบุคคล พ.ศ. 2562
                  หรือกรณีที่กฎหมายฉบับอื่นบัญญัติให้กระทำ
                </div>
                <div>
                  <br />
                </div>
                <div>
                  3. การเก็บรวบรวม เข้าถึง ใช้งาน จัดการ
                  และเปิดเผยข้อมูลส่วนบุคคลบนระบบแพลตฟอร์มดิจิทัล “ผูกพันธุ์”
                </div>
                <div>
                  ข้อมูลส่วนบุคคล
                  คือข้อมูลที่ทำให้สามารถระบุตัวตนหรือบ่งชี้ลักษณะเฉพาะตัวของเจ้าหน้าที่ปฏิบัติการ
                  ในห้องปฏิบัติงานได้ ไม่ว่าจะทั้งทางตรงหรือทางอ้อม
                  แต่ไม่รวมถึงข้อมูลของผู้ถึงแก่กรรม
                  เมื่อผู้ปฏิบัติงานในห้องปฏิบัติการเข้าใช้งานและให้ความยินยอมในการเข้าใช้บริการในระบบแพลตฟอร์มดิจิทัล
                  “ผูกพันธุ์” แล้วนั้นกรมวิทยาศาสตร์การแพทย์ กระทรวงสาธารณสุข
                  รวมทั้งผู้พัฒนาและดูแลระบบแพลตฟอร์มดิจิทัล “ผูกพันธุ์”
                  จะสามารถเก็บรวบรวม เข้าถึง ใช้งาน จัดการ
                  และเปิดเผยข้อมูลส่วนบุคคลของผู้ปฏิบัติงานในห้องปฏิบัติการในระบบแพลตฟอร์มดิจิทัล
                  “ผูกพันธุ์” ซึ่งข้อมูลส่วนบุคคลจะครอบคลุมทั้งข้อมูลก่อน
                  และหลังจากวันที่ผู้ปฏิบัติงานในห้องปฏิบัติการแสดงความยินยอมในการใช้บริการระบบแพลตฟอร์มดิจิทัล
                  “ผูกพันธุ์” โดยจะประกอบไปด้วยข้อมูล และวัตถุประสงค์ในการรวบรวม
                  เข้าถึง ใช้งาน จัดการ และเปิดเผย ดังนี้
                </div>
                <div>3.1 ข้อมูลส่วนตัว เช่น</div>
                <div>
                  <span className={styles.dot}></span>
                  หมายเลขบัตรประชาชน
                  เพื่อใช้ในยืนยันตัวตนของผู้ปฏิบัติงานในห้องปฏิบัติการกับฐานข้อมูลกรมการปกครอง
                </div>
                <div>
                  <span className={styles.dot}></span>
                  คำนำหน้า ชื่อ นามสกุล เพศ อายุ และหมายเลขโทรศัพท์
                  เพื่อระบุตัวตนและยืนยันตัวตน
                </div>
                <div>
                  <span className={styles.dot}></span>
                  รหัสไปรษณีย์ เพื่อนำไปใช้ในการศึกษาวิจัยทางวิทยาศาสตร์
                  ประวัติศาสตร์ หรือสถิติ หรือประโยชน์สาธารณะอื่น ๆ
                  ตามพระราชบัญญัติคุ้มครองข้อมูลส่วนบุคคล พ.ศ. 2562
                </div>
                <div>
                  <span className={styles.dot}></span>
                  หมายเลขหลังบัตรประชาชน
                  ถูกนำมาใช้เพื่อยืนยันตัวตนของเจ้าหน้าที่ปฏิบัติการ
                  ในห้องปฏิบัติงานกับฐานข้อมูลกรมการปกครอง
                  เป็นการป้องกันการฉ้อโกงโดยแสดงตนเป็นบุคคลอื่น
                  ซึ่งข้อมูลนี้จะไม่ถูกเก็บไว้เมื่อทำการยืนยันตัวตนหรือสมัครใช้งานสำเร็จ
                </div>
                <div>
                  <span className={styles.dot}></span>
                  เลขที่ใบประกอบวิชาชีพเวชกรรม
                  ใช้ในการตรวจสอบว่าผู้ปฏิบัติงานในห้องปฏิบัติการ
                  เป็นบุคลากรทางการแพทย์จริงจากระบบของสภาเทคนิคการแพทย์
                  หรือจากระบบ “หมอพร้อม”
                </div>
                <div>
                  3.2 ข้อมูลการเข้าร่วมระบบแพลตฟอร์มดิจิทัล “ผูกพันธุ์” (Login
                  Record) เช่น
                </div>
                <div>
                  <span className={styles.dot}></span>
                  ชื่อสถานพยาบาลและห้องปฏิบัติการ
                </div>
                <div>
                  <span className={styles.dot}></span>
                  ที่อยู่ของสถานพยาบาลและห้องปฏิบัติการ
                </div>
                <div>
                  <span className={styles.dot}></span>
                  ข้อมูลส่วนบุคคลของผู้ปฏิบัติงานในห้องปฏิบัติการ
                </div>
                <div>
                  <span className={styles.dot}></span>
                  สถานะของการเข้าใช้งานระบบฯ (สำเร็จ/ไม่สำเร็จ)
                </div>
                <div>3.3 ข้อมูลการบันทึกผลการตรวจทางพันธุกรรมในระบบฯ</div>
                <div>
                  <span className={styles.dot}></span>
                  ข้อมูลผู้ป่วย
                </div>
                <div>- หมายเลขการทดสอบของผู้ป่วย และหมายเลขผู้ป่วยนอก</div>
                <div>- เลขบัตรประจำตัวประชาชนของผู้ป่วย</div>
                <div>- คำนำหน้า ชื่อ และนามสกุลของผู้ป่วย</div>
                <div>- เพศ อายุ ของผู้ป่วย</div>
                <div>3.4 ข้อมูลตัวอย่าง</div>
                <div>
                  <span className={styles.dot}></span>
                  ชนิดของตัวอย่างลักษณะตัวอย่าง
                </div>
                <div>
                  <span className={styles.dot}></span>
                  วันที่ส่ง รับ และเก็บตัวอย่าง
                </div>
                <div>
                  <span className={styles.dot}></span>
                  ชื่อโรงพยาบาลที่ส่งตรวจตัวอย่าง
                </div>
                <div>
                  <span className={styles.dot}></span>
                  ที่อยู่โรงพยาบาลที่ส่งตรวจตัวอย่าง
                </div>
                <div>3.5 ข้อมูลผลการตรวจวิเคราะห์ของผู้ป่วย</div>
                <div>
                  <span className={styles.dot}></span>
                  เลขที่ใบรายงานผล
                </div>
                <div>
                  <span className={styles.dot}></span>
                  ประเภทผลการทดสอบ
                </div>
                <div>
                  <span className={styles.dot}></span>
                  ชื่อการทดสอบ
                </div>
                <div>
                  <span className={styles.dot}></span>
                  ผลการทดสอบ
                </div>
                <div>
                  <span className={styles.dot}></span>
                  วิธีการทดสอบ
                </div>
                <div>
                  <span className={styles.dot}></span>
                  วันที่ตรวจ และวันที่รายงานผล
                </div>
                <div>
                  <span className={styles.dot}></span>
                  วันและเวลาที่รับรองผล
                </div>
                <div>3.6 ข้อมูลผู้วิเคราะห์</div>
                <div>
                  <span className={styles.dot}></span>
                  ชื่อ-นามสกุล ผู้วิเคราะห์
                </div>
                <div>
                  <span className={styles.dot}></span>
                  ชื่อ-นามสกุล ผู้รับรองผล
                </div>
                <div>
                  <br />
                </div>
                <div>4. แหล่งที่มาของข้อมูลส่วนบุคคล</div>
                <div>
                  ข้อมูลส่วนบุคคลของเจ้าหน้าที่ปฏิบัติการในห้องปฏิบัติงานจะถูกเก็บรวบรวมโดยแบ่งเป็น
                </div>
                <div>
                  4.1 ข้อมูลส่วนตัว
                  จะถูกเก็บรวบรวมและจัดการผ่านระบบอิเล็กทรอนิกส์ของระบบแพลตฟอร์มดิจิทัล
                  “ผูกพันธุ์” โดยมีการนำเข้าข้อมูล และพิสูจน์ตัวตนจากแพลตฟอร์ม
                  ดังต่อไปนี้
                </div>
                <div>
                  <span className={styles.dot}></span>
                  “หมอพร้อม” ภายใต้การดูแลของสำนักสุขภาพดิจิทัล
                  สำนักปลัดกระทรวงสาธารณสุข
                </div>
                <div>
                  <span className={styles.dot}></span>
                  “OnesID” ภายใต้การดูแลของ SOFTMAX CO., LTD.
                </div>
                <div>
                  <span className={styles.dot}></span>
                  “ThaiD” ภายใต้การดูแลของกรมการปกครอง
                </div>
                <div>
                  หรือ
                  ผ่านการกรอกแบบฟอร์มลงทะเบียนเข้าใช้งานผ่านระบบแพลตฟอร์มดิจิทัล
                  “ผูกพันธุ์”
                </div>
                <div>
                  <br />
                </div>
                <div>
                  5. การจัดเก็บข้อมูลส่วนบุคคลของผู้ปฏิบัติงานในห้องปฏิบัติการ
                </div>
                <div>
                  ข้อมูลของเจ้าหน้าที่ปฏิบัติการในห้องปฏิบัติงานจะถูกจัดเก็บในฐานข้อมูลบนศูนย์ข้อมูล
                  (server) ของกรมวิทยาศาสตร์การแพทย์
                  โดยข้อมูลของเจ้าหน้าที่ปฏิบัติการในห้องปฏิบัติงานจะถูกรักษาไว้อย่างดี
                  โดยมีการสำรองข้อมูล มาตรการในการรักษาความปลอดภัย
                  และกลไกในการปกป้องข้อมูลจากการสูญเสียต่าง ๆ
                  การเปิดเผยข้อมูลส่วนบุคคลของเจ้าหน้าที่ปฏิบัติการในห้องปฏิบัติงานจะมีผลบังคับใช้ตลอดระยะเวลาที่
                  เจ้าหน้าที่ปฏิบัติการในห้องปฏิบัติงานให้ความยินยอมใช้งานระบบแพลตฟอร์มดิจิทัล
                  “ผูกพันธุ์” หรือจนกว่าระบบฯ จะยุติการให้บริการ
                  หรือเป็นไปตามข้อกำหนดของระเบียบกฎหมายที่เกี่ยวข้อง
                </div>
                <div>
                  <br />
                </div>
                <div>
                  6. การปฏิเสธคำขอหรือการคัดค้านเกี่ยวกับข้อมูลส่วนบุคคล
                </div>
                <div>
                  การดำเนินการต่าง ๆ
                  ที่เกิดขึ้นกับข้อมูลส่วนบุคคลของผู้ปฏิบัติงานในห้องปฏิบัติการจะเป็นตามพระราชบัญญัติคุ้มครองข้อมูลส่วนบุคคล
                  พ.ศ. 2562
                </div>
                <div>
                  <br />
                </div>
                <div>
                  7.
                  ข้อมูลเกี่ยวกับผู้ประมวลผลและผู้ควบคุมข้อมูลส่วนบุคคลของผู้ปฏิบัติงานในห้องปฏิบัติการ
                </div>
                <div>
                  เมื่อผู้ปฏิบัติงานในห้องปฏิบัติการเข้าร่วมใช้งานระบบแพลตฟอร์มดิจิทัล
                  “ผูกพันธุ์”
                  ข้อมูลส่วนบุคคลของผู้ปฏิบัติงานในห้องปฏิบัติการจะถูกเก็บรวบรวม
                  เข้าถึง ใช้งาน จัดการ
                  และเปิดเผยโดยบุคคลหรือนิติบุคคลที่เกี่ยวข้องตามหน้าที่ความรับผิดชอบที่ได้รับมอบหมาย
                  ซึ่งจำแนกออกเป็น
                </div>
                <div>
                  7.1 ผู้ควบคุมข้อมูลส่วนบุคคล หมายถึง
                  บุคคลหรือนิติบุคคลซึ่งมีหน้าที่ตัดสินใจเกี่ยวกับการเก็บรวบรวม
                  เข้าถึง ใช้งาน จัดการ และเปิดเผยข้อมูลส่วนบุคคล ในที่นี้
                  ผู้ควบคุมข้อมูลส่วนบุคคลในระบบฯ ได้แก่
                </div>
                <div>
                  <span className={styles.dot}></span>
                  กรมวิทยาศาสตร์การแพทย์
                  โดยสถาบันชีววิทยาศาสตร์ทางการแพทย์ซึ่งเป็นผู้ควบคุมดูแลข้อมูลที่อยู่ในระบบฯ
                  โดยมีหน้าที่
                </div>
                <div>
                  - เก็บรวบรวม เข้าถึง ใช้งาน จัดการ
                  และเปิดเผยข้อมูลของผู้ปฏิบัติงานในห้องปฏิบัติการตามที่ผู้ปฏิบัติงานในห้องปฏิบัติการได้ให้ความยินยอมไว้
                </div>
                <div>
                  -
                  จัดให้มีมาตรการรักษาความมั่นคงปลอดภัยข้อมูลส่วนบุคคลอย่างเหมาะสม
                  รวมทั้งแจ้งให้ผู้ควบคุมข้อมูลส่วนบุคคลทราบถึงการละเมิดข้อมูลส่วนบุคคลที่เกิดขึ้น
                </div>
                <div>
                  -
                  จัดทำและเก็บรักษาบันทึกรายการกิจกรรมการประมวลผลข้อมูลส่วนบุคคลที่เกิดขึ้นอย่างถูกต้องครบถ้วน
                </div>
                <div>
                  <span className={styles.dot}></span>
                  กรมการปกครอง
                  ซึ่งจะเป็นผู้ควบคุมข้อมูลส่วนบุคคลสำหรับข้อมูลส่วนตัวจากการดำเนินการตรวจสอบเลขหลังบัตรประชาชนเพื่อยืนยันตัวบุคคล
                  ที่กระทำโดยบุคลากรทางการแพทย์ผ่านขั้นตอนการกรอกข้อมูลเพื่อสมัครเข้าใช้งานระบบฯ
                </div>
                <div>
                  <span className={styles.dot}></span>
                  สำนักสุขภาพดิจิทัล สำนักปลัดกระทรวงสาธารณสุข
                  ซึ่งจะเป็นผู้ควบคุมข้อมูลส่วนบุคคลสำหรับข้อมูลส่วนตัวจากการดำเนินการสมัครใช้งานและยืนยันตัวตน
                  (e-KYC) ที่กระทำโดยบุคลากรทางการแพทย์ผ่านทางแอปพลิเคชัน
                  “หมอพร้อม”
                </div>
                <div>
                  <span className={styles.dot}></span>
                  บริษัท ซอฟต์แม็กซ์ จำกัด
                  ซึ่งจะเป็นผู้ควบคุมข้อมูลส่วนบุคคลสำหรับข้อมูลส่วนตัวจากการดำเนินการสมัครใช้งานและยืนยันตัวตน
                  (e-KYC) ที่กระทำโดยบุคลากรทางการแพทย์ผ่านทางแอปพลิเคชัน
                  “OnesID”
                </div>
                <div>
                  7.2 ผู้ประมวลผลข้อมูลส่วนบุคคล หมายถึง
                  บุคคลหรือนิติบุคคลซึ่งดำเนินการเกี่ยวกับ การเก็บรวบรวม เข้าถึง
                  ใช้งาน จัดการ
                  และเปิดเผยข้อมูลส่วนบุคคลตามคำสั่งหรือในนามของผู้ควบคุมข้อมูลส่วนบุคคล
                  ในที่นี้ ผู้ประมวลผลข้อมูลส่วนบุคคลในระบบฯ ได้แก่
                </div>
                <div>
                  <span className={styles.dot}></span>
                  กรมวิทยาศาสตร์การแพทย์ โดย ศูนย์เทคโนโลยีสารสนเทศ
                  ซึ่งมีหน้าที่ดำเนินการเก็บรวบรวม ใช้งาน จัดการ
                  และเปิดเผยข้อมูลของผู้ปฏิบัติงานในห้องปฏิบัติการตามที่ได้รับมอบหมายจากผู้ควบคุมข้อมูลและตามที่ผู้ปฏิบัติงานในห้องปฏิบัติการได้แสดงความยินยอมไว้
                  เว้นแต่จะขัดต่อข้อกฎหมายหรือพระราชบัญญัติคุ้มครองข้อมูลส่วนบุคคล
                  พ.ศ. 2562
                </div>
                <div>
                  <span className={styles.dot}></span>
                  ผู้ดูแลห้องปฏิบัติการ ซึ่งมีหน้าที่จัดการ
                  และดูแลเจ้าหน้าที่ปฏิบัติงานในห้องปฏิบัติการ
                  ของตนเองและเปิดเผยข้อมูลของเจ้าหน้าที่ปฏิบัติงานในห้องปฏิบัติการตามที่ได้รับมอบหมายจากผู้ควบคุมข้อมูลและตามที่ผู้ปฏิบัติงานในห้องปฏิบัติการได้แสดงความยินยอมไว้
                  เว้นแต่จะขัดต่อข้อกฎหมายหรือพระราชบัญญัติคุ้มครองข้อมูลส่วนบุคคล
                  พ.ศ. 2562
                </div>
                <div>
                  <span className={styles.dot}></span>
                  บุคคลอื่น
                  ที่ผู้ควบคุมข้อมูลกำหนดเพื่อดำเนินการตามวัตถุประสงค์ของระบบฯ
                </div>
                <div>
                  <br />
                </div>
                <div>8. การเปลี่ยนแปลงนโยบายการคุ้มครองข้อมูลส่วนบุคคล</div>
                <div>
                  ผู้ให้บริการระบบแพลตฟอร์มดิจิทัล “ผูกพันธุ์”
                  ขอสงวนสิทธิในการปรับปรุงหรือแก้ไขรายละเอียดนโยบายคุ้มครองข้อมูลส่วนบุคคล
                </div>
                <div>
                  <span className={styles.dot}></span>
                  เพื่อวัตถุประสงค์ของระบบฯ
                </div>
                <div>
                  <span className={styles.dot}></span>
                  เพื่อพัฒนา ทดสอบ และให้บริการระบบฯ
                </div>
                <div>
                  <span className={styles.dot}></span>
                  เพื่อให้เกิดผลประโยชน์ต่อผู้ใช้บริการ
                  และสาธารณสุขให้มากยิ่งขึ้น
                </div>
                <div>
                  <span className={styles.dot}></span>
                  เพื่อให้สอดคล้องกับพระราชบัญญัติคุ้มครองข้อมูลส่วนบุคคล พ.ศ.
                  2562 หรือหลักกฎหมายอื่น ๆ ที่เกี่ยวข้อง
                </div>
                <div>
                  ซึ่งระบบฯ
                  จะประกาศอย่างชัดเจนให้เจ้าหน้าที่ปฏิบัติการในห้องปฏิบัติงานทราบก่อนการดำเนินการ
                  พร้อมทั้งขอความยินยอมจากผู้ปฏิบัติงานในห้องปฏิบัติการอีกครั้งหากจำเป็น
                  ปัจจุบัน
                  นโยบายการคุ้มครองข้อมูลส่วนบุคคลของผู้ปฏิบัติงานในห้องปฏิบัติการ
                  ถูกทบทวนครั้งล่าสุดเมื่อวันที่ 10 พฤศจิกายน 2566
                </div>
                <div>
                  <br />
                </div>
                <div>
                  9.
                  การรักษาความปลอดภัยของข้อมูลส่วนบุคคลของผู้ปฏิบัติงานในห้องปฏิบัติการ
                </div>
                <div>
                  ระบบแพลตฟอร์มดิจิทัล “ผูกพันธุ์”
                  ได้มีการออกแบบและพัฒนาโดยตระหนักและให้ความสำคัญ
                  กับการรักษาความปลอดภัยของข้อมูลในทุกกระบวนการ
                  เพื่อปกป้องข้อมูลของผู้ปฏิบัติงานในห้องปฏิบัติการ
                  จากการทำลายหรือบุกรุกจากผู้ไม่หวังดีหรือผู้ไม่มีสิทธิในการเข้าถึงข้อมูล
                  มีระบบการลงทะเบียนด้วย e-KYC และทำการเข้ารหัสข้อมูล (Data
                  Encryption)
                  ซึ่งทำให้ผู้ที่ดักจับข้อมูลไม่สามารถนำข้อมูลไปใช้ต่อได้
                </div>
                <div>
                  ข้อมูลส่วนบุคคลในระบบแพลตฟอร์มดิจิทัล “ผูกพันธุ์”
                  จะถูกปกป้องอย่างเคร่งครัด
                  จึงทำให้การใช้งานของข้อมูลในระบบดังกล่าว
                  เป็นไปตามข้อกำหนดทางกฎหมายที่เกี่ยวข้อง ทั้งนี้ แม้ว่าระบบฯ
                  ได้มีการออกแบบและพัฒนาเพื่อรักษาความปลอดภัยเป็นอย่างดีที่สุดก็ตาม
                  ระบบฯ ไม่สามารถปกป้องข้อมูล
                  ของผู้ปฏิบัติงานในห้องปฏิบัติการได้อย่างเด็ดขาด ดังนั้น
                  ผู้ปฏิบัติงานในห้องปฏิบัติการควรตระหนัก
                  เรื่องการรักษาความปลอดภัยและดูแลอุปกรณ์ของผู้ปฏิบัติงานในห้องปฏิบัติการเป็นอย่างดีเช่นเดียวกัน
                </div>
                <div>
                  <br />
                </div>
                <div>10. การจำกัดความรับผิดชอบ</div>
                <div>
                  ทางระบบแพลตฟอร์มดิจิทัล “ผูกพันธุ์”
                  ขอสงวนสิทธิที่จะไม่รับผิดชอบต่อความเสียหาย ค่าใช้จ่าย
                  ความสูญเสียที่อาจเกิดขึ้นจากการดำเนินการของโครงการฯ
                  ทั้งทางตรงและทางอ้อม รวมถึงความถูกต้องแม่นยำของข้อมูล
                  ความล่าช้าในการโอนถ่ายข้อมูล ระยะเวลาในการเปิดเผยข้อมูล
                  เหตุขัดข้องหรืออุปสรรคของการเชื่อมต่อ ความผิดพลาดในการแสดงผล
                  ความเสถียรของระบบฯ และไวรัสคอมพิวเตอร์จากการใช้งานระบบฯ
                </div>
                <div>
                  <br />
                </div>
                <div>11. ช่องทางการติดต่อ</div>
                <div>
                  หากผู้ปฏิบัติงานในห้องปฏิบัติการประสงค์จะติดต่อ หรือมีข้อสงสัย
                  หรือต้องการสอบถามข้อมูลเกี่ยวกับรายละเอียดการเก็บรวบรวม ใช้
                  และ/หรือเปิดเผยข้อมูลส่วนบุคคล
                  รวมถึงสิทธิของเจ้าหน้าที่ปฏิบัติการในห้องปฏิบัติงานนโยบายฉบับนี้
                  หรือต้องการยกเลิกการให้ความยินยอมในการเก็บรวบรวม ใช้
                  และ/หรือเปิดเผยข้อมูลส่วนบุคคล
                  หรือกรณีที่พบว่ามีการใช้ข้อมูลส่วนบุคคลของเจ้าหน้าที่ปฏิบัติการในห้องปฏิบัติงานไปในทางที่ไม่ชอบ
                  เจ้าหน้าที่ปฏิบัติการในห้องปฏิบัติงานสามารถติดต่อสำนักงานทางช่องทางดังต่อไปนี้
                </div>
                <div>
                  <br />
                </div>
                <div>
                  สถาบันชีววิทยาศาสตร์ทางการแพทย์ กรมวิทยาศาสตร์การแพทย์
                </div>
                <div>
                  สถานที่ติดต่อ: 88/7 ซอยบำราศนราดูร ถ.ติวานนท์ ต.ตลาดขวัญ
                  อ.เมือง จ.นนทบุรี 11000
                </div>
                <div>เวลาทำการปกติ: วันจันทร์ถึงศุกร์ เวลา 8:30 – 16:30 น.</div>
                <div>เว็บไซต์: https://phukphan.dmsc.moph.go.th/</div>
                <div>
                  <br />
                </div>
                <div>ติดต่อสอบถาม :</div>

                <div style={{ fontWeight: 700 }}>นางสาวพรนภัส อยู่นุช</div>
                <div>อีเมลล์: pornnapat.y@dmsc.mail.go.th</div>
                <div>หมายเลขโทรศัพท์: 0-2589-9850 ถึง 8 ต่อ 98096</div>

                <div style={{ fontWeight: 700 }}>นายพนาพัฒน์ ไพเราะ</div>
                <div>อีเมลล์: panapat.p@dmsc.mail.go.th</div>
                <div>หมายเลขโทรศัพท์: 0-2951-0000 ต่อ 99394</div>

                <div style={{ fontWeight: 700 }}>นางสาวนภัชชา ถาวงศ์</div>
                <div>อีเมลล์: penpitcha.t@dmsc.mail.go.th</div>
                <div>หมายเลขโทรศัพท์: 0-2589-9850 ถึง 8 ต่อ 98096</div>

                <div style={{ fontWeight: 700 }}>นายอาคม สาลี</div>
                <div>อีเมลล์: arkom.s@dmsc.mail.go.th</div>
                <div>หมายเลขโทรศัพท์: 0-2951-0000 ต่อ 99460</div>
              </div>
            </div>
          ) : (
            <div className={styles.card}>
              <div className={styles.title}>สำหรับห้องปฏิบัติการ</div>
              <br />
              <div className={styles.detail}>
                <div>
                  เจ้าหน้าปฏิบัติงานในห้องปฏิบัติการตกลงใช้บริการของระบบแพลตฟอร์มดิจิทัล
                  “ผูกพันธุ์” ของกระทรวงสาธารณะสุข
                  ตามรายละเอียดการให้บริการที่ระบบฯ กำหนด
                  โดยยอมรับและตกลงที่จะผูกพัน
                  และปฏิบัติตามข้อกำหนดและเงื่อนไขการใช้บริการ ดังต่อไปนี้
                </div>
                <div>
                  <br />
                </div>
                <div>1. คำนิยาม</div>
                <div>
                  1.1 “ระบบแพลตฟอร์มดิจิทัล” หรือ “Digital Platform” ผูกพันธุ์
                  (ระบบฯ) หมายความว่า บริการดิจิทัลภาครัฐที่พัฒนา
                  หรือจัดหาและให้บริการ โดยกรมวิทยาศาสตร์การแพทย์
                  โดยมีวัตถุประสงค์ให้ประชาชน บุคลาการทางการแพทย์
                  สามารถเข้าถึงข้อมูลพันธุกรรม ได้แก่
                  ผลการตรวจทางเภสัชพันธุศาสตร์ เป็นต้น โดยระบบแพลตฟอร์มดิจิทัล
                  “ผูกพันธุ์” แบ่งการใช้งานออกเป็น 2 ระบบ ได้แก่
                </div>
                <div>
                  <span className={styles.dot}></span>
                  “แอปพลิเคชัน” หรือ “Application” ผูกพันธุ์ หมายความว่า
                  แอปพลิเคชัน “ผูกพันธุ์” ตลอดจนโปรแกรมคอมพิวเตอร์ ชุดคำสั่ง
                  หรือแอปพลิเคชันอื่น ๆ ที่ต้องใช้หรืออาจใช้ร่วมกัน
                  หรือเกี่ยวเนื่องกันกับแอปพลิเคชันดังกล่าว เพื่อการใช้บริการ
                  “ผูกพันธุ์” ไม่ว่าจะใช้งานผ่านโทรศัพท์มือถือ แท็บเล็ต เว็บ
                  หรือผ่านอุปกรณ์อื่นใดก็ตาม ทั้งนี้ ในกรณีที่ แอปพลิเคชัน
                  “ผูกพันธุ์”
                  เปลี่ยนชื่อเป็นอย่างอื่นหรือมีแอปพลิเคชันอื่นรวมอยู่ด้วย
                  ให้หมายความรวมถึงแอปพลิเคชันนั้นด้วย
                </div>
                <div>
                  <span className={styles.dot}></span>
                  “เว็บไซต์” หรือ “website” ผูกพันธุ์ หมายความว่า เว็บไซต์
                  “ผูกพันธุ์” ตลอดจนหน้าเว็บเพจที่ทำขึ้นเพื่อนำเสนอข้อมูลต่าง ๆ
                  ผ่านทางคอมพิวเตอร์ และอินเทอร์เน็ต
                  โดยมีหลายหน้าที่เชื่อมโยงเข้ากับไฮเปอร์ลิงก์
                  เพื่อให้สามารถเปิดไปยังหน้าเพจต่าง ๆ และถูกจัดเก็บไว้ใน www.
                  (เวิลด์ไวด์เว็บ) โดยเว็บไซต์ผูกพันธุ์ หรือ
                  https://phukphan.dmsc.moph.go.th/ มีไว้เพื่อให้ประชาชน
                  บุคลากรทางการแพทย์ สามารถเข้าถึงข้อมูลพันธุกรรมได้
                  นอกจากนี้ยังให้เจ้าหน้าที่ห้องปฏิบัติการสามารถเปิดห้องปฏิบัติการของตนเองและสามารถรายงานผลการตรวจทางพันธุกรรมได้
                </div>
                <div>
                  1.2 “ข้อมูลส่วนบุคคล” หมายความว่า ข้อมูลส่วนตัว หรือ
                  ข้อมูลเกี่ยวกับผู้ใช้บริการ
                  ซึ่งทำให้สามารถระบุตัวตนของผู้ใช้บริการได้ไม่ว่าทางตรงหรือทางอ้อม
                  ซึ่งรวมถึงข้อมูลทั่วไปของผู้ใช้บริการ ข้อมูลที่ใช้ยืนยันตัวตน
                  ข้อมูลชีวมาตรหรือ biometrics (เช่น ลายนิ้วมือ ใบหน้า เป็นต้น)
                  ข้อมูลสุขภาพ และข้อมูลส่วนบุคคลอื่นใดเกี่ยวกับผู้ใช้บริการ
                  ตามกฎหมายว่าด้วยการคุ้มครองข้อมูลส่วนบุคคล ทั้งนี้
                  ไม่รวมถึงข้อมูลเกี่ยวกับผู้ใช้บริการ
                  ในกรณีที่ผู้ใช้บริการถึงแก่กรรม และไม่รวมถึงข้อมูลทางสถิติ
                  หรือข้อมูลที่ไม่สามารถระบุตัวบุคคลที่เป็นเจ้าของข้อมูลส่วนบุคคลได้
                  ซึ่งไม่ถือเป็นข้อมูลส่วนบุคคล
                  ตามกฎหมายว่าด้วยการคุ้มครองข้อมูลส่วนบุคคล
                </div>
                <div>
                  1.3 “ข้อมูลสุขภาพ” หมายความว่า
                  ข้อมูลส่วนบุคคลของผู้ใช้บริการที่มีเนื้อหาเกี่ยวกับสุขภาพ
                  ได้แก่ ข้อมูลการแพ้ยา ข้อมูลโรควินิจฉัย ข้อมูลการจ่ายยา
                  ข้อมูลวัคซีน ข้อมูลหัตถการ ข้อมูลค่าผลตรวจ ทางการแพทย์
                  ข้อมูลผลตรวจห้องปฏิบัติและผลสรุปภาพถ่ายทางการแพทย์
                  ข้อมูลสุขภาพละเอียดอ่อน เช่น ข้อมูลพันธุกรรม เป็นต้น
                  และข้อมูลการเข้ารับบริการการรักษาพยาบาล
                  รวมไปถึงข้อมูลสุขภาพอื่น ๆ ที่อาจมีเพิ่มเติมในอนาคต
                </div>
                <div>
                  1.4 “ผู้ใช้บริการ” หมายความว่า ผู้ใช้งาน ระบบแพลตฟอร์มดิจิทัล
                  “ผูกพันธุ์” แบ่งการใช้งานตามระบบฯ และบทบาทดังต่อไปนี้
                </div>
                <div>
                  <span className={styles.dot}></span>
                  “ประชาชน” หมายความว่า ผู้ป่วย หรือ บุคคลทั่วไป
                  ที่เข้าใช้งานระบบแพลตฟอร์มดิจิทัล “ผูกพันธุ์”
                </div>
                <div>
                  <span className={styles.dot}></span>
                  “บุคลากรทางการแพทย์” หมายความว่า ผู้ประกอบวิชาชีพทางการแพทย์
                  ได้แก่ แพทย์ เภสัชกรพยาบาล เทคนิคการแพทย์ กายภาพบำบัด
                  แพทย์แผนไทย นักสาธารณสุขชุมชน รวมทั้ง
                  ผู้ที่มีหน้าที่ในการดูแลรักษาผู้ป่วยในด้านอื่น ๆ
                </div>
                <div>
                  <span className={styles.dot}></span>
                  “ผู้ปฏิบัติงานในห้องปฏิบัติการ” หมายความว่า
                  ผู้มีหน้าที่รับผิดชอบในการดำเนินการวิเคราะห์
                  ผลการตรวจทางพันธุกรรมที่โรงพยาบาลได้ทำการส่งตัวอย่างมาที่กรมวิทยาศาสตร์การแพทย์
                  ได้แก่ นักเทคนิคการแพทย์ และ นักวิทยาศาสตร์การแพทย์
                </div>
                <div>
                  1.5 “โรงพยาบาล” หมายความว่า
                  สถานที่รวมตลอดถึงยานพาหนะซึ่งจัดไว้เพื่อการประกอบโรคศิลปะ
                  ตามกฎหมายว่าด้วยการประกอบโรคศิลปะ
                  การประกอบวิชาชีพเวชกรรมตามกฎหมายว่าด้วยวิชาชีพเวชกรรม
                  การประกอบวิชาชีพการพยาบาลและการผดุงครรภ์ตามกฎหมายว่าด้วยวิชาชีพ
                  การพยาบาลและการผดุงครรภ์
                  การประกอบวิชาชีพทันตกรรมตามกฎหมายว่าด้วยวิชาชีพทันตกรรม
                  เทคนิคการแพทย์ตามกฎหมายว่าด้วยวิชาชีพเทคนิค การแพทย์
                  การประกอบวิชาชีพการแพทย์แผนไทยและการประกอบวิชาชีพการแพทย์แผนไทยประยุกต์ตามกฎหมายว่าด้วยวิชาชีพการแพทย์แผนไทย
                  หรือการประกอบวิชาชีพทางการแพทย์และสาธารณสุขอื่นตามกฎหมายว่าด้วยการนั้น
                </div>
                <div>
                  1.6 “ระบบสารสนเทศโรงพยาบาล” หรือ “Hospital Information System:
                  HIS” หมายความว่า ระบบการจัดการโรงพยาบาลที่ช่วยในการจัดเก็บ
                  จัดการ และส่งต่อข้อมูลจำนวนมากทั้งจากภายใน และภายนอกโรงพยาบาล
                  ให้ผู้บริหารสามารถจัดสรรทรัพยากรต่างๆ
                  ของโรงพยาบาลได้อย่างคุ้มค่า
                  เพิ่มประสิทธิภาพของการทำงานและการรักษาผู้ป่วยได้อย่างรวดเร็ว
                </div>
                <div>
                  1.7 “ระบบรับ-ส่งตัวอย่างเพื่อตรวจวิเคราะห์” หรือ “iLAB PLUS”
                  หมายความว่า ระบบรับ-ส่งตัวอย่าง
                  เพื่อตรวจวิเคราะห์กรมวิทยาศาสตร์การแพทย์ กระทรวงสาธารณสุข
                  โดยผู้ใช้จะแบ่งเป็นสำหรับหน่วยงานผู้ขอรับบริการ
                  และสำหรับเจ้าหน้าที่กรมวิทยาศาสตร์การแพทย์
                  ซึ่งผู้ขอรับบริการเป็นผู้ส่งตัวอย่างให้กับห้องปฏิบัติการของกรมวิทยาศาสตร์การแพทย์
                  จากนั้นจะทำการวิเคราะห์ผลทางห้องปฏิบัติการ
                  เมื่อวิเคราะห์ผลเรียบร้อยแล้วจะทำการออกรายงานผล
                  รับรองผลการตรวจวิเคราะห์
                  และส่งผลการตรวจวิเคราะห์กลับให้ทางผู้ขอรับบริการนั้น ๆ
                </div>
                <div>
                  1.8 “ผู้ให้บริการ”
                  หมายความหน่วยงานที่มีหน้าที่และ/หรือได้รับมอบหมายในการจัดทำ
                  พัฒนา และให้บริการระบบแพลตฟอร์มดิจิทัล“ผูกพันธุ์”
                </div>
                <div>
                  <br />
                </div>
                <div>บทนำ</div>
                <div>
                  ระบบแพลตฟอร์มดิจิทัล “ผูกพันธุ์” (ระบบฯ) คือ
                  แพลตฟอร์มดิจิทัลที่มีจุดประสงค์เพื่อรวบรวมข้อมูลพันธุกรรม
                  ที่กรมวิทยาศาสตร์การแพทย์และห้องปฏิบัติการอื่น ๆ ให้บริการ
                  และให้ผู้ใช้บริการงานสามารถเข้าถึงผลการตรวจผ่านช่องทางต่าง ๆ
                  เช่น เว็บไซต์และแอปพลิเคชัน “ผูกพันธุ์”
                  ระเบียนสุขภาพอิเล็กทรอนิกส์ส่วนบุคคล (Personal Health Record:
                  PHR) และระบบสารสนเทศของโรงพยาบาล (Hospital Information System:
                  HIS) เป็นต้น โดยมีผู้ใช้บริการงานระบบ และบทบาทที่เกี่ยวข้อง
                  ดังนี้
                </div>
                <div>
                  1. ประชาชน
                  เข้าถึงและแสดงผลการตรวจของตนเองให้บุคลาการทางการแพทย์ที่รักษา
                </div>
                <div>
                  2. บุคลาการทางการแพทย์ เข้าถึงและใช้ผลการตรวจของประชาชน
                  ประกอบการพิจารณาวินิจฉัย ป้องกัน และรักษาโรคที่เฉพาะบุคคล
                  ส่งเสริมการรักษาแบบการแพทย์แม่นยำ (Precision Medicine)
                </div>
                <div>
                  3. ผู้ปฏิบัติงานในห้องปฏิบัติการ ได้แก่ นักเทคนิคการแพทย์ และ
                  นักวิทยาศาสตร์การแพทย์ ลงข้อมูล
                  ผลการตรวจในระบบแพลตฟอร์มดิจิทัล “ผูกพันธุ์”
                </div>
                <div>
                  ระบบฯ ถูกออกแบบให้รองรับการเชื่อมต่อ PHR ต่าง ๆ
                  ทำให้ประชาชนมีทางเลือกในการเข้าถึงข้อมูลพันธุกรรมมากขึ้น
                  และการเชื่อมโยงข้อมูลกับระบบ HIS
                  ทำให้สามารถรับ-ส่งข้อมูลพันธุกรรมเข้าสู่ระบบของโรงพยาบาลได้
                  ดังนั้น เพื่อให้ผู้ให้บริการระบบฯ สามารถให้บริการฯ
                  แก่ผู้ใช้บริการได้
                  ผู้ใช้บริการจะต้องแสดงเจตนาให้กรมวิทยาศาสตร์ กระทรวงสาธารณสุข
                  และผู้ให้บริการระบบฯ
                  ด้วยการตกลงยอมรับข้อกำหนดและเงื่อนไขการใช้บริการสำหรับประชาชน
                </div>
                <div>
                  ผู้ใช้บริการตกลงที่จะให้กรมวิทยาศาสตร์ กระทรวงสาธารณสุข
                  เก็บรวมรวม ใช้ จัดการ และเปิดเผยข้อมูลส่วนบุคคล
                  ของผู้ใช้บริการ รวมทั้งข้อมูลสุขภาพ
                  รวมทั้งยินยอมให้ผู้ให้บริการระบบฯ และโรงพยาบาลที่เข้าร่วมระบบฯ
                  เก็บรวบรวม ใช้ จัดการ
                  และเปิดเผยข้อมูลดังกล่าวเพื่อการดำเนินการตามวัตถุประสงค์ของระบบฯ
                </div>
                <div>
                  <br />
                </div>
                <div>
                  การตกลงยอมรับข้อกำหนดและเงื่อนไขการใช้บริการสำหรับเจ้าหน้าปฏิบัติงานในห้องปฏิบัติการ
                </div>
                <div>
                  1. ผู้ใช้จะต้องใช้บริการ
                  ตามข้อกำหนดที่ได้ระบุไว้ในเอกสารข้อกำหนดและเงื่อนไขการใช้บริการ
                  สำหรับบุคลากรทางการแพทย์ฉบับนี้เท่านั้น
                  โดยจะไม่สามารถใช้บริการได้เว้นเสียแต่ว่าผู้ใช้บริการจะทำการตกลงยอมรับข้อกำหนดและเงื่อนไขการใช้บริการสำหรับเจ้าหน้าปฏิบัติงานในห้องปฏิบัติการ
                </div>
                <div>
                  2. การเข้าใช้งานระบบแพลตฟอร์มดิจิทัล “ผูกพันธุ์”
                  ถือเป็นการแสดงเจตนาว่าผู้ใช้บริการได้ทำความเข้าใจ
                  และตกลงยอมรับข้อกำหนดและเงื่อนไขการใช้บริการสำหรับเจ้าหน้าปฏิบัติงานในห้องปฏิบัติการ
                  อย่างครบถ้วนสมบูรณ์แล้ว
                </div>
                <div>
                  3. การตกลงยอมรับข้อกำหนดและเงื่อนไขฯ
                  ถือเป็นการแสดงเจตนาว่าผู้ใช้บริการอนุญาตให้ผู้ให้บริการระบบฯ
                  รวมถึงหน่วยงานที่ร่วมมือในการให้บริการฯ
                  ตามจุดประสงค์ของการให้บริการฯ มีสิทธิอย่างถูกต้องในการเข้าถึง
                  และจัดการข้อมูลการใช้งานของผู้ใช้บริการ
                  รวมไปถึงข้อมูลที่เกิดจากการใช้งานของผู้ใช้บริการตามที่เห็นสมควร
                </div>
                <div>
                  4.
                  การตกลงยอมรับข้อกำหนดและเงื่อนไขสำหรับเจ้าหน้าปฏิบัติงานในห้องปฏิบัติการ
                  จะมีผลสมบูรณ์ตามกฎหมาย
                </div>
                <div>
                  5. ในกรณีที่มีการเพิ่มเติมรายละเอียดข้อกำหนดและเงื่อนไขฯ
                  การใช้บริการฯ
                  ผู้ใช้บริการจำเป็นจะต้องปฏิบัติตามข้อกำหนดและเงื่อนไขฯ
                  เพิ่มเติมดังกล่าวเช่นเดียวกัน
                </div>
                <div>
                  <br />
                </div>
                <div>
                  การแก้ไขข้อกำหนดและเงื่อนไขการใช้บริการสำหรับบุคลากรทางการแพทย์
                </div>
                <div>
                  ผู้ให้บริการระบบดิจิทัลแพลตฟอร์ม “ผูกพันธุ์”
                  อาจมีการแก้ไขเปลี่ยนแปลงข้อกำหนดและเงื่อนไขการใช้บริการสำหรับเจ้าหน้าปฏิบัติงานในห้องปฏิบัติการ
                  ตามเหตุอันเห็นสมควร
                  โดยไม่จำเป็นต้องแจ้งให้ผู้ใช้บริการทราบล่วงหน้า ยกเว้น
                  มีเหตุที่อาจเกิดผลกระทบต่อข้อมูลส่วนบุคคล
                  การแก้ไขเปลี่ยนแปลงจะมีผลบังคับใช้เมื่อมีการประกาศ
                  ข้อกำหนดและเงื่อนไขการใช้บริการ สำหรับบุคลากรทางการแพทย์
                  ที่แก้ไขไว้บนระบบฯ
                  ผู้ใช้บริการจะต้องตกลงยอมรับการเปลี่ยนแปลงของข้อกำหนดและเงื่อนไขการใช้บริการสำหรับเจ้าหน้าปฏิบัติงานในห้องปฏิบัติการ
                  เพื่อใช้บริการฯ
                  หลังจากมีการเปลี่ยนแปลงข้อกำหนดและเงื่อนไขการใช้บริการสำหรับบุคลากรทางการแพทย์
                  ผู้ใช้บริการควรตรวจสอบ
                  และทำความเข้าใจข้อกำหนดและเงื่อนไขการใช้บริการสำหรับเจ้าหน้าปฏิบัติงานในห้องปฏิบัติการ
                  ที่มีการเปลี่ยนแปลง อย่างถี่ถ้วนระมัดระวัง
                  และหากผู้ใช้บริการไม่ประสงค์ที่จะใช้งานระบบฯ
                  ต่อไปภายใต้ข้อกำหนดและเงื่อนไขการใช้บริการสำหรับเจ้าหน้าปฏิบัติงานในห้องปฏิบัติการ
                  ฉบับใหม่ ผู้ใช้บริการสามารถดำเนินการยกเลิกการใช้งานระบบฯ ได้
                  ปัจจุบัน ข้อกำหนด
                  และเงื่อนไขการใช้บริการสำหรับเจ้าหน้าปฏิบัติงานในห้องปฏิบัติการถูกทบทวนครั้งล่าสุดเมื่อวันที่
                  10 พฤศจิกายน 2566
                </div>
                <div>
                  <br />
                </div>
                <div>การคุ้มครองข้อมูลส่วนบุคคล</div>
                <div>
                  1. ผู้ให้บริการระบบฯ
                  ยึดมั่นและให้ความสำคัญกับการรักษาความเป็นส่วนตัวของผู้ใช้
                  โดยจะจัดให้มีการคุ้มครองข้อมูล
                  ส่วนบุคคลของผู้ใช้งานตามเอกสารนโยบายการคุ้มครองข้อมูลส่วนบุคคลของเจ้าหน้าปฏิบัติงานในห้องปฏิบัติการ
                </div>
                <div>
                  2. ผู้ให้บริการระบบฯ
                  จะกระทำการโดยระมัดระวังอย่างสูงสุดเพื่อปกป้องข้อมูลของผู้ใช้บริการจากการถูกทำลาย
                  หรือบุกรุกโดยผู้ไม่มีสิทธิ์ในการเข้าถึงข้อมูล อย่างไรก็ตาม
                  ในปัจจุบันผู้ให้บริการระบบฯ
                  ยังไม่สามารถรับประกันการปกป้องข้อมูลได้อย่างเด็ดขาดจากการถูกทำลายหรือบุคคลภายนอกที่ไม่เกี่ยวข้อง
                  หรือผู้ไม่หวังดี
                </div>
                <div>คุณสมบัติการใช้งานระบบแพลตฟอร์มดิจิทัล “ผูกพันธุ์”</div>
                <div>
                  ผู้ใช้บริการสามารถค้นหารายละเอียดของบริการฯ
                  ได้ผ่านเว็บไซต์หรือแอปพลิเคชันของระบบฯ
                  หรือในหนังสือแสดงความยินยอมเข้าร่วมระบบฯ
                  คุณสมบัติการใช้งานระบบแพลตฟอร์มดิจิทัล “ผูกพันธุ์”
                  ที่เป็นส่วนหนึ่งของบริการ ประกอบด้วยคุณสมบัติดังนี้
                  ซึ่งผู้ใช้บริการสามารถใช้งานได้ตลอด 24 ชั่วโมง
                  (ยกเว้นกรณีที่ระบบฯ
                  หยุดให้บริการเป็นการชั่วคราวเพื่อบำรุงรักษาระบบฯ หรือ
                  กรณีเกิดเหตุขัดข้อง) ทั้งนี้ ผู้ให้บริการระบบฯ
                  อาจเพิ่มเติมคุณสมบัติอื่น
                  หรือเปลี่ยนแปลงหรือยกเลิกคุณสมบัติเหล่านี้ได้ในอนาคต
                </div>
                <div>- การลงทะเบียนใช้งานระบบฯ</div>
                <div>- การถอนการลงทะเบียนใช้งานระบบฯ</div>
                <div>
                  - การรายงานผลการตรวจทางห้องปฏิบัติการโดยการแนบไฟล์ (.xcel)
                </div>
                <div>- การรายงานผลการตรวจทางห้องปฏิบัติการรายบุคคล</div>
                <div>
                  - การเพิ่มผู้ใช้งานและจัดการผู้ใช้งานในห้องปฏิบัติการของตนเอง
                </div>
                <div>
                  -
                  การย้ายห้องปฏิบัติการในกรณีที่ผู้ใช้บริการจำเป็นต้องย้ายภูมิลำเนาหรือที่ทำงาน
                </div>
                <div>
                  <br />
                </div>
                <div>บัญชีผู้ใช้บริการ</div>
                <div>
                  1. ระบบฯ แบ่งเจ้าหน้าปฏิบัติงานในห้องปฏิบัติการ ออกเป็น 2
                  ประเภท ได้แก่
                </div>
                <div>
                  <span className={styles.dot}></span>
                  เจ้าหน้าที่ดูแลห้องปฏิบัติการ เป็นผู้ที่เปิดห้องปฏิบัติการ
                  สามารถจัดการผู้ใช้งานในห้องปฏิบัติการของตนเอง
                  และสามารถรายงานผลการตรวจทางห้องปฏิบัติการได้
                </div>
                <div>
                  <span className={styles.dot}></span>
                  เจ้าหน้าที่ห้องปฏิบัติการ
                  เป็นผู้ที่รายงานผลการตรจทางห้องปฏิบัติการ
                </div>
                <div>
                  2. ในขั้นตอนการลงทะเบียนเข้าใช้งานระบบฯ
                  สำหรับเจ้าหน้าที่ปฏิบัติงานในห้องปฏิบัติการ
                  ผู้ใช้บริการจะต้องเปิดห้องปฏิบัติการของตนเองก่อน
                  โดยเลือกประเภทผู้ใช้งานเป็น “เจ้าหน้าที่ห้องปฏิบัติการ”
                  หลังจากนั้นผู้ใช้บริการที่อยู่ภายใต้ห้องปฏิบัติการนั้นถึงจะสามารถลงทะเบียนเข้าใช้งานได้
                  โดยเลือกประเภทผู้ใช้งานเป็น “เจ้าหน้าที่ห้องปฏิบัติการ”
                  และทำการเลือกห้องปฏิบัติการของตนเองเพื่อลงทะเบียนเข้าใช้งานระบบฯ
                </div>
                <div>
                  3. ผู้ใช้บริการระบบฯ เมื่อทำการลงทะเบียนเข้าใช้งาน
                  ระบบฯจะแสดงช่องเพื่อกรอกเลขใบประกอบวิชาชีพ
                  หากผู้ใช้บริการระบบไม่มีเลขใบประกอบวิชาชีพ
                  ผู้ใช้บริการจะต้องแนบไฟล์คำร้องของใช้ระบบฯ
                  เพื่อให้ผู้ให้บริการระบบฯ
                  ตรวจสอบข้อมูลและทำการอนุมัติให้ผู้ใช้บริการสามารถเข้าใช้งานได้
                </div>
                <div>
                  4. ผู้ใช้บริการจะต้องยืนยันตัวตนผ่านแพลตฟอร์ม หมอพร้อม หรือ
                  OnesID หรือ ThaiD เมื่อสมัครใช้งานสำเร็จ ผู้ให้บริการระบบฯ
                  จะอนุมัติให้ผู้ใช้บริการสามารถเข้าใช้งาน
                  จากการตรวจเลขใบกระกอบวิชาชีพของบุคลากรทางการแพทย์ ดังนั้น
                  ผู้ใช้บริการจำเป็นต้องเป็นบุคลากรทางการแพทย์ที่มีเลขใบประกอบวิชาชีพเท่านั้น
                  ถึงจะสามารถเข้าใช้งานระบบฯได้
                </div>
                <div>
                  5. ในห้องปฏิบัติการ หนึ่งแห่ง
                  สามารถมีเจ้าหน้าที่ดูแลห้องปฏิบัติการได้เพียงหนึ่งบัญชีเท่านั้น
                  หากสร้างบัญชีผู้ใช้บริการใหม่ในขณะที่ห้องปฏิบัติการ
                  มีบัญชีผู้ใช้บริการเก่าอยู่แล้ว ผู้ให้บริการระบบฯ
                  จะทำการปิดบัญชีผู้ใช้บริการเก่าก่อนที่จะสร้างบัญชีผู้ใช้บริการใหม่
                  ทั้งนี้ ผู้ให้บริการระบบฯ อาจมีการตรวจสอบกับหน่วยงานฯ
                  ก่อนที่จะทำการดังกล่าว
                </div>
                <div>6. ผู้ใช้บริการระบบสามารถใช้งานระบบฯ ได้ดังต่อไปนี้</div>
                <div>
                  <span className={styles.dot}></span>
                  เจ้าหน้าที่ดูแลห้องปฏิบัติการ
                </div>
                <div>- จัดการเจ้าเจ้าหน้าที่ห้องปฏิบัติการของตนเอง</div>
                <div>- เพิ่มเจ้าหน้าที่ปฏิบัติการท่านอื่นๆ</div>
                <div>- รายงานผลการตรวจทางห้องปฏิบัติการ</div>
                <div>
                  <span className={styles.dot}></span>
                  เจ้าหน้าที่ห้องปฏิบัติการ
                </div>
                <div>- รายงานผลการตรวจทางห้องปฏิบัติการ</div>
                <div>
                  7.
                  ข้อมูลส่วนบุคคลของผู้ใช้บริการจะมาจากการลทะเบียนผ่านแพลตฟอร์ม
                  หมอพร้อม หรือ ThaiD หรือ OnesID หรือระบบแพลตฟอร์มดิจิทัล
                  “ผูกพันธุ์” หากข้อมูลดังกล่างไม่ถูกต้อง
                  ผู้ใช้บริการจะต้องติดต่อผู้ให้บริการระบบฯ
                  แก้ไข้ข้อมูลให้ถูกต้อง
                </div>
                <div>
                  8.
                  ความถูกต้องครบถ้วนและเป็นจริงของข้อมูลเกี่ยวกับบัญชีผู้ใช้บริการไม่ได้อยู่ภายใต้ความรับผิดชอบของผู้ดูแลระบบฯ
                  โดยตรง
                </div>
                <div>
                  9. ผู้ให้บริหาระบบฯ ถือว่าการใช้บริการฯ หรือกิจกรรมใด ๆ
                  ที่ดำเนินการภายใต้บัญชีดังกล่าวเป็นกิจกรรมที่ผู้ใช้บริการผู้เป็นเจ้าของบัญชีได้ดำเนินการด้วยตนเองทั้งสิ้น
                  ทั้งนี้
                  เว้นแต่จะมีหลักฐานที่สามารถพิสูจน์ได้ว่าเกิดขึ้นโดยผู้ใช้บริการไม่รับรู้และไม่ยินยอม
                  หรือเกิดจากความผิดพลาดของระบบฯ หรือเหตุสุดวิสัย
                </div>
                <div>
                  10. ผู้ดูแลระบบฯ มีสิทธิในการตรวจสอบประวัติการใช้งานระบบฯ
                  ของผู้ใช้บริการได้โดยไม่จำเป็นต้องแจ้งให้ทราบล่วงหน้า
                </div>
                <div>
                  11. ผู้ให้บริการระบบฯ
                  มีสิทธิในการระงับการเข้าใช้งานหรือเพิกถอนบัญชีในระบบฯ
                  รวมถึงการใช้บริการฯ ต่าง ๆ ผ่านบัญชีในระบบฯ
                  ของผู้ใช้บริการได้โดยไม่จำเป็นต้องแจ้งให้ทราบล่วงหน้า
                  หากทางผู้ดูแลระบบฯ
                  ตรวจสอบพบว่าผู้ใช้บริการได้ละเมิดหรือกำลังกระทำการอันเป็นการละเมิดข้อกำหนดและเงื่อนไขฯ
                </div>
                <div>
                  12. บัญชีของผู้ใช้บริการแต่ละบัญชีในระบบฯ
                  สงวนไว้เพื่อการใช้งานเฉพาะและโดยผู้เป็นเจ้าของบัญชีแต่เพียงผู้เดียวเท่านั้น
                  ผู้ใช้บริการไม่สามารถโอนสิทธิการใช้งานหรือให้ยืมบัญชีของตนแก่บุคคลอื่นไม่ว่ากรณีใดก็ตาม
                </div>
                <div>
                  <br />
                </div>
                <div>การให้บริการของระบบแพลตฟอร์มดิจิทัล “ผูกพันธุ์”</div>
                <div>
                  1. ผู้ใช้บริการหรือหน่วยงานฯ
                  จะต้องเป็นผู้ดูแลรับผิดชอบในการจัดหาเครื่องคอมพิวเตอร์
                  อุปกรณ์โทรศัพท์เคลื่อนที่ หรืออุปกรณ์อิเล็กทรอนิกส์ใด ๆ
                  รวมถึงระบบปฏิบัติการและการเชื่อมต่อข้อมูลที่จำเป็นสำหรับการใช้บริการฯ
                </div>
                <div>
                  2.
                  ผู้ใช้บริการสามารถสร้างบัญชีผู้ใช้โดยการลงทะเบียนผ่านเว็บไซต์หรือแอปพลิเคชัน
                  ดังต่อไปนี้
                </div>
                <div>
                  <span className={styles.dot}></span>
                  เว็บไซต์หรือแอปพลิเคชัน “ผูกพันธุ์”
                </div>
                <div>
                  <span className={styles.dot}></span>
                  แอปพลิเคชัน “หมอพร้อม”
                </div>
                <div>
                  <span className={styles.dot}></span>
                  แอปพลิเคชัน “OnesID”
                </div>
                <div>
                  <span className={styles.dot}></span>
                  แอปพลิเคชัน “ThaiD”
                </div>
                <div>
                  และจำเป็นต้องพิสูจน์ตัวตนก่อน
                  ถึงจะสามารถรายงานผลการตรวจทางห้องปฏิบัติการได้
                </div>
                <div>
                  3. ผู้ใช้บริการสามารถการรายงานผลการตรวจทางห้องปฏิบัติการได้ 2
                  วิธี
                </div>
                <div>
                  <span className={styles.dot}></span>
                  การรายงานผลการตรวจทางห้องปฏิบัติการโดยการแนบไฟล์ (.xcel)
                </div>
                <div>
                  <span className={styles.dot}></span>
                  การรายงานผลการตรวจทางห้องปฏิบัติการรายบุคคล
                </div>
                <div>
                  4. ผู้ใช้บริการตกลงว่าระบบฯ และผู้ให้บริการระบบฯ
                  ไม่มีภาระผูกพันหรือความรับผิดต่อเนื้อหา บริการ หรือกรณีใด ๆ
                  ที่เกิดจากหรือเกี่ยวข้องกับระบบฯ ของบุคคลที่สาม
                </div>
                <div>
                  5. ผู้ใช้บริการตกลงว่า
                  ในขณะที่ความสัมพันธ์ระหว่างผู้ใช้บริการกับระบบฯ ของบุคคลที่สาม
                  อาจถูกควบคุมโดยข้อตกลงกับบุคคลที่สามนั้น
                  การถอนการติดตั้งและ/หรือหยุดใช้งานระบบฯ ของบุคคลที่สาม
                  ที่มีความเกี่ยวข้องกับระบบฯ
                  เป็นการแก้ปัญหาความไม่พึงพอใจในตัวระบบฯ หรือเนื้อหาใน ระบบฯ
                  ของบุคคลที่สาม
                </div>
                <div>
                  6. บัญชีของผู้ใช้แต่ละบัญชีในระบบฯ
                  สงวนไว้เพื่อการใช้งานเฉพาะและโดยผู้เป็นเจ้าของบัญชีแต่เพียงผู้เดียวเท่านั้น
                  ผู้ใช้บริการไม่สามารถโอนสิทธิการใช้งานหรือให้ยืมบัญชีของตนแก่บุคคลอื่นไม่ว่ากรณีใดก็ตาม
                </div>
                <div>
                  7. ผู้ให้บริการระบบฯ ขอสงวนสิทธิ์ในการจำกัดการเข้าถึงบริการฯ
                  ของผู้ใช้บริการตามที่เห็นสมควร
                </div>
                <div>
                  8. ผู้ใช้บริการยอมรับว่า เท่าที่กฎหมายที่เกี่ยวข้องจะอนุญาต
                  การใช้งานและการให้บริการระบบฯ
                  เป็นความเสี่ยงของผู้ใช้บริการแต่เพียงฝ่ายเดียว
                  การให้บริการระบบฯ ถูกจัดทำขึ้น “ตามสภาพ” (as is) และ
                  “ตามที่มี” (as available) โดยอาจมีข้อบกพร่องรวมอยู่ด้วย
                  ผู้ให้บริการระบบฯ ไม่มีการรับประกันโดยนัยใด ๆ ทั้งสิ้น
                </div>
                <div>
                  <br />
                </div>
                <div>เนื้อหา</div>
                <div>
                  1. ผู้ใช้บริการจำเป็นจะต้องปฏิบัติตามข้อกำหนดและเงื่อนไขฯ
                  เมื่อมีการเรียกดูเนื้อหาฯ หรือนำไปใช้ และไม่ใช้เนื้อหาฯ
                  เกินจากขอบเขตของการใช้งานตามวัตถุประสงค์ ยกตัวอย่างเช่น
                  การลักลอบทำสำเนา การส่งต่อ การทำซ้ำ การแก้ไขบิดเบือน
                  หรือการนำเนื้อหาฯ ไปใช้เพื่อวัตถุประสงค์เชิงพาณิชย์อื่นใด
                  เป็นต้น
                </div>
                <div>
                  2. กรณีที่ผู้ดูแลระบบฯ
                  ตรวจสอบพบว่าผู้ใช้บริการได้มีการใช้เนื้อหาฯ
                  ในลักษณะที่อาจเป็นการฝ่าฝืนกฎหมายหรือละเมิดข้อกำหนดและเงื่อนไขฯ
                  ผู้ดูแลระบบฯ
                  ขอสงวนสิทธิ์การตัดสิทธิ์ของผู้ใช้บริการในการเรียกดูและใช้เนื้อหาฯ
                  โดยไม่จำเป็นต้องแจ้งให้ผู้ใช้บริการทราบล่วงหน้า
                </div>
                <div>
                  <br />
                </div>
                <div>ข้อจำกัด</div>
                <div>
                  ในการใช้บริการฯ ของระบบระบบแพลตฟอร์มดิจิทัล “ผูกพันธุ์”
                  ผู้ใช้บริการจะต้องไม่มีส่วนร่วมในกิจกรรมต่าง ๆ ดังต่อไปนี้
                </div>
                <div>
                  1. กิจกรรมที่เป็นการฝ่าฝืนกฎหมาย คำพิพากษา มติหรือคำสั่งศาล
                  หรือมาตรการทางปกครองที่มีผลผูกพัน ทางกฎหมาย
                </div>
                <div>
                  2.
                  กิจกรรมอื่นใดที่อาจขัดต่อความสงบเรียบร้อยหรือศีลธรรมอันดีงาม
                </div>
                <div>
                  3. กิจกรรมที่เป็นการละเมิดทรัพย์สินทางปัญญา เช่น
                  การละเมิดลิขสิทธิ์ ชื่อเสียง ความเป็นส่วนตัว เป็นต้น
                  และสิทธิอื่นๆ ทั้งหมดของผู้ให้บริการระบบฯ
                  และ/หรือบุคคลภายนอกที่มีการมอบให้ตามกฎหมายหรือสัญญา
                </div>
                <div>
                  4. กิจกรรมที่ส่งเสริมหรือนำไปสู่การเลือกปฏิบัติโดยเชื้อชาติ
                  สัญชาติ เพศ สถานะทางสังคม ถิ่นกำเนิดครอบครัว ลักษณะทางกายภาพ
                  สุขภาพหรือโรคประจำตัว และอื่น ๆ
                  รวมถึงการแสดงออกที่ชักชวนหรือส่งเสริมให้เกิด การฆ่าตัวตาย
                  พฤติกรรมการทำร้ายตัวเองหรือการใช้ยาในทางที่ผิด
                </div>
                <div>
                  5. กิจกรรมที่หลีกเลี่ยงเทคโนโลยีใด ๆ ที่ผู้ให้บริการระบบฯ
                  ผู้ที่ได้รับอนุญาต หรือบุคคลที่สามใด ๆ ใช้เพื่อ
                  ปกป้องเนื้อหาหรือบริการฯ
                </div>
                <div>
                  6. กิจกรรมที่อาจทำให้ผู้อื่นเกิดความเข้าใจผิดเกี่ยวกับระบบฯ
                  บริการของระบบฯ และ/หรือบุคคลภายนอก
                  หรือการจงใจเผยแพร่ข้อมูลเท็จ
                </div>
                <div>
                  7. กิจกรรมที่มีการแลกเปลี่ยนสิทธิในการใช้บริการฯ
                  หรือเข้าถึงเนื้อหาเพียงบางส่วนหรือทั้งหมดเป็นเงินสด
                  ทรัพย์สินหรือผลประโยชน์ใด ๆ
                </div>
                <div>
                  8. กิจกรรมที่มีการใช้บริการฯ เพื่อการซื้อขาย การตลาด โฆษณา
                  การชักชวน การได้มาซึ่งผลประโยชน์ส่วนตน
                  หรือวัตถุประสงค์ทางการค้าอื่น ๆ รวมถึงกิจกรรมที่ใช้บริการฯ
                  เพื่อวัตถุประสงค์ในการคุกคาม หรือหมิ่นประมาท
                  หรือกิจกรรมที่ใช้บริการฯ
                  เพื่อวัตถุประสงค์อื่นใดที่ไม่ใช่จุดประสงค์ที่แท้จริงของการให้บริการระบบฯ
                </div>
                <div>
                  9. กิจกรรมที่นำไปสู่การเก็บรวบรวม การเปิดเผย การทำสำเนา
                  การส่งต่อ การทำซ้ำ หรือการแก้ไข บิดเบือน
                  ข้อมูลส่วนบุคคลซึ่งเป็นเนื้อหาบนระบบฯ รวมไปถึงการทำสำเนา
                  โดยไม่ได้รับความเห็นชอบ
                  จากเจ้าของข้อมูลส่วนบุคคลและ/หรือผู้ให้บริการระบบฯ
                  หรือไม่ชอบด้วยกฎหมาย
                </div>
                <div>
                  10. กิจกรรมที่แทรกแซงเครื่องแม่ข่าย
                  และ/หรือระบบเครือข่ายของระบบฯ กิจกรรมซึ่งเป็นการใช้บริการฯ
                  ในทางที่ผิดด้วยการใช้บ็อท (BOTs) เครื่องมือเพื่อการโกง
                  หรือวิธีการทางเทคนิคใด ๆ
                  กิจกรรมที่ใช้ข้อบกพร่องหรือข้อผิดพลาดของบริการฯ
                  โดยไตร่ตรองไว้ก่อนแล้ว
                </div>
                <div>
                  11. กิจกรรมการตรวจสอบ สแกน หรือทดสอบจุดอ่อนของระบบฯ
                  หรือเครือข่ายใด ๆ
                </div>
                <div>
                  12.
                  กิจกรรมฝ่าฝืนหรือหลีกเลี่ยงการรักษาความปลอดภัยหรือมาตรการตรวจสอบตัวตน
                </div>
                <div>
                  13. กิจกรรมเข้าถึง ก้าวก่าย หรือใช้บริการฯ หรือ เนื้อหาใด ๆ
                  ซึ่งไม่เป็นไปตามขอบเขตการใช้งานของผู้ใช้บริการงาน
                  และวัตถุประสงค์ของระบบฯ
                </div>
                <div>
                  14. กิจกรรมที่ส่งเสริมหรือช่วยเหลือกิจกรรมใด ๆ
                  ที่กล่าวไว้ข้างต้น
                </div>
                <div>
                  15.
                  กิจกรรมที่ขัดแย้งกับข้อกำหนดและเงื่อนไขการใช้บริการสำหรับเจ้าหน้าปฏิบัติงานในห้องปฏิบัติการ
                  นี้ ตามที่ผู้ให้บริการระบบฯ กำหนดไว้
                </div>
                <div>
                  16. กิจกรรมอื่น ๆ ที่ผู้ให้บริการระบบฯ เห็นว่าไม่เหมาะสม
                </div>
                <div>
                  <br />
                </div>
                <div>ความรับผิดชอบของผู้ใช้บริการ</div>
                <div>
                  1. ผู้ใช้บริการจะต้องใช้บริการฯ
                  โดยถือเป็นความเสี่ยงของผู้ใช้บริการเอง
                  และจะต้องเป็นผู้รับผิดชอบแต่เพียงผู้เดียวสำหรับการกระทำ/กิจกรรมที่ได้ทำไป
                  รวมถึงผลของการกระทำที่มีต่อบริการฯ นี้ด้วย
                </div>
                <div>
                  2. ข้อมูลการเข้าใช้งานระบบฯ และกิจกรรมใดๆ
                  ที่เกิดขึ้นขณะผู้ใช้เข้าใช้งานระบบฯ
                  เป็นความรับผิดชอบของผู้ใช้เองทั้งหมด
                </div>
                <div>
                  3. ผู้ให้บริการระบบฯ อาจใช้มาตรการที่เห็นว่าจำเป็นและเหมาะสม
                  หากผู้ให้บริการระบบฯ พบว่าผู้ใช้รายใด
                  กำลังใช้บริการฯในทางที่ฝ่าฝืนข้อกำหนดและเงื่อนไขฯ อย่างไรก็ตาม
                  ผู้ให้บริการระบบฯ จะไม่รับผิดชอบ
                  ในการแก้ไขหรือป้องกันการฝ่าฝืนดังกล่าว
                </div>
                <div>
                  4. ในกรณีที่การใช้บริการฯ
                  ของผู้ใช้บริการก่อให้เกิดความเสียหายแก่ระบบฯ
                  หรือผู้ให้บริการระบบฯ หรือถูกเรียกเก็บค่าใช้จ่ายใด ๆ
                  (รวมถึงแต่ไม่จำกัดเพียงค่าทนายความ) ทั้งทางตรงและทางอ้อม
                  (รวมถึงแต่ไม่จำกัดเพียงกรณีที่มีบุคคลภายนอกฟ้องร้องเรียกค่าเสียหายจากผู้ให้บริการระบบฯ
                  )
                  อันเนื่องมาจากการที่ผู้ใช้บริการฝ่าฝืนข้อกำหนดและเงื่อนไขการใช้บริการสำหรับประชาชน
                  หรือฝ่าฝืนกฎหมายที่เกี่ยวข้องขณะใช้บริการฯ
                  ผู้ใช้บริการจะต้องทำการรับผิดชอบต่อความเสียหาย/ชดใช้ค่าเสียหายด้วยตนเอง
                  โดยไม่เกี่ยวข้องกับผู้ให้บริการระบบฯ แต่อย่างใด
                  ผู้ใช้รับทราบว่าการชดใช้ค่าเสียหายเพียงอย่างเดียวอาจไม่เพียงพอต่อการเยียวยาความเสียหายอันเกิดจากการฝ่าฝืนกฎหมายและ/หรือละเมิดข้อกำหนดและเงื่อนไขฯ
                  ฉบับนี้ ผู้ให้บริการระบบฯ
                  มีสิทธิได้รับการเยียวยาความเสียหายจากการกระทำการหรืองดเว้นกระทำการอื่นใดได้ตามความเหมาะสม
                </div>
                <div>
                  5. ผู้ใช้บริการยอมรับที่จะปฏิบัติตาม ข้อจำกัด
                  และจะไม่ใช้บริการ เนื้อหาของระบบฯ หรือส่วนใดที่กล่าวมาข้างต้น
                  ในลักษณะใดก็ตามที่ไม่ได้รับอนุญาตอย่างชัดเจนในข้อกำหนดและเงื่อนไขการใช้บริการสำหรับ
                  เจ้าหน้าปฏิบัติงานในห้องปฏิบัติการผู้ให้บริการระบบฯ
                  ไม่ให้สิทธิ์ ชื่อ หรือผลประโยชน์ใดก็ตามแก่ผู้ใช้บริการในบริการ
                  หรือเนื้อหาของระบบฯ
                  ยกเว้นสิทธิ์ที่ได้รับอนุญาตโดยชัดเจนในข้อกำหนดและเงื่อนไขการใช้บริการ
                  สำหรับเจ้าหน้าปฏิบัติงานในห้องปฏิบัติการ
                </div>
                <div>
                  <br />
                </div>
                <div>การให้บริการระบบแพลตฟอร์มดิจิทัล “ผูกพันธุ์”</div>
                <div>
                  ผู้ให้บริการระบบแพลตฟอร์มดิจิทัล “ผูกพันธุ์”
                  ขอสงวนสิทธิ์ในการจำกัดการเข้าถึงบริการระบบฯ
                  ของผู้ใช้บริการตามที่เห็นสมควรผู้ให้บริการระบบฯ
                  ขอสงวนสิทธิ์ในการเพิ่มเติม เปลี่ยนแปลง หรือยกเลิกการให้บริการฯ
                  เพียงบางส่วนหรือทั้งหมดโดยไม่จำเป็นต้องแจ้งให้ผู้ใช้บริการทราบล่วงหน้า
                  ผู้ใช้บริการยอมรับว่า เท่าที่กฎหมายที่เกี่ยวข้อง จะอนุญาต
                  การใช้งานและการให้บริการระบบฯ
                  เป็นความเสี่ยงของผู้ใช้บริการแต่เพียงฝ่ายเดียว
                  การให้บริการระบบฯ ถูกจัดทำขึ้น “ตามสภาพ” (as is) และ
                  “ตามที่มี” (as available) โดยอาจมีข้อบกพร่องรวมอยู่ด้วย
                  ผู้ให้บริการระบบฯ ไม่มีการรับประกันโดยนัยใด ๆ ทั้งสิ้น
                </div>
                <div>
                  <br />
                </div>
                <div>การยกเว้นความรับผิดชอบ</div>
                <div>
                  1. ผู้ให้บริการระบบแพลตฟอร์มดิจิทัล “ผูกพันธุ์”
                  ไม่สามารถรับประกันไม่ว่าจะอย่างชัดแจ้งหรือโดยปริยายว่า
                  การให้บริการฯ (รวมถึงข้อมูลส่วนบุคคล)
                  จะปราศจากข้อผิดพลาดหรือข้อบกพร่องตามจริงหรือตามกฎหมาย
                  ซึ่งอาจรวมถึง เสถียรภาพ การไว้วางใจได้ ความน่าเชื่อถือ
                  ความถูกต้อง ความครบถ้วนสมบูรณ์ การมีประสิทธิผล
                  ความเหมาะสมในการใช้บริการฯ เพื่อวัตถุประสงค์เฉพาะ
                  จุดบกพร่องที่เกี่ยวข้องกับความปลอดภัย (bug)
                  หรือการละเมิดสิทธิต่างๆ และผู้ให้บริการระบบฯ
                  จะไม่รับผิดชอบในการจัดหาบริการฯ
                  ที่ไม่มีข้อผิดพลาด/ข้อบกพร่องดังกล่าว แต่จะจัดหาบริการฯ
                  ที่ดีที่สุดตามความเหมาะสม
                </div>
                <div>
                  2. ผู้ให้บริการระบบแพลตฟอร์มดิจิทัล “ผูกพันธุ์”
                  ไม่สามารถรับรองได้ว่าผู้ใช้บริการจะได้รับผลประโยชน์
                  ตามวัตถุประสงค์ของระบบฯ เมื่อผู้ใช้บริการใช้บริการฯ
                  นอกจากนี้ผู้ให้บริการระบบฯ
                  ไม่สามารถรับประกันได้ด้วยว่าเจ้าหน้าปฏิบัติงานในห้องปฏิบัติการ
                  ผู้ปฏิบัติการในห้องปฏิบัติการ และผู้ดูแลระบบฯ ฝั่งโรงพยาบาล
                  (Hospital Administrator)
                  จะปฏิบัติตามข้อกำหนดและเงื่อนไขการใช้บริการสำหรับผู้ดูแลระบบฯ
                  ฝั่งโรงพยาบาล ดังนั้น ผู้ให้บริการระบบฯ
                  จะไม่รับผิดชอบข้อผิดพลาดใด ๆ
                  ที่เกิดจากการปฏิบัติหรือไม่ปฏิบัติตามข้อกำหนดและเงื่อนไขของการใช้งานของผู้ใช้บริการดังกล่าว
                </div>
                <div>
                  3. ผู้ให้บริการระบบระบบแพลตฟอร์มดิจิทัล “ผูกพันธุ์”
                  ไม่รับรองว่าผู้ใช้บริการจะสามารถใช้งานบริการฯ
                  ร่วมกับเครื่องคอมพิวเตอร์หรืออุปกรณ์อิเล็กทรอนิกส์ทุกชนิดของผู้ใช้บริการ
                  รวมไปถึงการที่ผู้ให้บริการระบบฯ จะให้บริการฯ
                  โดยปราศจากไวรัสคอมพิวเตอร์ วอร์ม หรือ ม้าโทรจัน (Trojan Horse)
                  และผู้ให้บริการระบบฯ จะไม่รับผิดชอบชดใช้ต่อความเสียหายใด ๆ
                  ที่เป็นผลมาจากตัวทำลายเหล่านั้น
                </div>
                <div>
                  4. ผู้ให้บริการระบบฯ
                  ไม่มีความจำเป็นต้องรับผิดชอบต่อค่าเสียหายใด ๆ
                  ที่เกิดขึ้นกับผู้ใช้บริการ ในการใช้หรือไม่สามารถใช้บริการฯ
                  แบบใด ๆ หรือเนื่องจากเหตุใดก็ตาม ข้อจำกัดมีผลบังคับใช้เสมอ
                  ไม่ว่า ผู้ให้บริการระบบฯ
                  จะได้รับทราบหรือควรตระหนักถึงความเป็นไปได้ของความเสียหายดังกล่าว
                  ในเขตอำนาจศาลที่ไม่อนุญาตให้ยกเว้นหรือจำกัดความรับผิดชอบต่อความเสียหายที่เป็นผลสืบเนื่องหรือเกิดขึ้นโดยไม่ได้ตั้งใจ
                  การรับผิดชอบของผู้ให้บริการระบบฯ
                  จำกัดแค่ขอบเขตสูงสุดที่กฎหมายอนุญาตเท่านั้น
                </div>
                <div>
                  5. ผู้ให้บริการระบบฯ จะไม่ต้องรับผิดชอบต่อค่าเสียหายโดยอ้อม
                  ค่าเสียหายพิเศษ ค่าเสียหายเนื่องจากการผิดสัญญา
                  ค่าเสียหายต่อเนื่องหรือค่าเสียหายเชิงลงโทษใด ๆ
                  ในส่วนที่เกี่ยวข้องกับการผิดสัญญาหรือการกระทำการละเมิด
                  อันเนื่องมากจากความประมาทของผู้ให้บริการระบบฯ เอง
                  การชดใช้ค่าเสียหายตามปกติในส่วนที่เกี่ยวข้องกับ
                  การผิดสัญญาหรือการกระทำละเมิดจากการเลินเล่อของผู้ให้บริการระบบฯ
                  จะเป็นไปตามความเหมาะสม ของการพิจารณาตามกฎหมาย
                </div>
                <div>
                  <br />
                </div>
                <div>
                  สิทธิ์ที่ผู้ใช้บริการมอบให้ผู้ให้บริการระบบแพลตฟอร์มดิจิทัล
                  “ผูกพันธุ์”
                </div>
                <div>
                  ในการพิจารณาสิทธิ์ที่ผู้ใช้บริการมอบให้ผู้ให้บริการระบบฯ
                  ภายใต้ข้อกำหนดและเงื่อนไขฯ ผู้ใช้บริการ
                  ได้ให้สิทธิ์ผู้ให้บริการระบบฯ ในการให้บริการฯ ใช้ระบบประมวลผล
                  แบนด์วิดธ์ และ ฮาร์ดแวร์ที่ใช้เก็บข้อมูลบนอุปกรณ์
                  ของผู้ใช้บริการ
                  เพื่อเป็นการอำนวยความสะดวกในการปฏิบัติการของบริการฯ
                </div>
                <div>
                  <br />
                </div>
                <div>
                  การยกเลิกสิ้นสุดข้อกำหนดและเงื่อนไขการใช้บริการสำหรับเจ้าหน้าปฏิบัติงานในห้องปฏิบัติการ
                </div>
                <div>
                  ผู้ให้บริการระบบฯ อาจทำการยกเลิกข้อกำหนดและเงื่อนไขฯ
                  เหล่านี้เมื่อใดก็ได้ตามเหตุอันเห็นสมควรโดยอาจแจ้งให้ผู้ใช้บริการทราบผ่านทางเว็บไซต์หรือแอปพลิเคชัน
                  “ผูกพันธุ์” และการยกเลิกสิ้นสุดจะมีผลทันที ณ ขณะนั้น
                </div>
                <div>
                  <br />
                </div>
                <div>การโอนสิทธิ์</div>
                <div>
                  1. ผู้ให้บริการระบบฯ
                  อาจโอนสิทธิ์ในข้อกำหนดและเงื่อนไขการใช้บริการสำหรับเจ้าหน้าปฏิบัติงานในห้องปฏิบัติการ
                  และสิทธิ์ใดก็ตามที่มีภายใต้ข้อกำหนดและเงื่อนไขการใช้บริการสำหรับเจ้าหน้าปฏิบัติงานในห้องปฏิบัติการ
                  ฉบับนี้ ทั้งหมดหรือบางส่วน อีกทั้ง ผู้ให้บริการระบบฯ
                  อาจมอบหมายภาระผูกพันภายใต้ข้อกำหนดและเงื่อนไขการใช้บริการสำหรับเจ้าหน้าปฏิบัติงานในห้องปฏิบัติการนี้ได้
                </div>
                <div>
                  2.
                  ผู้ใช้บริการไม่อาจโอนสิทธิ์ในข้อกำหนดและเงื่อนไขการใช้บริการสำหรับเจ้าหน้าปฏิบัติงานในห้องปฏิบัติการ
                  ทั้งหมดหรือบางส่วน หรือถ่ายสิทธิ์
                  หรืออนุญาตให้ใช้สิทธิ์ต่อภายใต้ข้อกำหนดและเงื่อนไขการใช้บริการสำหรับเจ้าหน้าปฏิบัติงานในห้องปฏิบัติการนี้แก่บุคคลที่สามใดก็ตาม
                </div>
                <div>
                  <br />
                </div>
                <div>การเป็นโมฆะบางส่วน การละเว้น และ การตีความ</div>
                <div>
                  เว้นแต่ได้ระบุไว้เป็นอื่นในข้อกำหนดและเงื่อนไขการใช้บริการสำหรับเจ้าหน้าปฏิบัติงานในห้องปฏิบัติการนี้
                  ข้อกำหนดข้อหนึ่งข้อใดในข้อกำหนดและเงื่อนไขการใช้บริการสำหรับเจ้าหน้าปฏิบัติงานในห้องปฏิบัติการจะตกเป็นโมฆะ
                  หรือไม่มีอำนาจบังคับใช้ได้ด้วยเหตุผลใดก็ตาม หรือภายในขอบเขตใด
                  ๆ การเป็นโมฆะหรือการไม่มีอำนาจบังคับใช้นั้นจะไม่มีผลต่อ
                  หรือส่งผลให้ข้อกำหนดที่เหลือของข้อกำหนดและเงื่อนไขการใช้บริการสำหรับเจ้าหน้าปฏิบัติงานในห้องปฏิบัติการ
                  นี้เป็นโมฆะ หรือไม่มีอำนาจบังคับใช้ด้วย ไม่ว่าในกรณีใดก็ตาม
                  และการบังคับใช้ข้อกำหนดดังกล่าวจะต้องมีผลใช้ภายในขอบเขตที่ชอบโดยกฎหมาย
                  รวมถึงจะไม่มีการละเว้นสิทธิ์ของผู้ให้บริการระบบฯ
                  หรือบุคคลที่สามผู้รับผลประโยชน์จากข้อกำหนด
                  และเงื่อนไขการใช้บริการสำหรับเจ้าหน้าปฏิบัติงานในห้องปฏิบัติการ
                  ฉบับนี้
                </div>
                <div>
                  ตามที่ใช้ในข้อกำหนดเหล่านี้ คำว่า “รวม” และ “รวมถึง” และ
                  การหลากคำข้างต้น จะถือว่ามีคำว่า “ไม่มีข้อจำกัด” ตามมาด้วย
                </div>
                <div>
                  <br />
                </div>
                <div>กฎหมายที่บังคับและขอบเขตอำนาจ</div>
                <div>
                  ข้อกำหนดและเงื่อนไขการใช้บริการสำหรับเจ้าหน้าปฏิบัติงานในห้องปฏิบัติการ
                  นี้
                  (รวมถึงข้อพิพาท/การเรียกร้องความเสียหายที่ไม่ได้ระบุในข้อกำหนดและเงื่อนไขฯ
                  ซึ่งเกิดจากหรือเกี่ยวเนื่องกับข้อกำหนดและเงื่อนไขการใช้บริการสำหรับบุคลากร
                  ทางการแพทย์)
                  จะใช้บังคับกับความสัมพันธ์ระหว่างผู้ใช้บริการและผู้ให้บริการระบบฯ
                  โดยจะอยู่ภายใต้การบังคับใช้กฎหมายของประเทศไทย
                  ผู้ใช้บริการตกลงที่จะระงับข้อพิพาทนอกศาลโดยติดต่อผู้ให้บริการระบบฯ
                  หากข้อพิพาทดังกล่าวไม่สามารถยุติได้
                  ผู้ใช้บริการถึงจะสามารถนําคดีขึ้นสู่ศาลได้ นอกจากนั้น
                  ผู้ใช้บริการและผู้ให้บริการระบบฯ เห็นชอบให้การระงับข้อพิพาท
                  การเรียกร้องความเสียหาย
                  หรือความขัดแย้งที่อาจเกิดขึ้นจากบริการฯ
                  หรือเกิดขึ้นระหว่างผู้ใช้บริการและผู้ให้บริการระบบฯ
                  ที่เกี่ยวกับบริการฯ อยู่ภายใต้เขตอำนาจของศาลประเทศไทย
                </div>
                <div>
                  <br />
                </div>
                <div>การแจ้งเตือนและการติดต่อ</div>
                <div>
                  เมื่อผู้ให้บริการระบบฯ
                  มีความประสงค์ที่จะแจ้งเตือนหรือติดต่อผู้ใช้บริการเกี่ยวกับการบริการฯ
                  ผู้ให้บริการระบบฯ
                  อาจทำการติดต่อไปยังผู้ใช้บริการโดยตรงหรือผ่านหน่วยงานฯ
                  ตามที่เห็นสมควรในแต่ละกรณี เช่นเดียวกัน
                  หากผู้ใช้บริการมีความประสงค์ที่จะแจ้งปัญหาหรือติดต่อ
                  เกี่ยวกับการบริการฯ สามารถติดต่อผู้ให้บริการระบบฯ
                  ตามข้อมูลที่ปรากฎตามด้านล่างนี้
                </div>
                <div>
                  <br />
                </div>
                <div>ช่องทางการติดต่อ</div>
                <div>
                  หากเจ้าหน้าปฏิบัติงานในห้องปฏิบัติการประสงค์จะติดต่อ
                  หรือมีข้อสงสัย
                  หรือต้องการสอบถามข้อมูลเกี่ยวกับรายละเอียดการเก็บรวบรวม ใช้
                  และ/หรือเปิดเผยข้อมูลส่วนบุคคล
                  รวมถึงสิทธิของเจ้าหน้าปฏิบัติงานในห้องปฏิบัติการนโยบายฉบับนี้หรือต้องการยกเลิกการให้ความยินยอมในการเก็บรวบรวม
                  ใช้ และ/หรือเปิดเผยข้อมูลส่วนบุคคล
                  หรือกรณีที่พบว่ามีการใช้ข้อมูลส่วนบุคคลของบุคลาการทางการแพทย์ไปในทางที่ไม่ชอบ
                  เจ้าหน้าปฏิบัติงานในห้องปฏิบัติการสามารถติดต่อสำนักงานทางช่องทางดังต่อไปนี้
                </div>
                <div>
                  <br />
                </div>
                <div>
                  สถาบันชีววิทยาศาสตร์ทางการแพทย์ กรมวิทยาศาสตร์การแพทย์
                </div>
                <div>
                  สถานที่ติดต่อ: 88/7 ซอยบำราศนราดูร ถ.ติวานนท์ ต.ตลาดขวัญ
                  อ.เมือง จ.นนทบุรี 11000
                </div>
                <div>เวลาทำการปกติ: วันจันทร์ถึงศุกร์ เวลา 8:30 – 16:30 น.</div>
                <div>เว็บไซต์: https://phukphan.dmsc.moph.go.th/</div>
                <div>
                  <br />
                </div>
                <div>ติดต่อสอบถาม :</div>
                <div>นางสาวพรนภัส อยู่นุช</div>
                <div>อีเมลล์: pornnapat.y@dmsc.mail.go.th</div>
                <div>หมายเลขโทรศัพท์: 0-2589-9850 ถึง 8 ต่อ 98096</div>
                <div>นายพนาพัฒน์ ไพเราะ</div>
                <div>อีเมลล์: panapat.p@dmsc.mail.go.th</div>
                <div>หมายเลขโทรศัพท์: 0-2951-0000 ต่อ 99394</div>
                <div>นางสาวนภัชชา ถาวงศ์</div>
                <div>อีเมลล์: penpitcha.t@dmsc.mail.go.th</div>
                <div>หมายเลขโทรศัพท์: 0-2589-9850 ถึง 8 ต่อ 98096</div>
                <div>นายอาคม สาลี</div>
                <div>อีเมลล์: arkom.s@dmsc.mail.go.th</div>
                <div>หมายเลขโทรศัพท์: 0-2951-0000 ต่อ 99460</div>
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
}
